const MAX_PRODUCTS = 10;
class SinglePersonalization extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.productID = this.dataset.productId;
        this.variantID = this.dataset.initialVariantId;
        this.inventoriesVariantQuantity = window.inventories?.[this.productID]?.[this.variantID] || {};
        this.availableVariantQuantity = window.inventories?.[this.productID]?.[this.variantID]?.quantity || 0;
        this.productQuantityValue = 1;

        this.quantityContainer = this.querySelector(".quantity-change__container");
        if (this.quantityContainer) {
            this.setupQuantityChange();
        }
        
        if (this.classList.contains('bulk-personalization__container')) {
            this.setupBulkQuantitySelectors();
        }
        
        this.addToCartBtn = this.querySelector("button[data-action=add-to-cart]");
        this.singleATCLabel = this.addToCartBtn?.textContent;
        
        this.isBulkPersonalization = this.classList.contains('bulk-personalization__container');
        
        if (this.isBulkPersonalization) {
            this.setupBulkQuantitySelectors();
        }
        
        if (this.addToCartBtn) this.updateATCButton(this.addToCartBtn, this.singleATCLabel);
        
        if (!this.isBulkPersonalization && this.addToCartBtn) {
            this.addToCartBtn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.initialATCLabel = this.addToCartBtn.textContent;
                this.addToCart(this.addToCartBtn);
            });
        }

        this.personalizedProductContainer = document.body.querySelector("product-info");
        if (FoxTheme?.pubsub) {
            FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
                this.updateSinglePersonalization(data.variantId);
            });
        }
        
        this.personalizationModal = this.closest('personalize-modal-container') || this.parentElement?.parentElement?.parentElement;

        this.singleProductCustomizer = this.querySelector(".product-personalization__container");
        this.addEventListener("SingleCustomizerChange", () => {
            const { icon, "personalized-text": personalizedText } = this.singleProductCustomizer?.savedCustomizationData || {};
            const hasCustomization = (icon?.trim() !== "") || (personalizedText?.trim() !== "");
            if (this.availableVariantQuantity > 0 && this.addToCartBtn) {
                this.addToCartBtn.toggleAttribute("disabled", !hasCustomization);
            }
        });

        document.addEventListener("cart:JSONReady", (e) => {
            this.updateVariantQuantity();
        });
    }

    updateVariantQuantity() {
        this.cartVariantQuantity = (window.cartDataJSON?.items || [])
            .filter(item => Number(item.variant_id) === Number(this.variantID))
            .reduce((total, item) => total + item.quantity, 0);
        this.inventoriesVariantQuantity = window.inventories?.[this.productID]?.[this.variantID] || {};
        this.availableVariantQuantity = Math.max(0, parseInt(this.inventoriesVariantQuantity.quantity - this.cartVariantQuantity, 10));
        
        if (this.classList.contains('bulk-personalization__container')) {
            this.updateQuantityDropdownItems();
        }
        
        if (this.availableProductElement) {
            this.availableProductElement.textContent = ` Available product quantity: ${this.availableVariantQuantity}`;
        }
    }

    // In SinglePersonalization class (parent class)
    updateATCButton(ATCButton, buttonLabel) {
        if (!ATCButton) return;
        
        // Store original text if not already stored
        if (!ATCButton.dataset.originalText) {
            ATCButton.dataset.originalText = buttonLabel;
        }
        
        ATCButton.textContent = this.availableVariantQuantity < 1 ? "Out of stock" : ATCButton.dataset.originalText;        
        
        if (this.availableVariantQuantity < 1) {
            ATCButton.classList.add('bs-cursor-not-allowed');
            ATCButton.disabled = true;
            ATCButton.setAttribute('disabled', 'disabled');
            ATCButton.style.opacity = '0.5';
            ATCButton.style.cursor = 'not-allowed';
            ATCButton.style.pointerEvents = 'none';
        } else {
            ATCButton.classList.remove('bs-cursor-not-allowed');
            ATCButton.disabled = false;
            ATCButton.removeAttribute('disabled');
            ATCButton.style.opacity = '';
            ATCButton.style.cursor = '';
            ATCButton.style.pointerEvents = '';
        }
    }

    updateSinglePersonalization(variant_id) {
        this.variantID = variant_id;
        this.updateVariantQuantity();
        if (this.addToCartBtn) this.updateATCButton(this.addToCartBtn, this.singleATCLabel);
        
        if (this.personalizationModal) {
            const outerButton = this.personalizationModal.querySelector('.products-personalization-button');
            if (outerButton) {
                const btnText = outerButton.querySelector('.btn__text');
                const icon = outerButton.querySelector('.personalization-icon');
                
                if (!outerButton.dataset.originalText && btnText) {
                    outerButton.dataset.originalText = btnText.textContent.trim();
                }
                
                if (this.availableVariantQuantity < 1) {
                    if (btnText) btnText.textContent = "Sold out";
                    if (icon) icon.style.display = "none";
                    outerButton.classList.add('bs-cursor-not-allowed');
                    outerButton.disabled = true;
                    outerButton.setAttribute('disabled', 'disabled');
                    outerButton.style.opacity = '0.5';
                    outerButton.style.cursor = 'not-allowed';
                    outerButton.style.pointerEvents = 'none';
                } else {
                    if (btnText) btnText.textContent = outerButton.dataset.originalText;
                    if (icon) icon.style.display = "";
                    outerButton.classList.remove('bs-cursor-not-allowed');
                    outerButton.disabled = false;
                    outerButton.removeAttribute('disabled');
                    outerButton.style.opacity = '';
                    outerButton.style.cursor = '';
                    outerButton.style.pointerEvents = '';
                }
            }
        }
    }

    // Replace the existing debounce method in BulkPersonalization with:
    debounce(func, delay) {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    }
    
    setupAddToCartEvent(ATCbtn) {
        if (!ATCbtn || !this.isBulkPersonalization) return;
        
        ATCbtn.replaceWith(ATCbtn.cloneNode(true));
        const newATCbtn = this.querySelector('button[data-action="bulk-add-to-cart"]');
        
        newATCbtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.initialATCLabel = newATCbtn.textContent;            
            this.addToCart(newATCbtn);
        });
    }
    setupQuantityChange() {
        if (!this.quantityContainer) return;
        
        const allChangeButton = this.quantityContainer.querySelectorAll("button[data-action=change]");
        this.productQuantity = this.quantityContainer.querySelector("input#productQuantity");
        
        if (!this.productQuantity) return;
        
        this.productQuantity.addEventListener("change", () => {
            let quantity = Math.max(1, Math.min(this.availableVariantQuantity, +this.productQuantity.value || 1));
            this.productQuantity.value = quantity;
            this.updateAllQuantitySelectors(quantity);
        });
        
        allChangeButton.forEach(btn => {
            btn.addEventListener("click", () => {
                let newQuantity;
                if (btn.dataset.role === "plus") {
                    newQuantity = Math.min(this.availableVariantQuantity, (+this.productQuantity.value || 0) + 1);
                }
                if (btn.dataset.role === "minus") {
                    newQuantity = Math.max((+this.productQuantity.value || 0) - 1, 1);
                }
                
                if (newQuantity !== undefined) {
                    this.productQuantity.value = newQuantity;
                    this.updateAllQuantitySelectors(newQuantity);
                }
            });
        });
    }

    updateAllQuantitySelectors(quantity) {
        const allQuantityInputs = this.querySelectorAll('.bulk-quantity-input');
        allQuantityInputs.forEach(input => {
            input.value = quantity;
        });
        
        this.productQuantityValue = quantity;
    }

    setupBulkQuantitySelectors() {
        const desktopQuantityContainer = this.querySelector('.desktop-only .bulk-quantity-selector');
        if (desktopQuantityContainer) {
            this.setupSingleQuantitySelector(desktopQuantityContainer);
        }
        
        const mobileQuantityContainers = this.querySelectorAll('.mobile-only .bulk-quantity-selector');
        mobileQuantityContainers.forEach(container => {
            this.setupSingleQuantitySelector(container);
        });
    }

    setupSingleQuantitySelector(container) {
        const quantityInput = container.querySelector('.bulk-quantity-input');
        const minusBtn = container.querySelector('[data-role="minus"]');
        const plusBtn = container.querySelector('[data-role="plus"]');
        
        if (!quantityInput || !minusBtn || !plusBtn) return;
        
        const product = container.closest('product-customizer');
        if (!product) return;
        
        // Clone elements to remove any existing event listeners
        const newQuantityInput = quantityInput.cloneNode(true);
        const newMinusBtn = minusBtn.cloneNode(true);
        const newPlusBtn = plusBtn.cloneNode(true);
        
        // Replace original elements with clones
        quantityInput.replaceWith(newQuantityInput);
        minusBtn.replaceWith(newMinusBtn);
        plusBtn.replaceWith(newPlusBtn);
        
        // Get current quantity and set initial value
        const currentQuantity = this.getProductQuantity(product);
        newQuantityInput.value = currentQuantity;
        newQuantityInput.max = this.availableVariantQuantity;
        
        // Helper function for button states
        const updateButtonStates = () => {
            const currentValue = parseInt(newQuantityInput.value) || 1;
            
            // Minus button
            if (currentValue <= 1) {
                newMinusBtn.disabled = true;
                newMinusBtn.setAttribute('disabled', 'disabled');
            } else {
                newMinusBtn.disabled = false;
                newMinusBtn.removeAttribute('disabled');
            }
            
            // Plus button
            if (currentValue >= this.availableVariantQuantity) {
                newPlusBtn.disabled = true;
                newPlusBtn.setAttribute('disabled', 'disabled');
            } else {
                newPlusBtn.disabled = false;
                newPlusBtn.removeAttribute('disabled');
            }
        };
        
        // Initialize button states
        updateButtonStates();
        
        // Input change event
        newQuantityInput.addEventListener("change", () => {
            let quantity = Math.max(1, Math.min(this.availableVariantQuantity, +newQuantityInput.value || 1));
            newQuantityInput.value = quantity;
            this.setProductQuantity(product, quantity);
            updateButtonStates();
        });
        
        // Input input event for real-time updates
        newQuantityInput.addEventListener("input", () => {
            let quantity = Math.max(1, Math.min(this.availableVariantQuantity, +newQuantityInput.value || 1));
            updateButtonStates();
        });
        
        // Minus button click - FIXED: Simple decrement
        newMinusBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            let currentValue = parseInt(newQuantityInput.value) || 1;
            let newQuantity = currentValue - 1; // Simple subtraction
            
            if (newQuantity < 1) newQuantity = 1;
            
            newQuantityInput.value = newQuantity;
            this.setProductQuantity(product, newQuantity);
            updateButtonStates();
            
            newQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        // Plus button click - FIXED: Simple increment
        newPlusBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            let currentValue = parseInt(newQuantityInput.value) || 1;
            let newQuantity = currentValue + 1; // Simple addition
            
            if (newQuantity > this.availableVariantQuantity) {
                newQuantity = this.availableVariantQuantity;
            }
            
            newQuantityInput.value = newQuantity;
            this.setProductQuantity(product, newQuantity);
            updateButtonStates();
            
            newQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
    
    // Add this helper method to update button states
    updateQuantityButtonStates(minusBtn, plusBtn, currentQuantity) {
        if (!minusBtn || !plusBtn) return;
        
        // Update minus button
        if (currentQuantity <= 1) {
            minusBtn.disabled = true;
            minusBtn.setAttribute('disabled', 'disabled');
        } else {
            minusBtn.disabled = false;
            minusBtn.removeAttribute('disabled');
        }
        
        // Update plus button
        if (currentQuantity >= this.availableVariantQuantity) {
            plusBtn.disabled = true;
            plusBtn.setAttribute('disabled', 'disabled');
        } else {
            plusBtn.disabled = false;
            plusBtn.removeAttribute('disabled');
        }
    }
    
    getAllCustomizationData(isBulkPersonalization) {
        const allProducts = this.querySelectorAll("product-customizer");
        const flattenedProperties = {
            "personalization type": isBulkPersonalization ? "bulk personalization" : "single personalization"
        };
        let productCount = 0;

        allProducts.forEach((product) => {
            if (product.personalizationProperties) {
                const hasValidProperty = Object.values(product.personalizationProperties).some(value => value);
                if (hasValidProperty) {
                    productCount++;
                    const productKey = `product${productCount}`;
                    Object.entries(product.personalizationProperties).forEach(([key, value]) => {
                        if (value) {
                            const formattedKey = key.replace(/-/g, ' ');
                            flattenedProperties[`${productKey} ${formattedKey}`] = value;
                        }
                    });
                }
            }
        });

        return flattenedProperties;
    }
    
    addToCart(btn) {
        if (!btn) return;
        
        if (!this.isBulkPersonalization) {
            return;
        }
        
        const isBulkPersonalization = btn.dataset.action === "bulk-add-to-cart" ? true : false;
        const allCustomizationData = this.getAllCustomizationData(isBulkPersonalization);
        const variantId = this.variantID;
        
        let productQuantity;
        if (btn.dataset.action === "bulk-add-to-cart") {
            productQuantity = this.productQuantityValue || 1;
        } else if (btn.dataset.action === "file-add-to-cart") {
            productQuantity = this.bulkFileQuantity || 1;
        } else {
            productQuantity = this.productQuantity?.value || 1;
        }
        
        this.sendToCart(variantId, productQuantity, allCustomizationData, btn);
    }

    async sendToCart(variantId, quantity = 1, properties = {}, btn) {
        if (!btn) return;
        
        // Validate quantity before sending to cart
        quantity = Math.max(1, Math.min(this.availableVariantQuantity, parseInt(quantity) || 1));
        
        // Check if trying to add more than available
        if (parseInt(quantity) > this.availableVariantQuantity) {
            document.body.querySelector('milton-toast')?.showErrorToast(`Failed to add item to cart: Adding more products than available`);
            
            // Re-enable the button if it was disabled
            btn.textContent = this.initialATCLabel;
            if (btn.dataset.action === "bulk-add-to-cart") {
                this.allBulkATCBtns?.forEach(bulkBtn => bulkBtn.removeAttribute("disabled"));
            } else {
                btn.removeAttribute("disabled");
            }
            return;
        }
        
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', {
                bubbles: true,
                detail: { sections: sectionsToBundle }
            })
        );
    
        const config = FoxTheme?.utils?.fetchConfig('javascript') || {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
    
        const formData = new FormData();
        formData.append('items[0][id]', variantId);
        formData.append('items[0][quantity]', quantity);
    
        Object.entries(properties || {}).forEach(([key, value]) => {
            formData.append(`items[0][properties][${key}]`, value);
        });
    
        formData.append('sections', sectionsToBundle);
        formData.append('sections_url', window.location.pathname);
    
        config.body = formData;
    
        try {
            const response = await (await fetch(FoxTheme?.routes?.cart_add_url || '/cart/add.js', config)).json();
    
            if (response.status) {
                // This should only happen for other errors, not quantity issues
                document.body.querySelector('milton-toast')?.showErrorToast(`Failed to add item to cart: ${response.description}`);
                throw new Error(`Failed to add item to cart: ${response.description}`);
            }
    
            setTimeout(() => {
                if (this.personalizationModal?.toggleModal) {
                    this.personalizationModal.toggleModal();
                }
            }, 300);
    
            document.body.querySelector('milton-toast')?.showSuccessToast(`Your product is added to cart`);
    
            btn.textContent = "Added";
            if (btn.dataset.action === "bulk-add-to-cart") {
                this.allBulkATCBtns?.forEach(bulkBtn => bulkBtn.setAttribute("disabled", true));
            } else {
                btn.setAttribute("disabled", true);
            }
    
            this.querySelectorAll("product-customizer").forEach(customizer => {
                if (customizer.resetCustomizer) {
                    customizer.resetCustomizer();
                }
            });
    
            const cartJson = await (await fetch(FoxTheme?.routes?.cart_url || '/cart.js', { ...config })).json();
            cartJson.sections = response.sections;
    
            if (FoxTheme?.pubsub) {
                await FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            }
    
            this.updateVariantQuantity();
            if (typeof this.updateBulkPersonalization === "function") {
                this.updateBulkPersonalization();
            }
        } catch (error) {
            console.error("Add to Cart Error:", error);
            
            // Only show general error toast if it's not already shown
            if (!error.message.includes("Adding more products than available")) {
                document.body.querySelector('milton-toast')?.showErrorToast(`Failed to add item to cart. Please try again.`);
            }
        } finally {
            setTimeout(() => {
                btn.textContent = this.initialATCLabel;
                document.querySelector("bulk-personalization")?.resetBulkPersonalization();
            }, 500);
        }
    }
}
customElements.define("single-personalization", SinglePersonalization);
class BulkPersonalization extends SinglePersonalization {
    constructor() {
        super();
        this._scrollHandler = null;
        this._nextButtonClickHandler = null;
        this._mobileTabClickHandler = null;
        this._desktopNextButtonClickHandler = null;
        this.blankBottleImage = null;
        this._dropdownHandlerBound = null;

        // ADD THESE
        this._bulkOptionHandlers = new Map();
        this._optionUpdateBlocked = false;
    }

    connectedCallback() {
        super.connectedCallback();
        this.setupUploadFileButton();
        this.parsedCSVData = [];
        this._files = [];
        this.products = [];
        this.bulkProductQuantity = 1;
        this.bulkFileQuantity = 0;
        this.currentProductIndex = 0;
        this.isPreviewMode = false;
        this.isProcessingNext = false;

        this.allBulkATCBtns = [];
        
        this.bulkPreviewContainer = this.querySelector(".bulk-preview-container");
        this.previewProductsGrid = this.querySelector(".preview-products-grid");
        this.editAllBtn = this.querySelector(".edit-all-btn");
        this.backToEditBtn = this.querySelector(".back-to-edit");
        this.addAllToCartBtn = this.querySelector(".add-all-to-cart");

        this.previewTemplate = this.querySelector("#product-preview--template");

        if (FoxTheme?.pubsub) {
            FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
                // Update variant ID
                this.variantID = data.variantId;
                
                // Get the new image URL for this variant
                this.updateProductImageForVariant(data.variantId);
                
                // Update bulk personalization with the new variant
                this.updateVariantForBulk(data.variantId);
                
                // Also update quantity and UI
                this.updateBulkPersonalization();
            });
        }
        this.setupVerificationButton();
        this.initializeCustomizationRegionData();
        this.addEventListener("BulkCustomizerChange", () => {
            this.validateAllCustomizers();
            this.updateAllProductsCompletionStatus();
        });
        setTimeout(() => {
            this.takeFullControlOfProductCustomizers();
        }, 1000);
        setTimeout(() => {
            this.storeBlankBottleImage();
            
            this.takeFullControlOfProductCustomizers();
            this.setupBulkCustomizerValidation();
            this.validateAllCustomizers(); 
            
            // Force initial canvas rendering with retry
            this.ensureInitialCanvasRender();
            
            // CRITICAL: Refresh all option classes to ensure they're applied
            setTimeout(() => {
                this.refreshAllOptionClasses();
            }, 500);
            
        }, 2500);
        this.newCustomizerTemplate = this.querySelector("#product-customizer--template");
        this.tabTemplate = this.querySelector("#product-tab--template");
        this.productsContainer = this.querySelector(".bulk-products__container");

        const oldControlsWrapper = this.querySelector(".products-controls__wrapper");
        if (oldControlsWrapper) {
            oldControlsWrapper.remove();
        }

        this.handleQuantityDropdownEvents();
        this.setupBackToManualButton();

        this.bulkFileATCButton = this.querySelector("button[data-action=file-add-to-cart]");
        this.bulkFileATCButtonLabel = this.bulkFileATCButton?.textContent;
        this.bulkFileATCButton?.addEventListener("click", (e) => this.handleBulkFileATC(e));

        this.progressContainer = this.querySelector(".bulk-progress");
        this.steps = this.progressContainer?.querySelectorAll(".progress__item") || [];

        this.availableProductElement = this.querySelector(".product-availablity__container");
        this.bulkSheetContainer = this.querySelector("bulk-upload");
        this._fakeInput = this.bulkSheetContainer?.querySelector('[js-fake-file-input]');
        this._realInput = this.bulkSheetContainer?.querySelector('[js-real-file-input]');
        this._chipContainer = this.bulkSheetContainer?.querySelector('[js-chip-container]');
        this._noFile = this.bulkSheetContainer?.querySelector('[js-no-file]');
        this._removeFilesButton = this.bulkSheetContainer?.querySelector('[js-remove-files]');
        this.fileProductQuantity = this.querySelector(".file-product--quantity");
        
        this.addProduct();
        
        this.allBulkATCBtns = this.querySelectorAll("button[data-action=bulk-add-to-cart]");
        
        setTimeout(() => {
            this.setupProductPreviewButtons();
        }, 100);
        setTimeout(() => {
            this.showManualBulkUI();
        }, 100);

        this.bulkProductsWrapper = this.querySelector(".bulk-products__wrapper");
        this.addFileEvents();

        this.CSVDownloadBtn = this.querySelector("#downloadBtn");
        this.CSVDownloadBtnLabel = this.querySelector("#downloadBtnText");
        this.handleCSVDownloadBtnEvent();

        this.bulkModalCloseBtn = this.querySelectorAll(".bulk-personalization-close--button");
        this.bulkModalCloseBtn.forEach(Btn => this.setupBulkCloseEvent(Btn));

        this.backToProductBtn = this.querySelector(".back-to-product");
        this.backToProductBtn?.addEventListener("click", () => {
            this.resetBulkPersonalization();
            if (this.lastActiveTab) {
                this.switchProduct(this.lastActiveTab);
            }
        });

        this.allModalCLoseBtn = document.body.querySelectorAll("modal-close");
        this.allModalCLoseBtn.forEach(Btn => {
            Btn.addEventListener("click", () => {
                this.resetBulkPersonalization();
            });
        });

        this.allActionsWrapper = this.querySelectorAll(".personalized-actions__wrapper");
        this.allActionsWrapper.forEach(wrapper => {
            this.setupBulkActionWrapperEvent(wrapper);
        });

        this.addEventListener("BulkCustomizerChange", () => {
            this.validateAllCustomizers();
        });

        this.bulkUploadPreviewContainer = this.querySelector(".bulk-upload-preview-container");
        this.previewUploadedBtn = this.querySelector(".preview-uploaded-products-btn");
        this.backToUploadBtn = this.querySelector(".back-to-upload");
        this.addUploadedToCartBtn = this.querySelector(".add-uploaded-to-cart");
        this.uploadedProductPreviewTemplate = this.querySelector("#uploaded-product-preview--template");
        
        this.previewUploadedBtn?.addEventListener("click", () => {
            this.showUploadedProductsPreview();
        });
        
        this.backToUploadBtn?.addEventListener("click", () => {
            this.backToUploadView();
        });
        
        this.addUploadedToCartBtn?.addEventListener("click", (e) => {
            this.handleBulkFileATC(e);
        });

        if (this.editAllBtn) {
            this.editAllBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.exitPreviewMode();
            });
        }

        if (this.backToEditBtn) {
            this.backToEditBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.exitPreviewMode();
            });
        }

        if (this.addAllToCartBtn) {
            this.addAllToCartBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const allProductsHaveCustomization = this.products.every(productObj => {
                    const { icon, "personalized-text": personalizedText } = productObj.product?.savedCustomizationData || {};
                    return (icon?.trim() !== "") || (personalizedText?.trim() !== "");
                });
                
                if (!allProductsHaveCustomization) {
                    document.body.querySelector('milton-toast')?.showErrorToast(`Some products are not customized. Please complete all customizations before adding to cart.`);
                    return;
                }
                
                this.addAllProductsToCart(e.target);
            });
        }

        this.setupNextButtonHandler();
        this.setupMobileTabEvents();
        this.setupDesktopNextButtonHandler();

        this.storeBlankBottleImage();

        setTimeout(() => {
            this.setupAllQuantitySelectors();
        }, 100);

        this.updateBulkPersonalization();
        this.updateQuantityDropdownItems();
        
        document.addEventListener("cart:JSONReady", (e) => {
            this.updateVariantQuantity();
        });
        setTimeout(() => {
            this.products.forEach(productObj => {
                this.setupBulkProductValidation(productObj.product);
            });
            this.validateAllCustomizers(); 
        }, 1000);
        setTimeout(() => {
            this.storeBlankBottleImage();
        }, 2000); // Increased delay to ensure everything is loaded
        
        setTimeout(() => {
            this.setupBulkCustomizerValidation();
            this.validateAllCustomizers(); 
            
            // Enhanced initial canvas rendering with retry
            this.ensureInitialCanvasRender();
            
            // Retry image storage if it failed
            setTimeout(() => {
                if (!this.blankBottleImage || !this.blankBottleImage.complete) {
                    this.storeBlankBottleImage();
                }
            }, 3000);
            
        }, 2500);
        setTimeout(() => {
            this.storeBlankBottleImage();
        }, 1500);
        
        // Multiple attempts to ensure we get the image
        setTimeout(() => {
            if (!this.blankBottleImage || !this.blankBottleImage.complete) {
                this.storeBlankBottleImage();
            }
        }, 3500);
        
        setTimeout(() => {
            if (!this.blankBottleImage || !this.blankBottleImage.complete) {
                this.createRealisticBottleImage();
            }
            
            // Setup other functionality
            this.setupBulkCustomizerValidation();
            this.validateAllCustomizers(); 
            this.ensureInitialCanvasRender();
        }, 5000);
        setTimeout(() => {
            this.storeBlankBottleImage();
            this.setupBulkCustomizerValidation();
            this.validateAllCustomizers();
            
            // Force initial render after a short delay
            setTimeout(() => {
                this.ensureInitialCanvasRender();
            }, 1000);
        }, 500);
        setTimeout(() => {
            this.storeBlankBottleImage();
            this.setupBulkCustomizerValidation();
            this.validateAllCustomizers();
            
            // Force initial render after a short delay
            setTimeout(() => {
                this.ensureInitialCanvasRender();
            }, 1000);
        }, 500);
        setTimeout(() => {
            this.storeBlankBottleImage();
        }, 1000);
        
        // Retry bottle image capture if needed
        setTimeout(() => {
            if (!this.blankBottleImage || !this.blankBottleImage.complete) {
                this.storeBlankBottleImage();
            }
        }, 3000);
        
        // Final fallback
        setTimeout(() => {
            if (!this.blankBottleImage || !this.blankBottleImage.complete) {                
                this.createEmergencyBottleImage();
            }
        }, 5000);
        
        setTimeout(() => {
            this.startOptionClassMonitor();
        }, 2000);
        setTimeout(() => {
            this.ensureFirstProductInitialization();
        }, 500);

        // Also add this to handle any dynamic changes
        this.setupFirstProductMonitor();
        setTimeout(() => {
            this.showManualBulkUI();
            // Initialize dropdown to show "Select Quantity" but have 1 product
            this.initializeDropdownWithPlaceholder();
        }, 100);
    }
    ensureFirstProductInitialization() {
        if (this.products.length === 0) return;
        
        const firstProduct = this.products[0].product;
        if (!firstProduct) return;        
        // Force re-setup of option handlers for first product
        this.setupBulkOptionHandlers(firstProduct);
        
        // Ensure font style is selected
        this.ensureFontStyleSelection(firstProduct);
        
        // Force application of option classes
        this.immediatelyApplyOptionClasses(firstProduct);
        
        // Ensure canvas is rendered
        this.forceBulkCanvasUpdateWithText(firstProduct);
    }
    setupFirstProductMonitor() {
        // Check first product state every second for the first 5 seconds
        let checkCount = 0;
        const maxChecks = 5;
        
        const checkFirstProduct = () => {
            if (checkCount >= maxChecks) return;
            
            if (this.products.length > 0) {
                const firstProduct = this.products[0].product;
                if (firstProduct) {
                    // Check if font style is selected
                    const hasFontStyle = firstProduct.savedCustomizationData?.["font-style"] && 
                                       firstProduct.savedCustomizationData["font-style"].trim() !== "";
                    
                    if (!hasFontStyle) {
                        this.ensureFontStyleSelection(firstProduct);
                    }
                    
                    // Check if option classes are applied
                    this.ensureOptionClassesAreApplied(firstProduct);
                }
            }
            
            checkCount++;
            setTimeout(checkFirstProduct, 1000);
        };
        
        setTimeout(checkFirstProduct, 1000);
    }
    startOptionClassMonitor() {
        // Monitor option classes every second to ensure they stay applied
        this.optionStateInterval = setInterval(() => {
            this.products.forEach(productObj => {
                const product = productObj.product;
                if (product && product.savedCustomizationData) {
                    this.ensureOptionClassesAreApplied(product);
                }
            });
        }, 300);
    }
    immediatelyApplyOptionClasses(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const data = product.savedCustomizationData;
        
        // Apply font-style class immediately
        if (data["font-style"] && data["font-style"].trim() !== "") {
            const fontStyleInputs = product.querySelectorAll('input[name="font-style"]');
            let found = false;
            fontStyleInputs.forEach(input => {
                if (input.dataset.optionData === data["font-style"]) {
                    if (!input.checked) {
                        input.checked = true;
                    }
                    const label = input.closest('label');
                    if (label && !label.classList.contains('font-style-option-selected')) {
                        label.classList.add('font-style-option-selected');
                    }
                    found = true;
                } else {
                    input.checked = false;
                    const label = input.closest('label');
                    if (label) {
                        label.classList.remove('font-style-option-selected');
                    }
                }
            });
        }
        
        // Apply font-pattern class immediately
        if (data["font-pattern"] && data["font-pattern"].trim() !== "") {
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            let found = false;
            fontPatternInputs.forEach(input => {
                if (input.dataset.optionData === data["font-pattern"]) {
                    if (!input.checked) {
                        input.checked = true;
                    }
                    const label = input.closest('label');
                    if (label && !label.classList.contains('font-pattern-option-selected')) {
                        label.classList.add('font-pattern-option-selected');
                    }
                    found = true;
                } else {
                    input.checked = false;
                    const label = input.closest('label');
                    if (label) {
                        label.classList.remove('font-pattern-option-selected');
                    }
                }
            });
            
            // If no font pattern found but data exists, clear all
            if (!found) {
                fontPatternInputs.forEach(input => {
                    input.checked = false;
                    const label = input.closest('label');
                    if (label) {
                        label.classList.remove('font-pattern-option-selected');
                    }
                });
            }
        } else {
            // Clear font pattern if no data
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            fontPatternInputs.forEach(input => {
                input.checked = false;
                const label = input.closest('label');
                if (label) {
                    label.classList.remove('font-pattern-option-selected');
                }
            });
        }
        
        // Apply icon class immediately
        if (data["icon"] && data["icon"].trim() !== "") {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            let found = false;
            iconInputs.forEach(input => {
                if (input.dataset.optionData === data["icon"]) {
                    if (!input.checked) {
                        input.checked = true;
                    }
                    const label = input.closest('label');
                    if (label && !label.classList.contains('icon-option-selected')) {
                        label.classList.add('icon-option-selected');
                    }
                    found = true;
                } else {
                    input.checked = false;
                    const label = input.closest('label');
                    if (label) {
                        label.classList.remove('icon-option-selected');
                    }
                }
            });
            
            // If no icon found but data exists, clear all
            if (!found) {
                iconInputs.forEach(input => {
                    input.checked = false;
                    const label = input.closest('label');
                    if (label) {
                        label.classList.remove('icon-option-selected');
                    }
                });
            }
        } else if (data["icon-label"] === "No icon") {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                const label = input.closest('label');
                const isNoIconInput = (input.value === "No icon" || input.dataset.optionLabel === "No icon");
                if (isNoIconInput) {
                    input.checked = true;
                    if (label) label.classList.add('icon-option-selected');
                } else {
                    input.checked = false;
                    if (label) label.classList.remove('icon-option-selected');
                }
            });
        } else {
            // Clear icon if no data
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                input.checked = false;
                const label = input.closest('label');
                if (label) {
                    label.classList.remove('icon-option-selected');
                }
            });
        }
    }
    // EMERGENCY FALLBACK: Always ensure we can draw something
    createEmergencyBottleImage() {
         
        const canvas = document.createElement('canvas');
        canvas.width = 3000;
        canvas.height = 3000;
        
        const ctx = canvas.getContext('2d');
        
        // Create a gradient background
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#e0e0e0');
        gradient.addColorStop(1, '#c0c0c0');
        
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Draw a simple bottle outline
        ctx.strokeStyle = '#999999';
        ctx.lineWidth = 20;
        ctx.strokeRect(canvas.width * 0.2, canvas.height * 0.1, canvas.width * 0.6, canvas.height * 0.8);
        
        // Add some text indicating it's a product
        ctx.fillStyle = '#666666';
        ctx.font = 'bold 200px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('PRODUCT', canvas.width / 2, canvas.height / 2);
        
        this.blankBottleImage = new Image();
        this.blankBottleImage.src = canvas.toDataURL('image/png');
        this.blankBottleImage.onload = () => {
            this.updateAllCanvasesWithStoredImage();
        };
    }

    initializeCustomizationRegionData() {
        // Try to get region data from the first product
        const firstProduct = this.products[0]?.product;
        if (firstProduct && firstProduct.customizationRegionData) {
            this.customizationRegionData = firstProduct.customizationRegionData;
        } else {
            // Create fallback region data
            this.getCustomizationRegionData(); 
        }
        
        // Ensure variantID is set
        if (!this.variantID) {
            // Try to get it from the first product or use a default
            this.variantID = firstProduct?.variantId || 'default';
        }
    }
    /*
    async addAllProductsToCart(btn) {
        if (!btn) return;
        
        this.initialATCLabel = btn.textContent;        
        
        try {
            const cartItems = this.products.map((productObj, index) => {
                const product = productObj.product;
                const customizationData = product.savedCustomizationData || {};
                const productQuantity = this.getProductQuantity(product) || 1;
                
                const properties = {
                    "personalization type": "bulk personalization"
                };
                
                if (customizationData['personalized-text']) {
                    properties[`product${index + 1} personalized text`] = customizationData['personalized-text'];
                }
                if (customizationData['font-style']) {
                    properties[`product${index + 1} font style`] = customizationData['font-style'];
                }
                // if (customizationData['font-pattern']) {
                //     properties[`product${index + 1} font pattern`] = customizationData['font-pattern'];
                // }
                if (customizationData['font-pattern-label'] && customizationData['font-pattern-label'].trim() !== "") {
                    // FIX: Send the label name instead of the URL
                    properties[`product${index + 1} font pattern`] = customizationData['font-pattern-label'];
                } else if (customizationData['font-pattern'] && customizationData['font-pattern'].trim() !== "") {
                    // Fallback: if no label but has URL, extract name from URL
                    properties[`product${index + 1} font pattern`] = this.extractNameFromUrl(customizationData['font-pattern']);
                }
                // FIX: Use icon-label instead of icon URL
                if (customizationData['icon'] && customizationData['icon'].trim() !== "" && customizationData['icon-label'] && customizationData['icon-label'].trim() !== "" && customizationData['icon-label'] !== "No icon") {
                    properties[`product${index + 1} icon`] = customizationData['icon-label']; // ← Sends the label
                } else if (customizationData['icon'] && customizationData['icon'].trim() !== "") {
                    // Fallback: if no label but has URL, extract name from URL
                    properties[`product${index + 1} icon`] = this.extractNameFromUrl(customizationData['icon']);
                }
                
                return {
                    id: this.variantID,
                    quantity: productQuantity,
                    properties: properties
                };
            });            
            await this.sendMultipleItemsToCart(cartItems, btn);
            
        } catch (error) {
            console.error("Add All to Cart Error:", error);
            btn.textContent = this.initialATCLabel;
        }
    }
    */
   async addAllProductsToCart(btn) {
        if (!btn) return;
        
        this.initialATCLabel = btn.textContent;        
        
        try {
            const cartItems = this.products.map((productObj, index) => {
                const product = productObj.product;
                const customizationData = product.savedCustomizationData || {};
                const productQuantity = this.getProductQuantity(product) || 1;
                
                const properties = {
                    "personalization type": "bulk personalization"
                };
                
                // INCLUDE TEXT ORIENTATION - THIS WAS MISSING
                if (customizationData['text-orientation']) {
                    properties[`product${index + 1} text orientation`] = customizationData['text-orientation'];
                } else {
                    // Default to horizontal if not set
                    properties[`product${index + 1} text orientation`] = "horizontal";
                }
                
                if (customizationData['personalized-text']) {
                    properties[`product${index + 1} personalized text`] = customizationData['personalized-text'];
                }
                if (customizationData['font-style']) {
                    properties[`product${index + 1} font style`] = customizationData['font-style'];
                }
                if (customizationData['font-pattern-label'] && customizationData['font-pattern-label'].trim() !== "") {
                    properties[`product${index + 1} font pattern`] = customizationData['font-pattern-label'];
                } else if (customizationData['font-pattern'] && customizationData['font-pattern'].trim() !== "") {
                    properties[`product${index + 1} font pattern`] = this.extractNameFromUrl(customizationData['font-pattern']);
                }
                if (customizationData['icon'] && customizationData['icon'].trim() !== "" && customizationData['icon-label'] && customizationData['icon-label'].trim() !== "" && customizationData['icon-label'] !== "No icon") {
                    properties[`product${index + 1} icon`] = customizationData['icon-label'];
                } else if (customizationData['icon'] && customizationData['icon'].trim() !== "") {
                    properties[`product${index + 1} icon`] = this.extractNameFromUrl(customizationData['icon']);
                }
                
                return {
                    id: this.variantID,
                    quantity: productQuantity,
                    properties: properties
                };
            });            
            await this.sendMultipleItemsToCart(cartItems, btn);
            
        } catch (error) {
            console.error("Add All to Cart Error:", error);
            btn.textContent = this.initialATCLabel;
        }
    }

    async sendMultipleItemsToCart(cartItems, btn) {
        // Validate total quantity before sending
        const totalQuantity = cartItems.reduce((sum, item) => sum + item.quantity, 0);
        
        if (totalQuantity > this.availableVariantQuantity) {
            document.body.querySelector('milton-toast')?.showErrorToast(`Failed to add items to cart: Adding more products than available`);
            
            // Re-enable button
            btn.textContent = this.initialATCLabel;
            this.allBulkATCBtns?.forEach(bulkBtn => bulkBtn.removeAttribute("disabled"));
            return;
        }
        
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', {
                bubbles: true,
                detail: { sections: sectionsToBundle }
            })
        );
    
        const config = FoxTheme?.utils?.fetchConfig('javascript') || {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
    
        const formData = new FormData();
        
        cartItems.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id);
            formData.append(`items[${index}][quantity]`, item.quantity);
            
            Object.entries(item.properties || {}).forEach(([key, value]) => {
                if (value && value.toString().trim() !== '') {
                    formData.append(`items[${index}][properties][${key}]`, value.toString().trim());
                }
            });
        });
    
        formData.append('sections', sectionsToBundle);
        formData.append('sections_url', window.location.pathname);
    
        config.body = formData;
    
        try {
            const response = await (await fetch(FoxTheme?.routes?.cart_add_url || '/cart/add.js', config)).json();
    
            if (response.status) {
                document.body.querySelector('milton-toast')?.showErrorToast(`Failed to add items to cart: ${response.description}`);
                throw new Error(`Failed to add items to cart: ${response.description}`);
            }
            this.forceCloseAllModals();
            // setTimeout(() => {
            //     if (this.personalizationModal?.toggleModal) {
            //         this.personalizationModal.toggleModal();
            //     }
            // }, 300);
    
            document.body.querySelector('milton-toast')?.showSuccessToast(`All products added to cart`);
    
            btn.textContent = "Added";
            this.allBulkATCBtns?.forEach(bulkBtn => bulkBtn.setAttribute("disabled", true));
    
            this.products.forEach(productObj => {
                if (productObj.product.resetCustomizer) {
                    productObj.product.resetCustomizer();
                }
            });
    
            const cartJson = await (await fetch(FoxTheme?.routes?.cart_url || '/cart.js', { ...config })).json();
            cartJson.sections = response.sections;
    
            if (FoxTheme?.pubsub) {
                await FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            }
    
            this.updateVariantQuantity();
            this.updateBulkPersonalization();
    
        } catch (error) {
            console.error("Add Multiple Items to Cart Error:", error);
            
            // Only show general error toast if it's not already shown
            if (!error.message.includes("Adding more products than available")) {
                document.body.querySelector('milton-toast')?.showErrorToast(`Failed to add items to cart. Please try again.`);
            }
            throw error;
        } finally {
            setTimeout(() => {
                btn.textContent = this.initialATCLabel;
            }, 500);
        }
    }
    forceCloseAllModals() {
        // Find ALL modal-viewer elements and remove active class
        const allModalViewers = document.querySelectorAll('modal-viewer');
        allModalViewers.forEach(modalViewer => {
            modalViewer.classList.remove('active');
        });
        
        // Also find any personalize-modal-container elements
        const allModalContainers = document.querySelectorAll('personalize-modal-container');
        allModalContainers.forEach(container => {
            const modalViewer = container.querySelector('modal-viewer');
            if (modalViewer) {
                modalViewer.classList.remove('active');
            }
        });
        
        // Find and click any modal-close buttons as a fallback
        const allCloseButtons = document.querySelectorAll('modal-close');
        allCloseButtons.forEach(btn => {
            try {
                btn.click();
            } catch (e) {
                // Ignore errors
            }
        });
        
        // Remove any modal overlays/backdrops
        const modalOverlays = document.querySelectorAll('.modal-overlay, .modal-backdrop');
        modalOverlays.forEach(overlay => {
            overlay.classList.remove('active');
        });
    }
    setupBackToManualButton() {
        const backToManualBtn = this.querySelector('.back-to-manual-group-personalize-btn');
        if (backToManualBtn) {
            backToManualBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.showManualBulkUI();
            });
        }
    }
    getProductQuantity(product) {
        if (!product) return 1;
        
        // First try to get from quantityData
        if (product.quantityData && product.quantityData.quantity) {
            return product.quantityData.quantity;
        }
        
        // Then try to get from input
        const quantityInput = product.querySelector('.bulk-quantity-input');
        if (quantityInput) {
            const value = parseInt(quantityInput.value);
            return isNaN(value) ? 1 : Math.max(1, value);
        }
        
        // Default
        return 1;
    }
    
    setProductQuantity(product, quantity) {
        if (!product) return;
        
        // Store in quantityData
        if (!product.quantityData) {
            product.quantityData = {};
        }
        product.quantityData.quantity = quantity;
        
        // Update all quantity inputs for this product
        const quantityInputs = product.querySelectorAll('.bulk-quantity-input');
        quantityInputs.forEach(input => {
            input.value = quantity;
        });
    }

    setupSingleQuantitySelector(container) {
        const quantityInput = container.querySelector('.bulk-quantity-input');
        const minusBtn = container.querySelector('[data-role="minus"]');
        const plusBtn = container.querySelector('[data-role="plus"]');
        
        if (!quantityInput || !minusBtn || !plusBtn) return;
        
        const product = container.closest('product-customizer');
        if (!product) return;
        
        // Clean existing event listeners by replacing elements
        const newQuantityInput = quantityInput.cloneNode(true);
        const newMinusBtn = minusBtn.cloneNode(true);
        const newPlusBtn = plusBtn.cloneNode(true);
        
        // Replace old elements with new ones
        quantityInput.replaceWith(newQuantityInput);
        minusBtn.replaceWith(newMinusBtn);
        plusBtn.replaceWith(newPlusBtn);
        
        // Get current quantity
        const currentQuantity = this.getProductQuantity(product) || 1;
        newQuantityInput.value = currentQuantity;
        
        // Set max based on available quantity
        newQuantityInput.max = this.availableVariantQuantity;
        
        // Helper function to update button states
        const updateButtons = () => {
            const currentValue = parseInt(newQuantityInput.value) || 1;
            
            // Update minus button
            if (currentValue <= 1) {
                newMinusBtn.disabled = true;
                newMinusBtn.setAttribute('disabled', 'disabled');
                newMinusBtn.style.opacity = '0.5';
                newMinusBtn.style.cursor = 'not-allowed';
            } else {
                newMinusBtn.disabled = false;
                newMinusBtn.removeAttribute('disabled');
                newMinusBtn.style.opacity = '1';
                newMinusBtn.style.cursor = 'pointer';
            }
            
            // Update plus button
            if (currentValue >= this.availableVariantQuantity) {
                newPlusBtn.disabled = true;
                newPlusBtn.setAttribute('disabled', 'disabled');
                newPlusBtn.style.opacity = '0.5';
                newPlusBtn.style.cursor = 'not-allowed';
            } else {
                newPlusBtn.disabled = false;
                newPlusBtn.removeAttribute('disabled');
                newPlusBtn.style.opacity = '1';
                newPlusBtn.style.cursor = 'pointer';
            }
        };
        
        // Initial button state
        updateButtons();
        
        // Input change handler
        newQuantityInput.addEventListener("change", () => {
            let quantity = Math.max(1, Math.min(this.availableVariantQuantity, +newQuantityInput.value || 1));
            newQuantityInput.value = quantity;
            this.setProductQuantity(product, quantity);
            updateButtons();
        });
        
        // Minus button handler
        newMinusBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            let currentValue = parseInt(newQuantityInput.value) || 1;
            let newQuantity = currentValue - 1;
            
            // Ensure minimum of 1
            if (newQuantity < 1) newQuantity = 1;
            
            newQuantityInput.value = newQuantity;
            this.setProductQuantity(product, newQuantity);
            updateButtons();
            
            // Trigger change event
            newQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        // Plus button handler
        newPlusBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            let currentValue = parseInt(newQuantityInput.value) || 1;
            let newQuantity = currentValue + 1;
            
            // Ensure maximum doesn't exceed available
            if (newQuantity > this.availableVariantQuantity) {
                newQuantity = this.availableVariantQuantity;
            }
            
            newQuantityInput.value = newQuantity;
            this.setProductQuantity(product, newQuantity);
            updateButtons();
            
            // Trigger change event
            newQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }
    
    // Add this helper method to update button states
    updateQuantityButtonStates(minusBtn, plusBtn, currentQuantity) {
        // Enable/disable minus button based on quantity
        if (currentQuantity <= 1) {
            minusBtn.disabled = true;
            minusBtn.setAttribute('disabled', 'disabled');
            minusBtn.style.opacity = '0.5';
            minusBtn.style.cursor = 'not-allowed';
        } else {
            minusBtn.disabled = false;
            minusBtn.removeAttribute('disabled');
            minusBtn.style.opacity = '1';
            minusBtn.style.cursor = 'pointer';
        }
        
        // Enable/disable plus button based on available quantity
        if (currentQuantity >= this.availableVariantQuantity) {
            plusBtn.disabled = true;
            plusBtn.setAttribute('disabled', 'disabled');
            plusBtn.style.opacity = '0.5';
            plusBtn.style.cursor = 'not-allowed';
        } else {
            plusBtn.disabled = false;
            plusBtn.removeAttribute('disabled');
            plusBtn.style.opacity = '1';
            plusBtn.style.cursor = 'pointer';
        }
    }

    updateAllQuantitySelectorsForProduct(product, quantity) {
        if (!product) return;
        
        const quantityInputs = product.querySelectorAll('.bulk-quantity-input');
        quantityInputs.forEach(input => {
            input.value = quantity;
        });
        
        if (!product.quantityData) {
            product.quantityData = {};
        }
        product.quantityData.quantity = quantity;
    }

    setupAllQuantitySelectors() {
        this.handleQuantityDropdownEvents();
        
        this.products.forEach(productObj => {
            const product = productObj.product;
            this.setupProductQuantitySelectors(product);
            
            // Initialize button states for existing quantity inputs
            const quantityInputs = product.querySelectorAll('.bulk-quantity-input');
            quantityInputs.forEach(input => {
                const currentQuantity = parseInt(input.value) || 1;
                const container = input.closest('.bulk-quantity-selector');
                if (container) {
                    const minusBtn = container.querySelector('[data-role="minus"]');
                    const plusBtn = container.querySelector('[data-role="plus"]');
                    if (minusBtn && plusBtn) {
                        // Simple button state update
                        if (currentQuantity <= 1) {
                            minusBtn.disabled = true;
                            minusBtn.setAttribute('disabled', 'disabled');
                        } else {
                            minusBtn.disabled = false;
                            minusBtn.removeAttribute('disabled');
                        }
                        
                        if (currentQuantity >= this.availableVariantQuantity) {
                            plusBtn.disabled = true;
                            plusBtn.setAttribute('disabled', 'disabled');
                        } else {
                            plusBtn.disabled = false;
                            plusBtn.removeAttribute('disabled');
                        }
                    }
                }
            });
        });
    }

    setupProductQuantitySelectors(product) {
        if (!product) return;
        
        // Clean up first
        this.cleanupQuantitySelectors(product);
        
        const desktopQuantityContainer = product.querySelector('.desktop-only .bulk-quantity-selector');
        const mobileQuantityContainers = product.querySelectorAll('.mobile-only .bulk-quantity-selector');
        
        if (desktopQuantityContainer) {
            this.setupSingleQuantitySelector(desktopQuantityContainer);
        }
        
        mobileQuantityContainers.forEach(container => {
            this.setupSingleQuantitySelector(container);
        });
    }
    
    handleProductQuantityChange(value, removeInSequence) {
        this.bulkProductQuantity = value;
        
        if (value < this.products.length) {
            // Remove products from the end
            const productsToRemove = this.products.length - value;
            
            for (let i = 0; i < productsToRemove; i++) {
                const lastIndex = this.products.length - 1;
                if (lastIndex >= 0) {
                    const productToRemove = this.products[lastIndex];
                    
                    // Remove from DOM
                    if (productToRemove.product && productToRemove.product.parentNode) {
                        productToRemove.product.remove();
                    }
                    
                    // Remove from array
                    this.products.splice(lastIndex, 1);
                }
            }
            
            // Re-number remaining products
            this.renumberAllProductsAndTabs();
            
        } else if (value > this.products.length) {
            // Add new products
            const additionalProducts = value - this.products.length;
            
            for (let i = 0; i < additionalProducts; i++) {
                this.addProductSimple();
            }
        }
        
        // Always show the first product after quantity change
        if (this.products.length > 0) {
            this.showProductByIndex(0);
        }
        
        // Update dropdown button text
        const dropdownButtons = this.querySelectorAll('.select-dropdown__button .selected-product--quantity');
        dropdownButtons.forEach(button => {
            if (value === 1) {
                button.textContent = 'Select Quantity';
            } else {
                button.textContent = `${value} Product${value > 1 ? 's' : ''}`;
            }
        });
        
        // Update selected state in dropdown list
        const dropdownItems = this.querySelectorAll('.select-dropdown__list-item');
        dropdownItems.forEach(item => {
            if (parseInt(item.dataset.value) === value) {
                item.classList.add('selected');
            } else {
                item.classList.remove('selected');
            }
        });
        
        this.validateAllCustomizers();
        this.scrollToTop();
    }

    // Add this method to clean up existing event handlers
cleanupQuantitySelectors(product) {
    if (!product) return;
    
    const quantitySelectors = product.querySelectorAll('.bulk-quantity-selector');
    quantitySelectors.forEach(container => {
        const quantityInput = container.querySelector('.bulk-quantity-input');
        const minusBtn = container.querySelector('[data-role="minus"]');
        const plusBtn = container.querySelector('[data-role="plus"]');
        
        if (quantityInput) {
            // Remove all event listeners by replacing the element
            const newInput = quantityInput.cloneNode(true);
            quantityInput.replaceWith(newInput);
        }
        
        if (minusBtn) {
            const newMinusBtn = minusBtn.cloneNode(true);
            minusBtn.replaceWith(newMinusBtn);
        }
        
        if (plusBtn) {
            const newPlusBtn = plusBtn.cloneNode(true);
            plusBtn.replaceWith(newPlusBtn);
        }
    });
}
    
    addProductSimple() {
        if (this.products.length >= MAX_PRODUCTS) return;
        if (!this.newCustomizerTemplate || !this.tabTemplate) return;
        
        const newProductIndex = this.products.length + 1;
        
        // Clone the template
        const newProduct = this.newCustomizerTemplate.content.cloneNode(true).querySelector("product-customizer");
        newProduct.dataset.initialVariantId = this.variantID;
        
        // IMPORTANT: Set initial quantity data
        newProduct.quantityData = { quantity: 1 };
        
        // Add to DOM
        this.productsContainer.appendChild(newProduct);
        
        // Create a tab for this product
        const newTab = this.createProductTab(newProductIndex);
        
        // Add to products array
        this.products.push({
            product: newProduct,
            tab: newTab,
            index: this.products.length
        });
        
        // Set initial quantity
        this.setProductQuantity(newProduct, 1);
        
        // Setup product validation
        this.setupBulkProductValidation(newProduct);
        this.ensureCanvasesVisible(newProduct);
        
        // Setup quantity selectors AFTER a brief delay to ensure DOM is ready
        setTimeout(() => {
            const desktopQuantityContainer = newProduct.querySelector('.desktop-only .bulk-quantity-selector');
            if (desktopQuantityContainer) {
                this.setupSingleQuantitySelector(desktopQuantityContainer);
            }
            
            const mobileQuantityContainers = newProduct.querySelectorAll('.mobile-only .bulk-quantity-selector');
            mobileQuantityContainers.forEach(container => {
                this.setupSingleQuantitySelector(container);
            });
        }, 50);
        
        // Rebuild tab containers
        this.simpleRebuildTabContainers();
        
        return newProduct;
    }
    handleQuantityDropdownEvents() {        
        if (this._dropdownHandlerBound) {
            this.removeEventListener('click', this._dropdownHandlerBound);
        }
        
        this._dropdownHandlerBound = this.handleDropdownClick.bind(this);
        this.addEventListener('click', this._dropdownHandlerBound);

        document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) {
                const allDropdownLists = this.querySelectorAll('.select-dropdown__list');
                allDropdownLists.forEach(list => {
                    list.classList.remove('active');
                });
            }
        });
    }

    handleDropdownClick(e) {
        const dropdownButton = e.target.closest('.select-dropdown__button');
        if (dropdownButton) {
            e.preventDefault();
            e.stopPropagation();
            
            const dropdownList = dropdownButton.nextElementSibling;
            if (dropdownList && dropdownList.classList.contains('select-dropdown__list')) {
                dropdownList.classList.toggle('active');
                
                const allDropdownLists = this.querySelectorAll('.select-dropdown__list');
                allDropdownLists.forEach(list => {
                    if (list !== dropdownList) {
                        list.classList.remove('active');
                    }
                });
            }
            return;
        }
        
        const dropdownItem = e.target.closest('.select-dropdown__list-item');
        if (dropdownItem) {
            e.preventDefault();
            e.stopPropagation();
            
            const selectedValue = parseInt(dropdownItem.dataset.value);
            const selectedText = dropdownItem.textContent;
            
            // Update all dropdown buttons to show the selected text
            const allDropdownButtons = this.querySelectorAll('.select-dropdown__button .selected-product--quantity');
            allDropdownButtons.forEach(button => {
                if (selectedValue === 1) {
                    // If selecting 1 product, show "Select Quantity" as placeholder
                    button.textContent = 'Select Quantity';
                } else {
                    // If selecting more than 1, show the actual count
                    button.textContent = selectedText;
                }
            });
            
            const allDropdownLists = this.querySelectorAll('.select-dropdown__list');
            allDropdownLists.forEach(list => {
                list.classList.remove('active');
            });
            
            // Handle product quantity change
            this.handleProductQuantityChange(selectedValue, false);
            this.currentProductIndex = 0;
            this.isPreviewMode = false;
            this.scrollToTop();
        }
    }
    
    
    addProduct() {
    if (this.products.length >= MAX_PRODUCTS) return;
    if (!this.newCustomizerTemplate || !this.tabTemplate) return;
    
    const newProduct = this.newCustomizerTemplate.content.cloneNode(true).querySelector("product-customizer");
    newProduct.dataset.initialVariantId = this.variantID;
    
    const newProductIndex = this.products.length + 1;
    
    this.productsContainer.appendChild(newProduct);
    
    const mainTab = this.createProductTab(newProductIndex);
    
    this.products.push({ product: newProduct, tab: mainTab });
    
    this.setProductQuantity(newProduct, 1);
    
    this.setupBulkActionWrapperEvent(newProduct.querySelector(".personalized-actions__wrapper"));
    
    const newBulkBtn = newProduct.querySelector(".bulk-add--button");
    if (newBulkBtn) this.addBulkToggleEvent(newBulkBtn);
    
    const newBulkCloseBtn = newProduct.querySelector(".bulk-personalization-close--button");
    if (newBulkCloseBtn) this.setupBulkCloseEvent(newBulkCloseBtn);
    
    this.attachTabEvents(mainTab);
    
    const newBulkATCBtn = newProduct.querySelector("button[data-action=bulk-add-to-cart]")
    this.setupAddToCartEvent(newBulkATCBtn);
    if (!this.bulkATCLabel) this.bulkATCLabel = newBulkATCBtn.textContent;
    this.availableVariantQuantity < 1 ? newBulkATCBtn.textContent = "Out of stock" : newBulkATCBtn.textContent = this.bulkATCLabel;
    
    // UPDATE allBulkATCBtns when adding a product
    this.allBulkATCBtns = this.querySelectorAll("button[data-action=bulk-add-to-cart]");
    
    // Initialize quantity selectors and button states
    this.setupProductQuantitySelectors(newProduct);
        
        // Initialize button states for the new product
        const quantityInputs = newProduct.querySelectorAll('.bulk-quantity-input');
        quantityInputs.forEach(input => {
            const currentQuantity = parseInt(input.value) || 1;
            const container = input.closest('.bulk-quantity-selector');
            if (container) {
                const minusBtn = container.querySelector('[data-role="minus"]');
                const plusBtn = container.querySelector('[data-role="plus"]');
                if (minusBtn && plusBtn) {
                    this.updateQuantityButtonStates(minusBtn, plusBtn, currentQuantity);
                }
            }
        });
        
        this.initializeTabsForAllStepsInAllProducts();
        this.initializeMainDesktopTabs();
        this.updateAllDropdownButtons();
        
        this.setupBulkProductValidation(newProduct);
        
        if (this.products.length === 1) {
            setTimeout(() => {
                this.firstProductInview();
            }, 100);
        }
        
        setTimeout(() => {
            this.setupProductPreviewButtons();
        }, 50);
        
        return newProduct;
    }
    updateOptionLabelClass(product, optionName, input) {
        if (!input || !product) return;
        
        // Find all labels for this option group
        const allLabels = product.querySelectorAll(`label[for*="${optionName}"], label[class*="${optionName}"], label:has(input[name="${optionName}"])`);
        
        // First, remove the selected class from all labels in this group
        allLabels.forEach(label => {
            label.classList.remove(`${optionName}-option-selected`);
        });
        
        // Then add the selected class to the label associated with the input ONLY if it's checked
        const label = input.closest('label') || product.querySelector(`label[for="${input.id}"]`);
        if (label && input.checked) {
            label.classList.add(`${optionName}-option-selected`);
        } else if (label) {
            console.log(`❌ Removed ${optionName}-option-selected class from label (input not checked)`);
        }
    }

    // NEW METHOD: Handle font pattern changes specifically
    handleBulkFontPatternChange(e, product) {
        const input = e.target;
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        
        const allInputs = product.querySelectorAll(`input[name="font-pattern"]`);
        
        if (input.checked) {
            // Uncheck all other options
            allInputs.forEach(option => {
                if (option !== input) {
                    option.checked = false;
                    this.updateOptionLabelClass(product, 'font-pattern', option);
                }
            });
            
            // Update customization data
            product.savedCustomizationData["font-pattern"] = optionData;
            product.savedCustomizationData["font-pattern-label"] = optionLabel;
            
            // Update label class
            this.updateOptionLabelClass(product, 'font-pattern', input);
            
        } else {
            // Deselect - clear the data
            product.savedCustomizationData["font-pattern"] = "";
            product.savedCustomizationData["font-pattern-label"] = "";
            
            // Update label class
            this.updateOptionLabelClass(product, 'font-pattern', input);
            
        }
        
        // Force immediate canvas update
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }

    handleBulkIconChange(e, product) {
        const input = e.target;
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        const allInputs = product.querySelectorAll('input[name="icon"]');
        
        const currentSavedLabel = product.savedCustomizationData["icon-label"];
        const isAlreadySelected = !!(currentSavedLabel && currentSavedLabel === optionLabel);
        
        if (isAlreadySelected) {
            // Deselect in bulk mode
            input.checked = false;
            
            // Clear the data
            product.savedCustomizationData["icon"] = "";
            product.savedCustomizationData["icon-label"] = "";
            
            // Remove the selected class
            this.removeOptionSelectedClass(product, 'icon', input);
            
        } else {
            // Select this one
            allInputs.forEach(opt => {
                opt.checked = false;
                this.removeOptionSelectedClass(product, 'icon', opt);
            });
            input.checked = true;
            
            // Update customization data
            product.savedCustomizationData["icon"] = optionData || "";
            product.savedCustomizationData["icon-label"] = optionLabel || "";
            
            // CRITICAL: Add the selected class
            this.addOptionSelectedClass(product, 'icon', input);
        }
        
        // Force immediate canvas update
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    refreshAllOptionClasses() {
        this.products.forEach(productObj => {
            const product = productObj.product;
            if (product && product.savedCustomizationData) {
                this.restoreSavedSelections(product);
            }
        });
    }
    addOptionSelectedClass(product, optionName, input) {
        if (!product || !input) return;
        
        
        // Remove selected classes from all labels first
        this.removeAllOptionSelectedClasses(product, optionName);
        
        // Add selected class to the clicked label
        let selectedLabel = input.closest('label');
        if (!selectedLabel && input.id) {
            selectedLabel = product.querySelector(`label[for="${input.id}"]`);
        }
        
        if (selectedLabel) {
            selectedLabel.classList.add(`${optionName}-option-selected`);
            const span = selectedLabel.querySelector('.option-preview__wrapper');
            if (span) span.classList.add(`${optionName}-option-selected`);
        } else {
            console.error(`❌ Could not find label for ${optionName} input`);
        }
    }

    takeFullControlOfProductCustomizers() {
        
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            
            // Use the new clean handler setup
            this.setupBulkOptionHandlers(product);
            
            // Ensure font style is always selected
            this.ensureFontStyleSelection(product);
        });
    }
    ensureBulkOptionClasses(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const data = product.savedCustomizationData;
        
        // Update each option group
        ['font-style', 'font-pattern', 'icon'].forEach(optionName => {
            if (data[optionName] && data[optionName].trim() !== "") {
                const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
                inputs.forEach(input => {
                    if (input.dataset.optionData === data[optionName]) {
                        input.checked = true;
                        this.updateBulkOptionClasses(product, optionName);
                    } else {
                        input.checked = false;
                    }
                });
            } else if (optionName === 'icon' && data["icon-label"] === "No icon") {
                const inputs = product.querySelectorAll('input[name="icon"]');
                inputs.forEach(input => {
                    const isNoIconInput = (input.value === "No icon" || input.dataset.optionLabel === "No icon");
                    const label = input.closest('label');
                    if (isNoIconInput) {
                        input.checked = true;
                        if (label) label.classList.add('icon-option-selected');
                    } else {
                        input.checked = false;
                        if (label) label.classList.remove('icon-option-selected');
                    }
                });
            }
        });
        
        // Ensure font-style always has a selection
        if (!data["font-style"] || data["font-style"].trim() === "") {
            const fontStyleInputs = product.querySelectorAll('input[name="font-style"]');
            const firstInput = fontStyleInputs[0];
            if (firstInput) {
                firstInput.checked = true;
                this.updateBulkOptionClasses(product, 'font-style');
                
                if (product.savedCustomizationData) {
                    product.savedCustomizationData["font-style"] = firstInput.dataset.optionData;
                    product.savedCustomizationData["font-style-label"] = firstInput.dataset.optionLabel;
                }
            }
        }
    }
    removeOptionSelectedClass(product, optionName, input) {
        let label = input.closest('label');
        if (!label && input.id) {
            label = product.querySelector(`label[for="${input.id}"]`);
        }
        
        if (label) {
            label.classList.remove(`${optionName}-option-selected`);
            const span = label.querySelector('.option-preview__wrapper');
            if (span) span.classList.remove(`${optionName}-option-selected`);
        }
    }
    removeAllOptionSelectedClasses(product, optionName) {
        const allLabels = product.querySelectorAll(`label[for*="${optionName}"], label[class*="${optionName}"], label:has(input[name="${optionName}"])`);
        allLabels.forEach(label => {
            label.classList.remove(`${optionName}-option-selected`);
            const span = label.querySelector('.option-preview__wrapper');
            if (span) span.classList.remove(`${optionName}-option-selected`);
        });
    }
    
    setupBulkProductValidation(product) {
        if (!product) return;
        
        // Initialize customization data
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {
                "personalized-text": "",
                "text-orientation": "horizontal",
                "font-style": "",
                "font-style-label": "", 
                "font-pattern": "",
                "font-pattern-label": "",
                "icon": "",
                "icon-label": "",
            };
        }
        
        // Text input handling
        const textInput = product.querySelector('#personalizedText');
        if (textInput) {            
            const handleInput = this.debounce((e) => {
                this.handleBulkTextInput(e, product);
            }, 200);
            
            textInput.replaceWith(textInput.cloneNode(true));
            const newTextInput = product.querySelector('#personalizedText');
            
            newTextInput.addEventListener('input', handleInput);
            newTextInput.addEventListener('change', handleInput);
        }
        
        // Orientation buttons
        const orientationButtons = product.querySelectorAll('.text-orientation__option');
        orientationButtons.forEach(button => {
            const newButton = button.cloneNode(true);
            button.replaceWith(newButton);
            
            newButton.addEventListener('click', (e) => {
                this.handleBulkOrientationChange(e, product);
            });
        });
        
        // Use the simplified option handlers
        this.setupBulkOptionHandlers(product);
    }
    setupCleanOptionHandlersForType(product, optionName) {
        // Find all inputs for this option
        const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        
        inputs.forEach((input, index) => {
            // Clone to remove existing listeners
            const newInput = input.cloneNode(true);
            if (input.parentNode) {
                input.parentNode.replaceChild(newInput, input);
            }
            
            // Add clean click handler
            newInput.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleCleanOptionSelection(newInput, product, optionName);
            });
        });
    }
    // Update the handleOptionSelectionWithClasses method for immediate response:
    handleOptionSelectionWithClasses(input, product, optionName) {
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        // Get all inputs for this option
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const allLabels = product.querySelectorAll(`label[for*="${optionName}"], label[class*="${optionName}"], label:has(input[name="${optionName}"])`);
        
        // IMMEDIATELY remove selected classes from all labels
        allLabels.forEach(label => {
            label.classList.remove(`${optionName}-option-selected`);
        });
        
        // IMMEDIATELY uncheck all inputs for this option
        allInputs.forEach(opt => {
            opt.checked = false;
        });
        
        if (!input.checked) {
            
            // IMMEDIATELY set current input as checked
            input.checked = true;
            
            // Update customization data
            product.savedCustomizationData[optionName] = optionData;
            product.savedCustomizationData[`${optionName}-label`] = optionLabel;
            
            // IMMEDIATELY add selected class to the label
            this.addOptionSelectedClassImmediately(product, optionName, input);
            
        } else {
            // Option is being deselected (only for optional options)
            if (optionName === 'icon') {
                // Allow deselection only for icons
                input.checked = false;
                
                // Clear the data
                product.savedCustomizationData[optionName] = "";
                product.savedCustomizationData[`${optionName}-label`] = "";
                
                // IMMEDIATELY remove selected class from label
                this.removeOptionSelectedClassImmediately(product, optionName, input);
            } else if (optionName === 'font-style') {
                // For font-style, keep it checked since it's required
                input.checked = true;
                this.addOptionSelectedClassImmediately(product, optionName, input);
            }
            // For font-pattern, do nothing - keep it checked (prevent deselection)
        }
        
        // Force canvas update with new selections
        this.forceBulkCanvasUpdateWithText(product);
        
        // Update UI state
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        // Dispatch change event
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }

    // NEW METHOD: Add selected class immediately
    addOptionSelectedClassImmediately(product, optionName, input) {
        if (!product || !input) return;
        
        // Remove selected classes from all labels first
        this.removeAllOptionSelectedClassesImmediately(product, optionName);
        
        // Add selected class to the clicked label
        let selectedLabel = input.closest('label');
        if (!selectedLabel && input.id) {
            selectedLabel = product.querySelector(`label[for="${input.id}"]`);
        }
        
        if (selectedLabel) {
            selectedLabel.classList.add(`${optionName}-option-selected`);
        }
    }

    // NEW METHOD: Remove selected class immediately
    removeOptionSelectedClassImmediately(product, optionName, input) {
        let label = input.closest('label');
        if (!label && input.id) {
            label = product.querySelector(`label[for="${input.id}"]`);
        }
        
        if (label) {
            label.classList.remove(`${optionName}-option-selected`);
        }
    }
    // Add this method to ensure immediate class application
    ensureImmediateOptionClasses(product) {
        if (!product) return;
        
        // Use requestAnimationFrame for immediate visual update
        requestAnimationFrame(() => {
            this.immediatelyApplyOptionClasses(product);
        });
    }

    // NEW METHOD: Remove all selected classes immediately
    removeAllOptionSelectedClassesImmediately(product, optionName) {
        const allLabels = product.querySelectorAll(`label[for*="${optionName}"], label[class*="${optionName}"], label:has(input[name="${optionName}"])`);
        allLabels.forEach(label => {
            label.classList.remove(`${optionName}-option-selected`);
        });
    }
    cleanupProductHandlers(product) {
        if (product._clickHandler) {
            product.removeEventListener('click', product._clickHandler, true);
            delete product._clickHandler;
        }
        delete product._bulkHandlersInitialized;
    }
    // Update the setupBulkOptionHandlers method to use the new handler
    setupBulkOptionHandlers(product) {
        if (!product) return;
        
        // Don't reinitialize if already done
        if (product._bulkHandlersInitialized) {
            return;
        }
        
        // Clean up any existing handlers
        this.cleanupProductHandlers(product);
        
        // Setup event delegation at the product level
        const handleProductClick = (e) => {
            if (this._optionUpdateBlocked) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            
            // Check for font-style option click
            const fontStyleLabel = e.target.closest(`label[for*="font-style"], label[class*="font-style"], label:has(input[name="font-style"])`);
            if (fontStyleLabel) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                this.handleBulkOptionClick(e, product, 'font-style');
                return;
            }
            
            // Check for font-pattern option click
            const fontPatternLabel = e.target.closest(`label[for*="font-pattern"], label[class*="font-pattern"], label:has(input[name="font-pattern"])`);
            if (fontPatternLabel) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                this.handleBulkOptionClick(e, product, 'font-pattern');
                return;
            }
            
            // Check for icon option click
            const iconLabel = e.target.closest(`label[for*="icon"], label[class*="icon"], label:has(input[name="icon"])`);
            if (iconLabel) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                this.handleBulkOptionClick(e, product, 'icon');
                return;
            }
        };
        
        // Attach with capture phase to ensure it runs first
        product.addEventListener('click', handleProductClick, true);
        
        // Store handler for cleanup
        product._clickHandler = handleProductClick;
        product._bulkHandlersInitialized = true;
    }

    // New method for setting up handlers with class management
    setupIsolatedOptionHandlersWithClasses(product, optionName) {
        // Find ALL inputs and labels for this option
        const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const labels = product.querySelectorAll(`label:has(input[name="${optionName}"])`);
        
        
        // Replace all elements to remove existing listeners
        inputs.forEach(input => {
            const newInput = input.cloneNode(true);
            input.parentNode.replaceChild(newInput, input);
        });
        
        labels.forEach(label => {
            const newLabel = label.cloneNode(true);
            label.parentNode.replaceChild(newLabel, label);
        });
        
        // Get fresh references after replacement
        const freshInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const freshLabels = product.querySelectorAll(`label:has(input[name="${optionName}"])`);
        
        // Set up clean click handlers
        freshLabels.forEach((label, index) => {
            const input = label.querySelector(`input[name="${optionName}"]`);
            if (!input) return;
            
            label.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                this.handleOptionSelectionWithClasses(input, product, optionName);
            });
            
        });
    }
    setupIsolatedOptionHandlers(product, optionName) {
        // Find ALL inputs and labels for this option
        const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const labels = product.querySelectorAll(`label:has(input[name="${optionName}"])`);
        
        
        // Replace all elements to remove existing listeners
        inputs.forEach(input => {
            const newInput = input.cloneNode(true);
            input.parentNode.replaceChild(newInput, input);
        });
        
        labels.forEach(label => {
            const newLabel = label.cloneNode(true);
            label.parentNode.replaceChild(newLabel, label);
        });
        
        // Get fresh references after replacement
        const freshInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const freshLabels = product.querySelectorAll(`label:has(input[name="${optionName}"])`);
        
        // Set up clean click handlers
        freshLabels.forEach((label, index) => {
            const input = label.querySelector(`input[name="${optionName}"]`);
            if (!input) return;
            
            label.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                this.handleCleanBulkOptionSelection(input, product, optionName);
            });
            
        });
    }
    handleCleanBulkOptionSelection(input, product, optionName) {
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }        
        
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const allLabels = product.querySelectorAll(`label:has(input[name="${optionName}"])`);
        
        const currentSavedLabel = product.savedCustomizationData[`${optionName}-label`];
        const isAlreadySelected = !!(currentSavedLabel && currentSavedLabel === optionLabel);
        
        // Remove all selected classes first
        allLabels.forEach(label => {
            label.classList.remove(`${optionName}-option-selected`);
        });
        
        // Uncheck all inputs
        allInputs.forEach(opt => {
            opt.checked = false;
        });
        
        if (isAlreadySelected && optionName === 'icon') {
            // Deselect icon (allow deselection)
            input.checked = false;
            
            // Clear data for icon
            product.savedCustomizationData[optionName] = "";
            product.savedCustomizationData[`${optionName}-label`] = "";
        } else {
            // Select current option (for font-style, font-pattern, or unselected icon)
            input.checked = true;
            
            // Update data
            product.savedCustomizationData[optionName] = optionData || "";
            product.savedCustomizationData[`${optionName}-label`] = optionLabel || "";
            
            // Add visual selection
            const label = input.closest('label');
            if (label) {
                label.classList.add(`${optionName}-option-selected`);
            }
        }
        
        // Update canvas
        this.forceBulkCanvasUpdateWithText(product);
        
        // Dispatch event
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
        
        this.validateAllCustomizers();
    }
    // Add this method to BulkPersonalization
    cleanupProductCustomizerEvents(product) {
        if (!product) return;
        
        // Remove any event listeners that might interfere
        const optionTypes = ['font-style', 'font-pattern', 'icon'];
        
        optionTypes.forEach(optionName => {
            const elements = product.querySelectorAll(
                `input[name="${optionName}"], label[for*="${optionName}"], label:has(input[name="${optionName}"])`
            );
            
            elements.forEach(element => {
                const newElement = element.cloneNode(true);
                element.parentNode.replaceChild(newElement, element);
            });
        });        
    }
    handleCleanOptionSelection(input, product, optionName) {
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        // Get all inputs for this option
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        const currentSavedLabel = product.savedCustomizationData[`${optionName}-label`];
        const isAlreadySelected = !!(currentSavedLabel && currentSavedLabel === optionLabel);
        
        // Remove all selected classes first
        this.removeAllOptionSelectedClasses(product, optionName);
        
        // Uncheck all inputs for this option
        allInputs.forEach(opt => {
            opt.checked = false;
        });
        
        if (!isAlreadySelected) {
            // Set current input as checked
            input.checked = true;
            
            // Update customization data
            product.savedCustomizationData[optionName] = optionData || "";
            product.savedCustomizationData[`${optionName}-label`] = optionLabel || "";
            
            // Add visual selection class
            this.addOptionSelectedClass(product, optionName, input);
        } else {
            // Option is being deselected
            if (optionName === 'icon') {
                input.checked = false;
                product.savedCustomizationData[optionName] = "";
                product.savedCustomizationData[`${optionName}-label`] = "";
            } else if (optionName === 'font-style') {
                input.checked = true;
                this.addOptionSelectedClass(product, optionName, input);
            }
            // For font-pattern, do nothing (keep it checked)
        }
        
        // Force canvas update with new selections
        this.forceBulkCanvasUpdateWithText(product);
        
        // Update UI state
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        // Dispatch change event
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    setupOptionHandlersForType(product, optionName) {
        // Find all inputs for this option
        const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        inputs.forEach((input, index) => {
            // Remove any existing listeners by replacing the input
            const newInput = input.cloneNode(true);
            if (input.parentNode) {
                input.parentNode.replaceChild(newInput, input);
            }
            
            // Add clean click handler
            newInput.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleOptionClick(newInput, product, optionName);
            });
            
            // Also handle change event for safety
            newInput.addEventListener('change', (e) => {
                this.handleOptionClick(newInput, product, optionName);
            });
            
        });
    }
    handleOptionClick(input, product, optionName) {
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
               
        // Get all inputs for this option
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        const currentSavedLabel = product.savedCustomizationData[`${optionName}-label`];
        const isAlreadySelected = !!(currentSavedLabel && currentSavedLabel === optionLabel);
        
        if (!isAlreadySelected) {            
            // Uncheck all other options
            allInputs.forEach(opt => {
                if (opt !== input) {
                    opt.checked = false;
                    this.removeOptionSelectedClass(product, optionName, opt);
                }
            });
            
            // Set current input as checked
            input.checked = true;
            
            // Update customization data
            product.savedCustomizationData[optionName] = optionData || "";
            product.savedCustomizationData[`${optionName}-label`] = optionLabel || "";
            
            // Add visual selection class
            this.addOptionSelectedClass(product, optionName, input);
            
        } else {
            // Option is being deselected
            if (optionName === 'icon') {
                // Allow deselection for icons
                input.checked = false;
                
                // Clear the data
                product.savedCustomizationData[optionName] = "";
                product.savedCustomizationData[`${optionName}-label`] = "";
                
                // Remove visual selection class
                this.removeOptionSelectedClass(product, optionName, input);
            } else if (optionName === 'font-style') {
                input.checked = true;
                this.addOptionSelectedClass(product, optionName, input);
            }
            // For font-pattern, do nothing when clicked while selected (prevent deselection)
        }
        
        // Force canvas update with new selections
        this.forceBulkCanvasUpdateWithText(product);
        
        // Update UI state
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        // Dispatch change event
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    completelyReplaceOptionContainers(product) {
        const optionTypes = ['font-style', 'font-pattern', 'icon'];
        
        optionTypes.forEach(optionName => {
            // Find ALL containers that might have this option
            const selectors = [
                `.${optionName}-options-container`,
                `[data-option="${optionName}"]`,
                `[data-step="${optionName}"]`,
                `[class*="${optionName}"]`
            ];
            
            selectors.forEach(selector => {
                const containers = product.querySelectorAll(selector);
                containers.forEach(container => {
                    if (container && container.parentNode) {
                        const newContainer = container.cloneNode(true);
                        container.parentNode.replaceChild(newContainer, container);                        
                    }
                });
            });
        });
    }

    setupCleanOptionHandlers(product, optionName) {
        // Find ALL inputs for this option
        const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        inputs.forEach(input => {
            // Clone to remove existing listeners
            const newInput = input.cloneNode(true);
            const parent = input.parentNode;
            
            if (parent) {
                parent.replaceChild(newInput, input);
                
                // Add SINGLE click handler
                newInput.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    
                    this.handleOptionSelection(newInput, product, optionName);
                });
            }
        });
    }

    handleOptionSelection(input, product, optionName) {
           
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        // Remove ALL selected classes first
        this.removeAllSelectedClasses(product, optionName);
        
        // Uncheck ALL inputs
        allInputs.forEach(opt => {
            opt.checked = false;
        });
        
        if (!input.checked) {
            // Select this option
            input.checked = true;
            this.addSelectedClass(input, optionName);
            
            // Update saved data
            if (!product.savedCustomizationData) {
                product.savedCustomizationData = {};
            }
            product.savedCustomizationData[optionName] = input.dataset.optionData;
            product.savedCustomizationData[`${optionName}-label`] = input.dataset.optionLabel;
        } else {
            // Deselect
            if (optionName === 'icon') {
                // Allow icon deselection
                product.savedCustomizationData[optionName] = "";
                product.savedCustomizationData[`${optionName}-label`] = "";                
            } else if (optionName === 'font-style') {
                // Re-check font-style if trying to deselect
                input.checked = true;
                this.addSelectedClass(input, optionName);
            }
            // For font-pattern, do nothing (keep selected)
        }
        
        // Update UI
        this.forceBulkCanvasUpdateWithText(product);
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        // Dispatch single event
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }

    removeAllSelectedClasses(product, optionName) {
        const allLabels = product.querySelectorAll(`label[class*="${optionName}"]`);
        allLabels.forEach(label => {
            label.classList.remove(`${optionName}-option-selected`);
        });
    }

    addSelectedClass(input, optionName) {
        const label = input.closest('label');
        if (label) {
            label.classList.add(`${optionName}-option-selected`);
        }
    }

    restoreSavedSelections(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const data = product.savedCustomizationData;
        
        // Restore each option type
        ['font-style', 'font-pattern', 'icon'].forEach(optionName => {
            if (data[optionName] && data[optionName].trim() !== "") {
                const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
                let found = false;
                
                inputs.forEach(input => {
                    if (input.dataset.optionData === data[optionName]) {
                        input.checked = true;
                        this.addOptionSelectedClass(product, optionName, input);
                        found = true;
                    } else {
                        input.checked = false;
                    }
                });
                
                if (!found && optionName === 'font-style') {
                    // For font-style, select the first option if saved one not found
                    const firstInput = inputs[0];
                    if (firstInput) {
                        firstInput.checked = true;
                        this.addOptionSelectedClass(product, 'font-style', firstInput);
                        data["font-style"] = firstInput.dataset.optionData;
                        data["font-style-label"] = firstInput.dataset.optionLabel;                        
                    }
                }
            } else if (optionName === 'font-style') {
                // Ensure font-style always has a selection
                const inputs = product.querySelectorAll(`input[name="font-style"]`);
                const firstInput = inputs[0];
                if (firstInput && !data["font-style"]) {
                    firstInput.checked = true;
                    this.addOptionSelectedClass(product, 'font-style', firstInput);
                    data["font-style"] = firstInput.dataset.optionData;
                    data["font-style-label"] = firstInput.dataset.optionLabel;                    
                }
            } else {
                // For other options, ensure they're unchecked if no data
                const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
                inputs.forEach(input => {
                    input.checked = false;
                });
            }
        });
    }
    ensureFontStyleSelection(product) {
        if (!product) return;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        const data = product.savedCustomizationData;
        const fontStyleInputs = product.querySelectorAll('input[name="font-style"]');
        
        // If no font style is selected, select the first one
        if (!data["font-style"] || data["font-style"].trim() === "") {
            const firstInput = fontStyleInputs[0];
            if (firstInput) {
                firstInput.checked = true;
                this.addOptionSelectedClass(product, 'font-style', firstInput);
                data["font-style"] = firstInput.dataset.optionData;
                data["font-style-label"] = firstInput.dataset.optionLabel;
                
                // Update canvas
                this.forceBulkCanvasUpdateWithText(product);
            }
        } else {
            // If there is a saved font style, ensure it's visually selected
            const inputs = product.querySelectorAll('input[name="font-style"]');
            inputs.forEach(input => {
                if (input.dataset.optionData === data["font-style"]) {
                    input.checked = true;
                    this.addOptionSelectedClass(product, 'font-style', input);
                } else {
                    input.checked = false;
                }
            });
        }
    }
    restoreOptionClasses(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const data = product.savedCustomizationData;
        
        // Restore each option type
        ['font-style', 'font-pattern', 'icon'].forEach(optionName => {
            if (data[optionName] && data[optionName].trim() !== "") {
                const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
                let found = false;
                
                inputs.forEach(input => {
                    if (input.dataset.optionData === data[optionName]) {
                        input.checked = true;
                        this.addOptionSelectedClass(product, optionName, input);
                        found = true;
                    } else {
                        input.checked = false;
                    }
                });
                
                if (!found && optionName === 'font-style') {
                    // For font-style, select the first option if saved one not found
                    const firstInput = inputs[0];
                    if (firstInput) {
                        firstInput.checked = true;
                        this.addOptionSelectedClass(product, 'font-style', firstInput);
                        data["font-style"] = firstInput.dataset.optionData;
                        data["font-style-label"] = firstInput.dataset.optionLabel;                        
                    }
                }
            } else if (optionName === 'font-style') {
                // Ensure font-style always has a selection
                const inputs = product.querySelectorAll(`input[name="font-style"]`);
                const firstInput = inputs[0];
                if (firstInput && !data["font-style"]) {
                    firstInput.checked = true;
                    this.addOptionSelectedClass(product, 'font-style', firstInput);
                    data["font-style"] = firstInput.dataset.optionData;
                    data["font-style-label"] = firstInput.dataset.optionLabel;                    
                }
            } else {
                // For other options, ensure they're unchecked if no data
                const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
                inputs.forEach(input => {
                    input.checked = false;
                });
            }
        });
    }
    restoreOptionSelections(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const data = product.savedCustomizationData;
        const optionTypes = [
            { name: 'font-style', required: true },
            { name: 'font-pattern', required: false },
            { name: 'icon', required: false }
        ];
        
        optionTypes.forEach(({ name, required }) => {
            if (data[name] && data[name].trim() !== "") {
                const inputs = product.querySelectorAll(`input[name="${name}"]`);
                let found = false;
                
                inputs.forEach(input => {
                    if (input.dataset.optionData === data[name]) {
                        input.checked = true;
                        const label = input.closest('label');
                        if (label) {
                            label.classList.add(`${name}-option-selected`);
                        }
                        found = true;
                    } else {
                        input.checked = false;
                    }
                });
                
                if (!found && required) {
                    // Select first option if required option is missing
                    const firstInput = inputs[0];
                    if (firstInput) {
                        firstInput.checked = true;
                        const label = firstInput.closest('label');
                        if (label) {
                            label.classList.add(`${name}-option-selected`);
                        }
                        data[name] = firstInput.dataset.optionData;
                        data[`${name}-label`] = firstInput.dataset.optionLabel;                        
                    }
                }
            }
        });
    }
    completelyReplaceOptionElements(product) {
        const optionTypes = ['font-style', 'font-pattern', 'icon'];
        
        optionTypes.forEach(optionName => {
            const containers = product.querySelectorAll(`.${optionName}-options-container, [data-option="${optionName}"]`);
            containers.forEach(container => {
                if (container) {
                    const newContainer = container.cloneNode(true);
                    container.parentNode.replaceChild(newContainer, container);                    
                }
            });
        });
    }

    setupUnifiedOptionHandlers(product, optionName) {
        const labels = product.querySelectorAll(`label:has(input[name="${optionName}"])`);
        
        labels.forEach(label => {
            // Clone to remove existing listeners
            const newLabel = label.cloneNode(true);
            label.parentNode.replaceChild(newLabel, label);
            
            const input = newLabel.querySelector(`input[name="${optionName}"]`);
            if (!input) return;
            
            // Add clean click handler
            newLabel.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                this.handleBulkOptionClick(input, newLabel, product, optionName);
            });
        });
    }

    handleBulkOptionClick(e, product, optionName) {
        if (this._optionUpdateBlocked) return;
        
        // Block further clicks for a short time
        this._optionUpdateBlocked = true;
        setTimeout(() => {
            this._optionUpdateBlocked = false;
        }, 100);
        
        const label = e.target.closest('label');
        if (!label) return;
        
        // Find the input
        let input = label.querySelector('input[type="radio"]');
        if (!input && label.hasAttribute('for')) {
            const inputId = label.getAttribute('for');
            input = product.querySelector(`#${inputId}`);
        }
        
        if (!input) return;        
        
        // Get all inputs for this option
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const isRequired = optionName === 'font-style';
        
        const optionLabel = input.dataset.optionLabel || "";
        const currentSavedLabel = product.savedCustomizationData ? product.savedCustomizationData[`${optionName}-label`] : "";
        const isAlreadySelected = !!(currentSavedLabel && currentSavedLabel === optionLabel);
        
        // Toggle selection
        if (isAlreadySelected) {
            // Already selected - handle deselection
            if (optionName === 'icon') {
                // Allow deselection for icons
                input.checked = false;
                if (product.savedCustomizationData) {
                    product.savedCustomizationData[optionName] = "";
                    product.savedCustomizationData[`${optionName}-label`] = "";
                }
                // Icon deselected: restore vertical orientation button visibility
                this.toggleBulkVerticalOrientationButton(product, true);
            }
            // For font-style and font-pattern, do nothing when already selected (prevent deselection)
        } else {
            // Select - uncheck all others first
            allInputs.forEach(opt => {
                opt.checked = false;
            });
            input.checked = true;
            
            if (product.savedCustomizationData) {
                product.savedCustomizationData[optionName] = input.dataset.optionData || "";
                product.savedCustomizationData[`${optionName}-label`] = optionLabel || "";
            }

            // When icon is selected, enforce horizontal orientation and hide vertical button
            if (optionName === 'icon') {
                const hasActualIcon = !!(input.dataset.optionData && input.dataset.optionData.trim() !== "");
                this.toggleBulkVerticalOrientationButton(product, !hasActualIcon);
                if (hasActualIcon) {
                    if (product.savedCustomizationData) {
                        product.savedCustomizationData['text-orientation'] = 'horizontal';
                    }
                    const orientationBtns = product.querySelectorAll('.text-orientation__option');
                    orientationBtns.forEach(btn => {
                        btn.classList.remove('active');
                        if (btn.dataset.role === 'horizontal') btn.classList.add('active');
                    });
                }
            }
        }
        
        // Update visual classes
        this.updateBulkOptionClasses(product, optionName);
        
        // Update canvas
        this.forceBulkCanvasUpdateWithText(product);
        
        // Dispatch event
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData},
            bubbles: true
        }));
        
        // Update validation
        this.validateAllCustomizers();
    }

    /**
     * Shows or hides the vertical text orientation button for a bulk product.
     * @param {HTMLElement} product - The product-customizer element
     * @param {boolean} visible - true to show, false to hide
     */
    toggleBulkVerticalOrientationButton(product, visible) {
        const verticalBtn = product.querySelector('.text-orientation__option[data-role="vertical"]');
        if (verticalBtn) {
            verticalBtn.style.display = visible ? '' : 'none';
        }
    }

    updateBulkOptionClasses(product, optionName) {
        if (!product) return;
        
        const inputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const selectedClass = `${optionName}-option-selected`;
        
        // Find the checked input
        let checkedInput = null;
        inputs.forEach(input => {
            if (input.checked) {
                checkedInput = input;
            }
        });
        
        // Fallback for No icon label if saved label is No icon
        if (!checkedInput && optionName === 'icon' && product.savedCustomizationData && product.savedCustomizationData["icon-label"] === "No icon") {
            inputs.forEach(input => {
                if (input.value === "No icon" || input.dataset.optionLabel === "No icon") {
                    input.checked = true;
                    checkedInput = input;
                }
            });
        }
        
        // Update all labels for this option
        const allLabels = product.querySelectorAll(
            `label[for*="${optionName}"], label[class*="${optionName}"], label:has(input[name="${optionName}"])`
        );
        
        allLabels.forEach(label => {
            // Remove selected class from all
            label.classList.remove(selectedClass);
            const span = label.querySelector('.option-preview__wrapper');
            if (span) span.classList.remove(selectedClass);
            
            // Add to the correct label
            if (checkedInput) {
                const labelForInput = checkedInput.closest('label') || 
                                    product.querySelector(`label[for="${checkedInput.id}"]`);
                if (label === labelForInput) {
                    label.classList.add(selectedClass);
                    if (span) span.classList.add(selectedClass);
                }
            }
        });
    }
    // NEW METHOD: Handle option label clicks in bulk mode
    handleBulkOptionLabelClick(e, optionName, product) {
        const label = e.currentTarget;
        
        // Find the input - handle both nested and separate cases
        let input = label.querySelector('input[type="radio"]');
        if (!input && label.hasAttribute('for')) {
            const inputId = label.getAttribute('for');
            input = product.querySelector(`#${inputId}`);
        }
        
        if (!input) {
            console.error(`❌ Could not find input for ${optionName} label:`, label);
            return;
        }
        
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel || "";
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        const currentSavedLabel = product.savedCustomizationData ? product.savedCustomizationData[`${optionName}-label`] : "";
        const isCurrentlySelected = !!(currentSavedLabel && currentSavedLabel === optionLabel);
        
        if (isCurrentlySelected && optionName !== 'font-style') {
            // Deselect (only for non-font-style options)
            input.checked = false;
            product.savedCustomizationData[optionName] = "";
            product.savedCustomizationData[`${optionName}-label`] = "";
        } else {
            // Select this one
            allInputs.forEach(opt => {
                opt.checked = false;
            });
            input.checked = true;
            product.savedCustomizationData[optionName] = optionData || "";
            product.savedCustomizationData[`${optionName}-label`] = optionLabel || "";
        }
        
        // Add selected classes
        this.addBulkOptionSelectedClass(product, optionName, input);
        
        // Force immediate rendering
        this.forceBulkCanvasUpdateWithText(product);
        
        // Dispatch event for bulk mode
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
    }
    // NEW METHOD: Handle option input changes in bulk mode
    handleBulkOptionInputChange(e, optionName, product) {
        const input = e.target;
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (input.checked) {
            product.savedCustomizationData[optionName] = optionData;
            product.savedCustomizationData[`${optionName}-label`] = optionLabel;
        } else if (optionName !== 'font-style') {
            product.savedCustomizationData[optionName] = "";
            product.savedCustomizationData[`${optionName}-label`] = "";
        }
        
        // Add selected classes
        this.addBulkOptionSelectedClass(product, optionName, input);
        
        // Force immediate rendering
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    // NEW METHOD: Add selected class to the appropriate label in bulk mode
    addBulkOptionSelectedClass(product, optionName, selectedInput) {
        // Remove selected classes from all labels first
        const allLabels = product.querySelectorAll(`label[for*="${optionName}"], label[class*="${optionName}"], label:has(input[name="${optionName}"])`);
        allLabels.forEach(label => {
            label.classList.remove(`${optionName}-option-selected`);
        });
        
        // Add selected class to the clicked label
        let selectedLabel = selectedInput.closest('label');
        if (!selectedLabel && selectedInput.id) {
            selectedLabel = product.querySelector(`label[for="${selectedInput.id}"]`);
        }
        
        if (selectedLabel) {
            selectedLabel.classList.add(`${optionName}-option-selected`);            
        }
    }
    // Add this helper method to clear option classes
    clearAllOptionClasses(product) {
        if (!product) return;
        
        // Clear font style classes
        const fontStyleLabels = product.querySelectorAll('label[class*="font-style-option-selected"]');
        fontStyleLabels.forEach(label => {
            label.classList.remove('font-style-option-selected');
        });
        
        // Clear font pattern classes
        const fontPatternLabels = product.querySelectorAll('label[class*="font-pattern-option-selected"]');
        fontPatternLabels.forEach(label => {
            label.classList.remove('font-pattern-option-selected');
        });
        
        // Clear icon classes
        const iconLabels = product.querySelectorAll('label[class*="icon-option-selected"]');
        iconLabels.forEach(label => {
            label.classList.remove('icon-option-selected');
        });
        
        // Uncheck all inputs
        const allOptionInputs = product.querySelectorAll('input[name="font-style"], input[name="font-pattern"], input[name="icon"]');
        allOptionInputs.forEach(input => {
            input.checked = false;
        });
    }
    getCustomizationRegionData() {
        // If we don't have the region data yet, create a fallback
        if (!this.customizationRegionData) {
            this.customizationRegionData = {};
            
            // Create a default region similar to single personalization
            const defaultRegion = {
                x: 1000,   // Similar to single personalization positioning
                y: 1000,   
                width: 1000,  
                height: 1000  
            };
            
            // Use the current variant ID or create a fallback
            const variantId = this.variantID || 'default';
            this.customizationRegionData[variantId] = defaultRegion;
        }
        
        // Get the region for current variant, or use default
        const region = this.customizationRegionData[this.variantID] || 
                       this.customizationRegionData['default'] || 
                       this.customizationRegionData[Object.keys(this.customizationRegionData)[0]];
        
        if (!region) {
            // Ultimate fallback - center of canvas (same as single personalization)
            return {
                x: 1000,
                y: 1000,
                width: 1000,
                height: 1000
            };
        }
        
        return region;
    }
    preserveOptionClasses(optionName) {
        const options = this.querySelectorAll(`input[name="${optionName}"]`);
        options.forEach(option => {
            if (option.checked) {
                const label = option.closest('label') || this.querySelector(`label[for="${option.id}"]`);
                if (label) {
                    // Preserve the selected class
                    label.classList.add(`${optionName}-option-selected`);
                }
            }
        });
    }
    // NEW METHOD: Check if font style is selected before adding other option classes
    shouldApplyOptionClasses(product) {
        if (!product || !product.savedCustomizationData) return false;
        return !!(product.savedCustomizationData["font-style"] && 
                product.savedCustomizationData["font-style"].trim() !== "");
    }
    
    handleBulkFontPatternChange(e, product) {
        const input = e.target;
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        const allInputs = product.querySelectorAll('input[name="font-pattern"]');
        
        if (input.checked) {
            // Already selected - do nothing (prevent deselection)
            return;
        } else {
            // Uncheck all other options and remove their classes
            allInputs.forEach(option => {
                if (option !== input) {
                    option.checked = false;
                    this.removeOptionSelectedClass(product, 'font-pattern', option);
                }
            });
            
            // Select this option
            input.checked = true;
            
            // Update customization data
            product.savedCustomizationData["font-pattern"] = optionData;
            product.savedCustomizationData["font-pattern-label"] = optionLabel;
            
            // CRITICAL: Add the selected class
            this.addOptionSelectedClass(product, 'font-pattern', input);
        }
        
        // Force immediate canvas update
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    getBottleImageForProduct(product) {
        const customizer = product?.tagName === 'PRODUCT-CUSTOMIZER'
            ? product
            : product?.querySelector?.('product-customizer');
        
        const productImg = customizer?.productImg;
        
        if (productImg) {
            if (productImg.complete && productImg.naturalWidth > 0) {
                return productImg;
            }
            
            productImg.addEventListener('load', () => {
                if (productImg.naturalWidth > 0) {
                    this.blankBottleImage = productImg;
                    if (product) {
                        this.forceBulkCanvasUpdateWithText(product);
                    }
                }
            }, { once: true });
        }
        
        if (this.blankBottleImage && this.blankBottleImage.complete) {
            return this.blankBottleImage;
        }
        
        return null;
    }
    // Improved canvas rendering with retry mechanism
    forceBulkCanvasUpdateWithText(product) {
        if (!product) return;
        
        // Get current variant's image
        let productImg = this.blankBottleImage;
        
        // If we don't have an image, try to get it from the current variant
        if (!productImg || !productImg.complete) {
            if (this.variantID) {
                const variantsImgScript = document.body.querySelector("#variantPersonalizationImage");
                if (variantsImgScript) {
                    const variantsPersonalizationImages = JSON.parse(variantsImgScript.textContent || '{}');
                    const imageUrl = variantsPersonalizationImages[this.variantID];
                    
                    if (imageUrl) {
                        productImg = new Image();
                        productImg.crossOrigin = "anonymous";
                        productImg.src = imageUrl;
                        productImg.onload = () => {
                            this.blankBottleImage = productImg;
                            this.redrawAllCanvasesForProduct(product, productImg);
                        };
                        return;
                    }
                }
            }
        }
        
        // If we have an image, redraw
        if (productImg && productImg.complete) {
            this.redrawAllCanvasesForProduct(product, productImg);
        }
    }
    // Add this method to sync from single to bulk
syncFromSinglePersonalization() {
    // Get current variant from single personalization
    const singleModal = document.querySelector('.single-personalization-modal');
    if (!singleModal) return;
    
    const singlePersonalization = singleModal.querySelector('single-personalization');
    if (!singlePersonalization || !singlePersonalization.variantID) return;
    
    const singleVariantId = singlePersonalization.variantID;
    
    if (singleVariantId && singleVariantId !== this.variantID) {
        this.updateVariantForBulk(singleVariantId);
    }
}
    // Add this method to periodically refresh option classes
    startOptionClassRefresh() {
        // Refresh every 2 seconds to ensure classes stay applied
        this.optionRefreshInterval = setInterval(() => {
            this.products.forEach(productObj => {
                const product = productObj.product;
                if (product && product.savedCustomizationData) {
                    this.ensureBulkOptionClasses(product);
                }
            });
        }, 2000);
    }

    // Don't forget to clear the interval when component is disconnected
    disconnectedCallback() {
        // Clean up bulk handlers
        this.products.forEach(productObj => {
            if (productObj.product) {
                this.cleanupProductHandlers(productObj.product);
            }
        });
        
        this._bulkOptionHandlers.clear();
        
        // Call parent cleanup
        super.disconnectedCallback?.();
    }
    
    // NEW METHOD: Create emergency canvas when missing
    createEmergencyCanvasForProduct(product, canvasId, text = '') {
        const canvas = document.createElement('canvas');
        canvas.id = canvasId;
        canvas.width = 3000;
        canvas.height = 3000;
        canvas.style.display = 'none';
        
        const container = product.querySelector('.canvas-container') || 
                         product.querySelector('.customization-steps-container') ||
                         product;
        container.appendChild(canvas);
        
        this.emergencyCanvasRender(canvas, text);
    }

    renderBulkCanvasWithTextAndPattern(product, canvas, text, fontPattern) {
        if (!canvas) {
            console.error('❌ Canvas is null');
            return;
        }
        
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            console.error('❌ Canvas context is null');
            return;
        }
        
        // STEP 1: Clear canvas completely
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // STEP 2: Always draw the bottle image first
        const bottleImage = this.getBottleImageForProduct(product);
        
        if (bottleImage && bottleImage.complete) {
            this.processCanvasImage(canvas, ctx, bottleImage);
        } else {
            // Create a simple fallback background
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            
            // Draw a simple bottle outline so user knows it's working
            ctx.strokeStyle = '#dee2e6';
            ctx.lineWidth = 10;
            ctx.strokeRect(canvas.width * 0.2, canvas.height * 0.1, canvas.width * 0.6, canvas.height * 0.8);
        }
        
        // STEP 3: Only draw text if it exists (this won't affect the bottle image)
        if (text && text.trim() !== '') {            
            // Get orientation from product data
            const orientation = product.savedCustomizationData?.["text-orientation"] || "horizontal";
            const fontStyle = product.savedCustomizationData?.["font-style"] || '';
            const iconUrl = product.savedCustomizationData?.["icon"] || '';
            
            // Use the same rendering logic as single personalization
            this.drawTextAndIconOnCanvas(ctx, canvas, text, fontPattern, orientation, fontStyle, iconUrl);
        } else {
            console.log('📝 No text to draw, showing bottle only');
        }
        
    }

    // Add this helper method to safely query elements
    safeQuerySelector(element, selector) {
        try {
            return element.querySelector(selector);
        } catch (error) {
            console.error(`❌ Invalid selector: ${selector}`, error);
            return null;
        }
    }

    // Update the addProduct method to use safe queries
    addProduct() {
        if (this.products.length >= MAX_PRODUCTS) return;
        if (!this.newCustomizerTemplate || !this.tabTemplate) return;
        
        const newProduct = this.newCustomizerTemplate.content.cloneNode(true).querySelector("product-customizer");
        newProduct.dataset.initialVariantId = this.variantID;
        
        const newProductIndex = this.products.length + 1;
        
        this.productsContainer.appendChild(newProduct);
        
        const mainTab = this.createProductTab(newProductIndex);
        
        this.products.push({ product: newProduct, tab: mainTab });
        
        this.setProductQuantity(newProduct, 1);
        
        this.setupBulkActionWrapperEvent(newProduct.querySelector(".personalized-actions__wrapper"));
        
        const newBulkBtn = newProduct.querySelector(".bulk-add--button");
        if (newBulkBtn) this.addBulkToggleEvent(newBulkBtn);
        
        const newBulkCloseBtn = newProduct.querySelector(".bulk-personalization-close--button");
        if (newBulkCloseBtn) this.setupBulkCloseEvent(newBulkCloseBtn);
        
        this.attachTabEvents(mainTab);
        
        const newBulkATCBtn = newProduct.querySelector("button[data-action=bulk-add-to-cart]")
        this.setupAddToCartEvent(newBulkATCBtn);
        
        // FIXED: Always check stock status when adding product
        if (!this.bulkATCLabel) {
            this.bulkATCLabel = newBulkATCBtn.textContent;
            newBulkATCBtn.dataset.originalText = newBulkATCBtn.textContent;
        }
        
        // Match single personalization styling for out of stock
        if (this.availableVariantQuantity < 1) {
            newBulkATCBtn.textContent = "Out of stock";
            newBulkATCBtn.classList.add('bs-cursor-not-allowed');
            newBulkATCBtn.disabled = true;
            newBulkATCBtn.setAttribute('disabled', 'disabled');
            newBulkATCBtn.style.opacity = '0.5';
            newBulkATCBtn.style.cursor = 'not-allowed';
            newBulkATCBtn.style.pointerEvents = 'none';
        } else {
            newBulkATCBtn.textContent = this.bulkATCLabel;
            newBulkATCBtn.classList.remove('bs-cursor-not-allowed');
            newBulkATCBtn.disabled = false;
            newBulkATCBtn.removeAttribute('disabled');
            newBulkATCBtn.style.opacity = '';
            newBulkATCBtn.style.cursor = '';
            newBulkATCBtn.style.pointerEvents = '';
        }
        
        // UPDATE allBulkATCBtns when adding a product
        this.allBulkATCBtns = this.querySelectorAll("button[data-action=bulk-add-to-cart]");
        
        // Initialize quantity selectors and button states
        this.setupProductQuantitySelectors(newProduct);
            
        // Initialize button states for the new product
        const quantityInputs = newProduct.querySelectorAll('.bulk-quantity-input');
        quantityInputs.forEach(input => {
            const currentQuantity = parseInt(input.value) || 1;
            const container = input.closest('.bulk-quantity-selector');
            if (container) {
                const minusBtn = container.querySelector('[data-role="minus"]');
                const plusBtn = container.querySelector('[data-role="plus"]');
                if (minusBtn && plusBtn) {
                    this.updateQuantityButtonStates(minusBtn, plusBtn, currentQuantity);
                }
            }
        });
        
        this.initializeTabsForAllStepsInAllProducts();
        this.initializeMainDesktopTabs();
        this.updateAllDropdownButtons();
        
        this.setupBulkProductValidation(newProduct);
        
        if (this.products.length === 1) {
            setTimeout(() => {
                this.firstProductInview();
            }, 100);
        }
        
        setTimeout(() => {
            this.setupProductPreviewButtons();
        }, 50);
        
        return newProduct;
    }

    drawTextAndIconOnCanvas(ctx, canvas, text, fontPattern, orientation = "horizontal", fontStyle = '', iconUrl = '') {
        if (!text && !iconUrl) {
            return;
        }
    
        // Get customization region data (same as single personalization)
        const customizationRegion = this.getCustomizationRegionData();
        if (!customizationRegion) {
            console.error('❌ No customization region found');
            return;
        }
    
        let textSize = 190;
        let iconHeight = 0;
        let padding = customizationRegion.height * 0.05;
    
        // Convert icon to white (same as single personalization)
        const convertIconToWhite = (icon, targetWidth, targetHeight) => {
            const tempCanvas = document.createElement("canvas");
            const tempCtx = tempCanvas.getContext("2d");
            tempCanvas.width = targetWidth;
            tempCanvas.height = targetHeight;
    
            tempCtx.drawImage(icon, 0, 0, targetWidth, targetHeight);
            let imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
            let data = imageData.data;
    
            for (let i = 0; i < data.length; i += 4) {
                if (data[i + 3] > 0) {
                    data[i] = 255;
                    data[i + 1] = 255;
                    data[i + 2] = 255;
                }
            }
    
            tempCtx.putImageData(imageData, 0, 0);
            return tempCanvas;
        };
        
        const drawIcon = () => {
            return new Promise((resolve) => {
                if (iconUrl) {
                    const icon = new Image();
                    icon.crossOrigin = "anonymous";
                    icon.onload = () => {
                        // Increase bounding region for larger icon display while preserving natural aspect ratio
                        const hasText = text && text.trim() !== "";
                        const maxW = customizationRegion.width * 0.8;
                        const maxH = customizationRegion.height * (hasText ? 0.55 : 0.75);
                        const aspectRatio = icon.naturalHeight / icon.naturalWidth;
                        
                        let iconDrawWidth = maxW;
                        let iconDrawHeight = iconDrawWidth * aspectRatio;
                        
                        if (iconDrawHeight > maxH) {
                            iconDrawHeight = maxH;
                            iconDrawWidth = iconDrawHeight / aspectRatio;
                        }
                        
                        const iconX = customizationRegion.x + (customizationRegion.width - iconDrawWidth) / 2;
                        
                        let iconY;
                        if (orientation === "vertical") {
                            iconY = customizationRegion.y + customizationRegion.height * 0.15;
                        } else {
                            iconY = customizationRegion.y;
                        }
                        
                        const whiteIcon = convertIconToWhite(icon, iconDrawWidth, iconDrawHeight);
                        ctx.drawImage(whiteIcon, iconX, iconY, iconDrawWidth, iconDrawHeight);
                        
                        if (orientation === "vertical") {
                            iconHeight = iconDrawHeight + customizationRegion.height * 0.05;
                        } else {
                            iconHeight = iconDrawHeight + customizationRegion.height * 0.05;
                        }
                        resolve();
                    };
                    icon.onerror = () => {
                        console.error('❌ Failed to load icon:', iconUrl);
                        iconHeight = padding;
                        resolve();
                    };
                    icon.src = iconUrl;
                } else {
                    iconHeight = padding;
                    resolve();
                }
            });
        };
        
    
        const drawText = () => {
            if (!text) return;
            
            ctx.save();
        
            let fontWeight = orientation === "vertical" ? "bold" : "normal";
            let fontFamily = fontStyle || 'Arial, sans-serif';
                            
            ctx.font = `${fontWeight} ${textSize}px ${fontFamily}`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
        
            let textWidth = ctx.measureText(text).width;
            let textHeight = textSize;
        
            if (orientation === "vertical") {
                const availableHeight = customizationRegion.height * (iconUrl ? 0.6 : 0.8);
                if (textWidth > availableHeight) {
                    textSize *= availableHeight / textWidth;
                    ctx.font = `${fontWeight} ${textSize}px ${fontFamily}`;
                    textWidth = ctx.measureText(text).width;
                    textHeight = textSize;
                }
            } else {
                if (textWidth > customizationRegion.width * 0.9) {
                    textSize *= (customizationRegion.width * 0.9) / textWidth;
                    ctx.font = `${fontWeight} ${textSize}px ${fontFamily}`;
                    textWidth = ctx.measureText(text).width;
                    textHeight = textSize;
                }
            }
        
            let textX = customizationRegion.x + customizationRegion.width / 2;
            let textY = customizationRegion.y + iconHeight + padding;
        
            if (orientation === "vertical") {
                let translateY;
                if (iconUrl) {
                    const iconBottom = customizationRegion.y + (customizationRegion.height * 0.15) + iconHeight;
                    
                    translateY = iconBottom + (customizationRegion.height * 0.25);
                } else {
                    translateY = customizationRegion.y + (customizationRegion.height / 2);
                }
            
                ctx.translate(customizationRegion.x + customizationRegion.width / 2 + 10, translateY);
                ctx.rotate(-Math.PI / 2);
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                textX = 0;
                textY = 0;
            }
        
            if (fontPattern) {
                const patternImg = new Image();
                patternImg.crossOrigin = "anonymous";
                patternImg.onload = () => {
                    const patternCanvas = document.createElement("canvas");
                    const patternCtx = patternCanvas.getContext("2d");
                    patternCanvas.width = customizationRegion.width * 1.1;
                    patternCanvas.height = textHeight * 1.1;
                    patternCtx.drawImage(patternImg, 0, 0, customizationRegion.width * 1.1, orientation === "vertical" ? customizationRegion.height * 1.1 : textHeight * 1.1);
                    const pattern = ctx.createPattern(patternCanvas, "repeat");
                    ctx.fillStyle = pattern;
                    
                    const finalX = orientation === "vertical" ? textX : textX;
                    const finalY = orientation === "vertical" ? textY : textY;
                    
                    ctx.fillText(text, finalX, finalY);
                    ctx.restore();
                };
                patternImg.onerror = () => {
                    console.error('❌ Failed to load font pattern, using white text');
                    ctx.fillStyle = "#fff";
                    
                    const finalX = orientation === "vertical" ? textX : textX;
                    const finalY = orientation === "vertical" ? textY : textY;
                    
                    ctx.fillText(text, finalX, finalY);
                    ctx.restore();
                };
                patternImg.src = fontPattern;
            } else {
                ctx.fillStyle = "#fff";
                
                const finalX = orientation === "vertical" ? textX : textX;
                const finalY = orientation === "vertical" ? textY : textY;
                
                ctx.fillText(text, finalX, finalY);
                ctx.restore();
            }
        };
    
        if (iconUrl) {
            drawIcon().then(() => {
                drawText();
            });
        } else {
            drawText();
        }
    }

    processCanvasImage(canvas, ctx, productImage) {
        const aspectRatio = productImage.width / productImage.height;
        const canvasAspectRatio = canvas.width / canvas.height;
        let drawWidth, drawHeight, offsetX, offsetY;
    
        if (aspectRatio > canvasAspectRatio) {
            drawWidth = canvas.width;
            drawHeight = drawWidth / aspectRatio;
            offsetX = 0;
            offsetY = (canvas.height - drawHeight) / 2;
        } else {
            drawHeight = canvas.height;
            drawWidth = drawHeight * aspectRatio;
            offsetX = (canvas.width - drawWidth) / 2;
            offsetY = 0;
        }
    
        ctx.drawImage(productImage, offsetX, offsetY, drawWidth, drawHeight);
    }
    
    // NEW METHOD: Force canvas update with all customization data
    forceBulkCanvasUpdate(product) {
        if (!product) return;
        
        const customizationData = product.savedCustomizationData || {};
        const text = customizationData["personalized-text"] || "";
        const fontPattern = customizationData["font-pattern"] || "";        
        const currentStep = this.getCurrentlyActiveStep(product);
        const stepType = currentStep ? currentStep.dataset.step : 'text';
        
        // Update the current step canvas
        const currentCanvas = this.getCurrentStepCanvas(product, stepType);
        if (currentCanvas) {
            this.renderBulkCanvasWithPattern(product, currentCanvas, text, fontPattern);
        }
        
        // Also update main canvas
        const mainCanvas = product.querySelector('#mainPersonalizationCanvas');
        if (mainCanvas && mainCanvas !== currentCanvas) {
            this.renderBulkCanvasWithPattern(product, mainCanvas, text, fontPattern);
        }
    }
    
    // NEW METHOD: Render canvas with font pattern for bulk mode
    renderBulkCanvasWithPattern(product, canvas, text, fontPattern) {
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        
        // Clear canvas completely
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw product image
        const bottleImage = this.getBottleImageForProduct(product);
        
        if (bottleImage && bottleImage.complete) {
            this.processCanvasImage(canvas, ctx, bottleImage);
        } else {
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        
        // CRITICAL FIX: Always draw text if it exists
        if (text && text.trim() !== '') {
            if (fontPattern && fontPattern.trim() !== '') {
                this.drawTextWithPattern(ctx, text, fontPattern, canvas.width, canvas.height);
            } else {
                // Fallback to regular text if no pattern or pattern fails
                this.drawTextOnCanvas(ctx, text, canvas.width, canvas.height);
            }
        }
    }
    
    drawTextWithPattern(ctx, text, fontPattern, width, height, orientation = "horizontal") {
        if (!text || !fontPattern) {
            this.drawTextOnCanvas(ctx, text, width, height, orientation);
            return;
        }
                
        const customizationRegion = this.getCustomizationRegionData();
        
        let centerX, centerY;
        
        if (customizationRegion) {
            centerX = customizationRegion.x + (customizationRegion.width / 2);
            centerY = customizationRegion.y + (customizationRegion.height / 2);
        } else {
            centerX = width / 2;
            centerY = height / 2;
        }
        
        // Use larger, consistent font size
        const textStyle = {
            fontSize: '120px',
            fontFamily: 'Arial, sans-serif',
            fontWeight: 'bold'
        };
        
        ctx.font = `${textStyle.fontWeight} ${textStyle.fontSize} ${textStyle.fontFamily}`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        
        // Load and apply font pattern with error handling
        const patternImg = new Image();
        patternImg.crossOrigin = 'anonymous';
        
        patternImg.onload = () => {
            try {
                // IMPORTANT: Save the current canvas state
                ctx.save();
                
                // Handle orientation
                if (orientation === "vertical") {
                    ctx.translate(centerX, centerY);
                    ctx.rotate(-Math.PI / 2); // -90 degrees
                    ctx.translate(-centerX, -centerY);
                }
                
                // Create pattern - this should ONLY affect the text fill, not the background
                const pattern = ctx.createPattern(patternImg, 'repeat');
                
                // Set the pattern as fill style for TEXT ONLY
                ctx.fillStyle = pattern;
                
                // Draw text with pattern - this should NOT affect the background image
                ctx.fillText(text, centerX, centerY);
                
                // Add stroke for better visibility
                ctx.strokeStyle = '#ffffff';
                ctx.lineWidth = 4;
                ctx.strokeText(text, centerX, centerY);
                
                // Restore the canvas state to prevent pattern from affecting other draws
                ctx.restore();                
            } catch (error) {
                console.error('❌ Pattern application failed, using fallback:', error);
                
                // Restore state if error occurred
                ctx.restore();
                this.drawTextOnCanvas(ctx, text, width, height, orientation);
            }
        };
        
        patternImg.onerror = () => {
            console.error('❌ Failed to load pattern image, using fallback:', fontPattern);
            // Fallback to regular text
            this.drawTextOnCanvas(ctx, text, width, height, orientation);
        };
        
        patternImg.src = fontPattern;
    }
   
    handleBulkOrientationChange(e, product) {
        const button = e.currentTarget;
        const orientation = button.dataset.role;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        const orientationButtons = product.querySelectorAll('.text-orientation__option');
        orientationButtons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");
        
        product.savedCustomizationData["text-orientation"] = orientation;

        // When vertical orientation is chosen, clear icon selection and hide icon section
        if (orientation === 'vertical') {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(iconInput => { iconInput.checked = false; });
            product.savedCustomizationData['icon'] = '';
            product.savedCustomizationData['icon-label'] = '';
            if (product.personalizationProperties) {
                product.personalizationProperties['icon-label'] = '';
            }
            this.toggleBulkIconSectionVisibility(product, false);
        } else {
            // Horizontal selected: restore icon section visibility
            this.toggleBulkIconSectionVisibility(product, true);
        }
        
        // CRITICAL: Update the canvas with the new orientation
        const currentText = product.savedCustomizationData["personalized-text"] || "";
        if (currentText) {
            this.forceBulkCanvasUpdateWithText(product);
        }
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange'));
    }

    /**
     * Shows or hides the icon personalization step and its tab buttons for a bulk product.
     * @param {HTMLElement} product - The product-customizer element
     * @param {boolean} visible
     */
    toggleBulkIconSectionVisibility(product, visible) {
        const iconStep = product.querySelector('.personalization-step[data-step="icon"]');
        if (iconStep) {
            iconStep.style.display = visible ? '' : 'none';
        }
        const iconTabButtons = product.querySelectorAll('.tab-button[data-tab="icon"]');
        iconTabButtons.forEach(tabBtn => {
            tabBtn.style.display = visible ? '' : 'none';
        });
    }
    updateAllProductsTabContainers() {        
        this.products.forEach(productObj => {
            const product = productObj.product;
            
            const steps = product.querySelectorAll('.personalization-step');
            
            steps.forEach(step => {
                const stepType = step.dataset.step;
                
                const desktopTabsContainer = step.querySelector('.desktop-product-tabs-container .product-tabs__container');
                const mobileTabsContainer = step.querySelector('.mobile-product-tabs-container .product-tabs__container');
                
                if (desktopTabsContainer) {
                    desktopTabsContainer.innerHTML = '';
                    this.products.forEach((prodObj, index) => {
                        const desktopTab = this.createProductTab(index + 1);
                        desktopTabsContainer.appendChild(desktopTab);
                        this.attachTabEvents(desktopTab);
                    });
                }
                
                if (mobileTabsContainer) {
                    mobileTabsContainer.innerHTML = '';
                    this.products.forEach((prodObj, index) => {
                        const mobileTab = this.createProductTab(index + 1);
                        mobileTabsContainer.appendChild(mobileTab);
                        this.attachTabEvents(mobileTab);
                    });
                }
            });
        });
        
        if (this.products.length > 0) {
            const currentTabLabel = this.products[this.currentProductIndex]?.tab.querySelector('.tab--label').textContent;
            if (currentTabLabel) {
                this.activateTabInAllStepsOfAllProducts(currentTabLabel);
            }
        }
    }

    updateProductTabContainer(product) {
        if (!product) return;
        
        const desktopTabsContainer = product.querySelector('.desktop-product-tabs-container .product-tabs__container');
        const mobileTabsContainer = product.querySelector('.mobile-product-tabs-container .product-tabs__container');
        
        if (!desktopTabsContainer || !mobileTabsContainer) return;
        
        desktopTabsContainer.innerHTML = '';
        mobileTabsContainer.innerHTML = '';
        
        this.products.forEach((productObj, index) => {
            const tabLabel = `${index + 1}`;
            
            const desktopTab = this.createProductTab(index + 1);
            const mobileTab = this.createProductTab(index + 1);
            
            desktopTabsContainer.appendChild(desktopTab);
            mobileTabsContainer.appendChild(mobileTab);
            
            this.attachTabEvents(desktopTab);
            this.attachTabEvents(mobileTab);
        });
    }

    addTabToAllContainers(mainTab, tabLabel) {
        const desktopProductTabsContainers = this.querySelectorAll(".desktop-product-tabs-container .product-tabs__container");
        const mobileProductTabsContainers = this.querySelectorAll(".mobile-product-tabs-container .product-tabs__container");
    
        mainTab.querySelector('.tab--label').textContent = tabLabel;
    
        desktopProductTabsContainers.forEach(container => {
            const tabClone = mainTab.cloneNode(true);
            tabClone.querySelector('.tab--label').textContent = tabLabel;
            container.appendChild(tabClone);
            this.attachTabEvents(tabClone);
        });
    
        mobileProductTabsContainers.forEach(container => {
            const tabClone = mainTab.cloneNode(true);
            tabClone.querySelector('.tab--label').textContent = tabLabel;
            container.appendChild(tabClone);
            this.attachTabEvents(tabClone);
        });
    }

    updateAllDropdownButtons() {
        const dropdownButtons = this.querySelectorAll('.select-dropdown__button .selected-product--quantity');
        dropdownButtons.forEach(button => {
            if (this.products.length === 1) {
                // When we have exactly 1 product, show "Select Quantity" as placeholder
                button.textContent = 'Select Quantity';
            } else if (this.products.length > 1) {
                // When we have more than 1 product, show the actual count
                button.textContent = `${this.products.length} Product${this.products.length > 1 ? 's' : ''}`;
            } else {
                // Fallback (shouldn't happen)
                button.textContent = 'Select Quantity';
            }
        });
    }

    deactivateAllTabs() {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        allTabs.forEach(tab => {
            tab.classList.remove("active");
            tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
        });
    }

    firstProductInview() {
        if (this.products.length === 0) return;
        
        const firstProduct = this.products[0].product;
        
        this.updateTabLabels();
        
        const firstProductLabel = this.products[0].tab.querySelector('.tab--label').textContent;
        
        this.initializeMainDesktopTabs();
        this.activateTabInAllStepsOfAllProducts(firstProductLabel);
        
        this.products.forEach((p, index) => {
            if (index === 0) {
                p.product.classList.remove("slide-right", "hidden-block");
                p.product.classList.add("inview");
            } else {
                p.product.classList.remove("inview");
                p.product.classList.add("hidden-block");
            }
        });
        
        this.lastActiveTab = this.products[0].tab;
        this.lastActiveProduct = this.products[0].product;
        this.currentProductIndex = 0;
        
        this.setupScrollNavigationForProduct(this.products[0].product);
        
    }
    updateAllProductsCompletionStatus() {
        this.products.forEach((productObj, index) => {
            this.markProductAsCompleted(index);
        });
    }
    // Add this method to refresh classes when switching between products
    refreshProductOptionClasses(product) {
        if (!product) return;
                
        // Remove all existing selected classes first
        const allSelectedLabels = product.querySelectorAll('[class*="-option-selected"]');
        allSelectedLabels.forEach(label => {
            label.classList.remove('font-style-option-selected', 'font-pattern-option-selected', 'icon-option-selected');
        });
        
        // Uncheck all inputs
        const allOptionInputs = product.querySelectorAll('input[name="font-style"], input[name="font-pattern"], input[name="icon"]');
        allOptionInputs.forEach(input => {
            input.checked = false;
        });
        
        // Re-apply based on saved data
        this.ensureOptionClassesAreApplied(product);
    }

    // Update the switchProduct method
    switchProduct(selectedTab) {
        if (this.isPreviewMode) return;
        
        this.isProcessingNext = true;
        const selectedTabLabel = selectedTab.querySelector('.tab--label').textContent;
        const productIndex = parseInt(selectedTabLabel) - 1;
        
        
        if (productIndex >= 0 && productIndex < this.products.length) {
            this.showProductByIndex(productIndex);
        }
        
        this.isProcessingNext = false;
        this.scrollToTop();
    }

    activateTabInCurrentProduct(currentProduct, tabLabel) {
        if (!currentProduct) return;
        
        const allTabs = currentProduct.querySelectorAll('.products-switcher--tab');
        
        allTabs.forEach(tab => {
            const labelElement = tab.querySelector('.tab--label');
            if (labelElement) {
                const currentLabel = labelElement.textContent;
                
                if (currentLabel === tabLabel) {
                    tab.classList.add("active");
                    if (this.products.length >= 2) {
                        tab.querySelector(".delete-svg__wrapper")?.classList.add("active");
                    }
                    tab.querySelector(".empty-svg__wrapper")?.classList.remove("active");
                } else {
                    tab.classList.remove("active");
                    tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
                }
            }
        });
    }

    updateCurrentProductTabContainer(currentProduct) {
        if (!currentProduct) return;
        
        const desktopTabsContainer = currentProduct.querySelector('.desktop-product-tabs-container .product-tabs__container');
        const mobileTabsContainer = currentProduct.querySelector('.mobile-product-tabs-container .product-tabs__container');
        
        if (!desktopTabsContainer || !mobileTabsContainer) {
            return;
        }
        
        desktopTabsContainer.innerHTML = '';
        mobileTabsContainer.innerHTML = '';
        
        this.products.forEach((productObj, index) => {
            const tabLabel = `${index + 1}`;
            
            const desktopTab = this.createProductTab(index + 1);
            const mobileTab = this.createProductTab(index + 1);
            
            desktopTabsContainer.appendChild(desktopTab);
            mobileTabsContainer.appendChild(mobileTab);
            
            this.attachTabEvents(desktopTab);
            this.attachTabEvents(mobileTab);
            
            if (productObj.tab && productObj.tab.querySelector('.tab--label').textContent === tabLabel) {
                productObj.tab = desktopTab;
            }
        });
    }
    
    getAllTabInstancesByLabel(tabLabel) {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        const matchingTabs = [];
        
        allTabs.forEach(tab => {
            const labelElement = tab.querySelector('.tab--label');
            if (labelElement && labelElement.textContent === tabLabel) {
                matchingTabs.push(tab);
            }
        });
        
        return matchingTabs;
    }
    markProductAsCompleted(productIndex) {
        if (productIndex < 0 || productIndex >= this.products.length) return;
        
        const productObj = this.products[productIndex];
        if (!productObj) return;
        
        const product = productObj.product;
        const tab = productObj.tab;
        
        const { icon, "personalized-text": personalizedText } = product.savedCustomizationData || {};
        const hasCustomization = (icon?.trim() !== "") || (personalizedText?.trim() !== "");
        
        if (hasCustomization) {
            const tabLabel = tab.querySelector('.tab--label').textContent;
            this.addCompletedClassToTab(tabLabel);
        } else {
            const tabLabel = tab.querySelector('.tab--label').textContent;
            this.removeCompletedClassFromTab(tabLabel);
        }
    }
    
    
    addCompletedClassToTab(tabLabel) {
        const allTabInstances = this.getAllTabInstancesByLabel(tabLabel);
        allTabInstances.forEach(tab => {
            tab.classList.add("product-completed");
        });
    }
    
    removeCompletedClassFromTab(tabLabel) {
        const allTabInstances = this.getAllTabInstancesByLabel(tabLabel);
        allTabInstances.forEach(tab => {
            tab.classList.remove("product-completed");
        });
    }

    activateTabByLabel(tabLabel) {        
        const allTabInstances = this.getAllTabInstancesByLabel(tabLabel);
        
        allTabInstances.forEach(tab => {
            tab.classList.add("active");
            if (this.products.length >= 2) {
                tab.querySelector(".delete-svg__wrapper")?.classList.add("active");
            }
            tab.querySelector(".empty-svg__wrapper")?.classList.remove("active");
            
            const labelElement = tab.querySelector('.tab--label');
            if (labelElement) {
                labelElement.style.display = 'block';
                labelElement.style.visibility = 'visible';
                labelElement.style.opacity = '1';
            }
        });
        
        this.deactivateAllOtherTabs(tabLabel);
    }

    deactivateAllOtherTabs(activeTabLabel) {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        
        allTabs.forEach(tab => {
            const labelElement = tab.querySelector('.tab--label');
            if (labelElement && labelElement.textContent !== activeTabLabel) {
                tab.classList.remove("active");
                tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
            }
        });
    }

    deactivateTab(tabToDeactivate) {
        const tabLabel = tabToDeactivate.querySelector('.tab--label').textContent;
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        
        allTabs.forEach(tab => {
            if (tab.querySelector('.tab--label').textContent === tabLabel) {
                tab.classList.remove("active");
                tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
            }
        });
    }
    
    deleteProduct(tabElement, resetAction = false) {
        if (!tabElement) {
            return;
        }
        
        const tabLabel = tabElement.querySelector('.tab--label')?.textContent;
        if (!tabLabel) {
            return;
        }
        
        this.deleteProductByLabel(tabLabel);
    }
    
    removeTabByLabel(tabLabel) {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        let removedCount = 0;
        
        allTabs.forEach(tab => {
            const labelElement = tab.querySelector('.tab--label');
            if (labelElement && labelElement.textContent === tabLabel) {
                tab.remove();
                removedCount++;
            }
        });
        
    }
    updateTabLabels() {
        
        this.products.forEach((item, index) => {
            const newLabel = `${index + 1}`;
            const oldLabel = item.tab.querySelector(".tab--label").textContent;
            
            
            this.updateTabLabelInstances(oldLabel, newLabel);
            item.tab.querySelector(".tab--label").textContent = newLabel;
            item.tab.querySelector(".tab--label").style.display = 'block';
            item.tab.querySelector(".tab--label").style.visibility = 'visible';
            item.tab.querySelector(".tab--label").style.opacity = '1';
        });
    }

    updateTabLabelInstances(oldLabel, newLabel) {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        allTabs.forEach(tab => {
            const labelElement = tab.querySelector('.tab--label');
            if (labelElement && labelElement.textContent === oldLabel) {
                labelElement.textContent = newLabel;
                labelElement.style.display = 'block';
                labelElement.style.visibility = 'visible';
                labelElement.style.opacity = '1';
            }
        });
    }

    getCurrentStepCanvas(product, stepType) {
        if (!product) return null;
        
        let canvas = null;
        switch(stepType) {
            case 'text':
                canvas = product.querySelector('#personalizationCanvas');
                break;
            case 'font-style':
                canvas = product.querySelector('#personalizationCanvasFontStyle');
                break;
            case 'font-pattern':
                canvas = product.querySelector('#personalizationCanvasFontPattern');
                break;
            case 'icon':
                canvas = product.querySelector('#personalizationCanvasIcon');
                break;
            default:
                canvas = product.querySelector('#mainPersonalizationCanvas');
        }
        
        if (!canvas) {
            canvas = product.querySelector('#mainPersonalizationCanvas');
        }
        
        return canvas;
    }

    renderCanvasForStep(product, stepType) {
        if (!product) return;
        
        
        const canvas = this.getCurrentStepCanvas(product, stepType);
        if (!canvas) {
            console.warn('❌ Canvas not found for step:', stepType);
            return;
        }
        
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        const bottleImage = this.getBottleImageForProduct(product);
        
        if (bottleImage && bottleImage.complete) {
            this.processCanvasImage(canvas, ctx, bottleImage);
        } else {
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        
        const customizationData = product.savedCustomizationData || {};
        
        switch(stepType) {
            case 'text':
                if (customizationData['personalized-text']) {
                    this.drawTextOnCanvas(ctx, customizationData['personalized-text'], canvas.width, canvas.height);
                }
                break;
                
            case 'font-style':
                if (customizationData['personalized-text']) {
                    this.drawTextOnCanvas(ctx, customizationData['personalized-text'], canvas.width, canvas.height);
                }
                break;
                
            case 'font-pattern':
                if (customizationData['personalized-text']) {
                    this.drawTextOnCanvas(ctx, customizationData['personalized-text'], canvas.width, canvas.height);
                }
                break;
                
            case 'icon':
                if (customizationData['icon']) {
                    this.drawIconOnCanvas(ctx, customizationData['icon'], canvas, product);
                } else if (customizationData['personalized-text']) {
                    this.drawTextOnCanvas(ctx, customizationData['personalized-text'], canvas.width, canvas.height);
                }
                break;
                
            default:
                if (customizationData['icon']) {
                    this.drawIconOnCanvas(ctx, customizationData['icon'], canvas, product);
                } else if (customizationData['personalized-text']) {
                    this.drawTextOnCanvas(ctx, customizationData['personalized-text'], canvas.width, canvas.height);
                }
        }
    }
    drawIconOnCanvas(ctx, iconUrl, canvas, product = null) {
        if (!iconUrl || !canvas) return;
        
        const width = canvas.width;
        const height = canvas.height;
        
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            ctx.clearRect(0, 0, width, height);
            
            const bottleImage = this.getBottleImageForProduct(product);
            
            if (bottleImage && bottleImage.complete) {
                this.processCanvasImage(canvas, ctx, bottleImage);
            } else {
                ctx.fillStyle = '#f8f9fa';
                ctx.fillRect(0, 0, width, height);
            }
            
            const maxBox = Math.min(width, height) * 0.85;
            let drawW = maxBox;
            let drawH = maxBox;
            if (img.naturalWidth && img.naturalHeight) {
                const aspectRatio = img.naturalHeight / img.naturalWidth;
                if (aspectRatio > 1) {
                    drawH = maxBox;
                    drawW = maxBox / aspectRatio;
                } else {
                    drawW = maxBox;
                    drawH = maxBox * aspectRatio;
                }
            }
            const x = (width - drawW) / 2;
            const y = (height - drawH) / 2;
            
            ctx.drawImage(img, x, y, drawW, drawH);
        };
        img.onerror = () => {
            console.error('Failed to load icon:', iconUrl);
            this.drawIconPlaceholder(ctx, width, height);
        };
        img.src = iconUrl;
    }
    showProductSelectionUI() {
        this.currentProductIndex = 0;
        this.isPreviewMode = false;
        
        if (this.bulkProductsWrapper) {
            this.bulkProductsWrapper.classList.remove('hidden-block');
        }
        
        if (this.bulkPreviewContainer) {
            this.bulkPreviewContainer.classList.add('hidden-block');
        }
        
        this.updateTabLabels();
        
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            const tabLabel = productObj.tab.querySelector('.tab--label').textContent;
            
            if (index === 0) {
                this.activateTabByLabel(tabLabel);
            } else {
                this.deactivateTabByLabel(tabLabel);
            }
            
            product.classList.remove("inview", "hidden-block", "stack-down", "slide-right");
            
            const staticImageContainer = product.querySelector('.static-image-container');
            const customizationStepsContainer = product.querySelector('.customization-steps-container');
            const previewStepContainer = product.querySelector('.preview-step-container');
            
            if (staticImageContainer) {
                staticImageContainer.classList.remove('hidden-block');
            }
            if (customizationStepsContainer) {
                customizationStepsContainer.classList.remove('hidden-block');
            }
            if (previewStepContainer) {
                previewStepContainer.classList.add('hidden-block');
            }
            
            this.resetToFirstStepWithoutClearingData(product);
            
            if (index === 0) {
                product.classList.add("inview");
            } else {
                product.classList.add("hidden-block");
            }
        });
        
        if (this.products.length > 0) {
            this.lastActiveTab = this.products[0].tab;
            this.lastActiveProduct = this.products[0].product;
            this.currentProductIndex = 0;
            
            this.setupScrollNavigationForProduct(this.products[0].product);
            
            const scrollContainer = this.products[0].product.querySelector('.desktop-scroll-container');
            if (scrollContainer) {
                scrollContainer.scrollTop = 0;
            }
        }
        
        setTimeout(() => {
            this.validateAllCustomizers();
        }, 200);
        
        this.scrollToTop();
    }

    deactivateTabByLabel(tabLabel) {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        allTabs.forEach(tab => {
            if (tab.querySelector('.tab--label').textContent === tabLabel) {
                tab.classList.remove("active");
                tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
            }
        });
    }
    
    createProductTab(index) {
        const tab = this.tabTemplate.content.cloneNode(true).querySelector(".products-switcher--tab");
        const labelElement = tab.querySelector(".tab--label");
        labelElement.textContent = `${index}`;
        
        // Set data attributes
        tab.dataset.tabIndex = index;
        tab.dataset.productIndex = index;
        
        return tab;
    }

    storeBlankBottleImage() {  
            // Try to get image for current variant first
    if (this.variantID) {
        const variantsImgScript = document.body.querySelector("#variantPersonalizationImage");
        if (variantsImgScript) {
            const variantsPersonalizationImages = JSON.parse(variantsImgScript.textContent || '{}');
            const imageUrl = variantsPersonalizationImages[this.variantID];
            
            if (imageUrl) {
                const variantImg = new Image();
                variantImg.crossOrigin = "anonymous";
                variantImg.src = imageUrl;
                
                variantImg.onload = () => {
                    this.blankBottleImage = variantImg;
                };
                
                variantImg.onerror = () => {
                    console.error(`❌ Failed to load variant ${this.variantID} image`);
                    this.createRealisticBottleImage();
                };
                
                return;
            }
        }
    }      
        // Method 1: Try to get from existing product customizer (single personalization)
        const productCustomizers = document.querySelectorAll('product-customizer');
        let sourceCanvas = null;
        
        if (productCustomizers.length > 0) {
            const firstCustomizer = productCustomizers[0];
            
            if (firstCustomizer.productImg) {
                const productImg = firstCustomizer.productImg;
                
                if (productImg.complete && productImg.naturalWidth > 0) {
                    this.blankBottleImage = productImg;
                    this.forceUpdateAllCanvasesWithBottle();
                    return;
                }
                
                productImg.addEventListener('load', () => {
                    if (productImg.naturalWidth > 0) {
                        this.blankBottleImage = productImg;
                        this.forceUpdateAllCanvasesWithBottle();
                    }
                }, { once: true });
            }
            
            const canvases = [
                firstCustomizer.querySelector('#mainPersonalizationCanvas'),
                firstCustomizer.querySelector('#personalizationCanvas'),
                firstCustomizer.querySelector('canvas')
            ].filter(Boolean);
            
            if (canvases.length > 0) {
                sourceCanvas = canvases[0];                
                // Check if the canvas actually has content
                const ctx = sourceCanvas.getContext('2d');
                const imageData = ctx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
                const hasContent = imageData.data.some(channel => channel !== 0);
                
                if (hasContent) {
                    this.captureCanvasAsBottleImage(sourceCanvas);
                    return;
                } else {
                    console.log('🔄 Canvas found but no content, trying alternative methods...');
                }
            }
        }
        
        // Method 2: Look for product image directly
        const productImage = document.querySelector('.product-personalization__container img, .static-image-container img, [data-product-image]');
        if (productImage && productImage.complete) {
            this.blankBottleImage = new Image();
            this.blankBottleImage.crossOrigin = 'anonymous';
            this.blankBottleImage.onload = () => {
                this.forceUpdateAllCanvasesWithBottle();
            };
            this.blankBottleImage.onerror = () => {
                console.error('❌ Failed to load product image');
                this.createRealisticBottleImage();
            };
            this.blankBottleImage.src = productImage.src;
            return;
        }
        this.createRealisticBottleImage();
    }
    
    // NEW METHOD: Capture bottle image from ProductCustomizer
    captureBottleFromProductCustomizer() {
        const productCustomizers = document.querySelectorAll('product-customizer');
        
        if (productCustomizers.length > 0) {
            const firstCustomizer = productCustomizers[0];
            
            // Try to get the main canvas from the customizer
            const canvases = [
                firstCustomizer.querySelector('#mainPersonalizationCanvas'),
                firstCustomizer.querySelector('#personalizationCanvas'),
                firstCustomizer.querySelector('canvas')
            ].filter(Boolean);
            
            if (canvases.length > 0) {
                const canvas = canvases[0];                
                this.captureCanvasAsBottleImage(canvas);
                return;
            }
        }
        
        setTimeout(() => {
            this.createRealisticBottleImage();
        }, 3000);
    }
    
    // NEW METHOD: Capture canvas content as bottle image
    captureCanvasAsBottleImage(canvas) {
        if (!canvas) {
            console.error('❌ No canvas provided for capture');
            this.createRealisticBottleImage();
            return;
        }        
        try {
            // Create a copy of the canvas content
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = canvas.width;
            tempCanvas.height = canvas.height;
            const tempCtx = tempCanvas.getContext('2d');
            
            // Draw the current canvas content
            tempCtx.drawImage(canvas, 0, 0);
            
            // Store as our bottle image
            this.blankBottleImage = new Image();
            this.blankBottleImage.onload = () => {                
                // Force update all canvases immediately
                this.forceUpdateAllCanvasesWithBottle();
            };
            
            this.blankBottleImage.onerror = () => {
                console.error('❌ Failed to capture canvas image');
                this.createRealisticBottleImage();
            };
            
            this.blankBottleImage.src = tempCanvas.toDataURL('image/png');
            
        } catch (error) {
            console.error('❌ Error capturing canvas:', error);
            this.createRealisticBottleImage();
        }
    }

    createRealisticBottleImage() {
        const canvas = document.createElement('canvas');
        canvas.width = 3000;
        canvas.height = 3000;
        
        const ctx = canvas.getContext('2d');
        
        // Create a professional-looking bottle
        this.drawRealisticBottle(ctx, canvas.width, canvas.height);
        
        this.blankBottleImage = new Image();
        this.blankBottleImage.onload = () => {
            this.forceUpdateAllCanvasesWithBottle();
        };
        this.blankBottleImage.src = canvas.toDataURL('image/png');
    }
    
    // NEW METHOD: Draw a realistic bottle
    drawRealisticBottle(ctx, width, height) {
        // Clear with light background
        ctx.fillStyle = '#f8f9fa';
        ctx.fillRect(0, 0, width, height);
        
        // Bottle dimensions
        const bottleWidth = width * 0.5;
        const bottleHeight = height * 0.7;
        const bottleX = (width - bottleWidth) / 2;
        const bottleY = (height - bottleHeight) / 2;
        
        // Main bottle body with gradient
        const bottleGradient = ctx.createLinearGradient(bottleX, 0, bottleX + bottleWidth, 0);
        bottleGradient.addColorStop(0, '#ffffff');
        bottleGradient.addColorStop(0.5, '#f8f9fa');
        bottleGradient.addColorStop(1, '#ffffff');
        
        ctx.fillStyle = bottleGradient;
        ctx.strokeStyle = '#e9ecef';
        ctx.lineWidth = 8;
        
        // Rounded bottle body
        ctx.beginPath();
        ctx.roundRect(bottleX, bottleY, bottleWidth, bottleHeight, 60);
        ctx.fill();
        ctx.stroke();
        
        // Bottle neck
        const neckWidth = bottleWidth * 0.3;
        const neckHeight = bottleHeight * 0.15;
        const neckX = bottleX + (bottleWidth - neckWidth) / 2;
        const neckY = bottleY - neckHeight;
        
        ctx.beginPath();
        ctx.roundRect(neckX, neckY, neckWidth, neckHeight, 15);
        ctx.fill();
        ctx.stroke();
        
        // Bottle cap
        const capWidth = neckWidth * 0.8;
        const capHeight = neckHeight * 0.6;
        const capX = neckX + (neckWidth - capWidth) / 2;
        const capY = neckY - capHeight;
        
        const capGradient = ctx.createLinearGradient(capX, 0, capX + capWidth, 0);
        capGradient.addColorStop(0, '#6c757d');
        capGradient.addColorStop(0.5, '#495057');
        capGradient.addColorStop(1, '#6c757d');
        
        ctx.fillStyle = capGradient;
        ctx.beginPath();
        ctx.roundRect(capX, capY, capWidth, capHeight, 8);
        ctx.fill();
        
        // Reflection effects
        const reflectionGradient = ctx.createLinearGradient(bottleX, 0, bottleX + bottleWidth, 0);
        reflectionGradient.addColorStop(0, 'rgba(255,255,255,0.1)');
        reflectionGradient.addColorStop(0.3, 'rgba(255,255,255,0.3)');
        reflectionGradient.addColorStop(0.7, 'rgba(255,255,255,0.3)');
        reflectionGradient.addColorStop(1, 'rgba(255,255,255,0.1)');
        
        ctx.fillStyle = reflectionGradient;
        ctx.beginPath();
        ctx.roundRect(bottleX + 20, bottleY + 20, bottleWidth - 40, bottleHeight - 40, 40);
        ctx.fill();
        
        // Label area
        const labelWidth = bottleWidth * 0.7;
        const labelHeight = bottleHeight * 0.4;
        const labelX = bottleX + (bottleWidth - labelWidth) / 2;
        const labelY = bottleY + (bottleHeight - labelHeight) / 2;
        
        ctx.fillStyle = 'rgba(248, 249, 250, 0.8)';
        ctx.strokeStyle = 'rgba(233, 236, 239, 0.6)';
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.roundRect(labelX, labelY, labelWidth, labelHeight, 20);
        ctx.fill();
        ctx.stroke();
        
    }
    
    // NEW METHOD: Force update all canvases with the captured bottle image
    forceUpdateAllCanvasesWithBottle() {        
        if (!this.blankBottleImage || !this.blankBottleImage.complete) {           
            return;
        }
        
        this.products.forEach((productObj, productIndex) => {
            const product = productObj.product;
            const canvases = [
                product.querySelector('#mainPersonalizationCanvas'),
                product.querySelector('#personalizationCanvas'),
                product.querySelector('#personalizationCanvasFontStyle'), 
                product.querySelector('#personalizationCanvasFontPattern'),
                product.querySelector('#personalizationCanvasIcon'),
                product.querySelector('#personalizationCanvasPreview')
            ].filter(Boolean);
            
            canvases.forEach((canvas, canvasIndex) => {
                if (canvas) {
                    this.drawBottleOnCanvas(canvas);
                    
                    // Also draw any existing text
                    const text = product.savedCustomizationData?.["personalized-text"] || "";
                    if (text) {
                        this.drawTextOnExistingCanvas(canvas, text);
                    }
                }
            });
        });
    }
    
    // NEW METHOD: Draw just the bottle on a canvas
    drawBottleOnCanvas(canvas) {
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        
        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw the captured bottle image
        if (this.blankBottleImage && this.blankBottleImage.complete) {
            ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
        } else {
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
    }
    
    // NEW METHOD: Draw text on existing canvas (without clearing bottle)
    drawTextOnExistingCanvas(canvas, text) {
        if (!canvas || !text) return;
        
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        
        // Just draw the text without clearing the canvas
        this.drawTextOnCanvas(ctx, text, canvas.width, canvas.height);
    }
    
    // NEW METHOD: Update all canvases with the stored image
    updateAllCanvasesWithStoredImage() {
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            const canvases = [
                product.querySelector('#mainPersonalizationCanvas'),
                product.querySelector('#personalizationCanvas'),
                product.querySelector('#personalizationCanvasFontStyle'), 
                product.querySelector('#personalizationCanvasFontPattern'),
                product.querySelector('#personalizationCanvasIcon'),
                product.querySelector('#personalizationCanvasPreview')
            ];
            
            canvases.forEach((canvas, canvasIndex) => {
                if (canvas) {
                    this.drawImageOnCanvas(canvas);
                }
            });
        });
    }
    
    // NEW METHOD: Draw just the image on a canvas
    drawImageOnCanvas(canvas) {
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        
        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw the stored image
        if (this.blankBottleImage && this.blankBottleImage.complete) {
            ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
        } else {
            // Fallback
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
    }

    createFallbackBottleImage() {
        this.createEmergencyBottleImage(); // Use the same emergency method
    }

    saveCanvasAsImage(canvas) {
        return new Promise((resolve, reject) => {
            try {
                const image = new Image();
                image.onload = () => resolve(image);
                image.onerror = () => reject(new Error('Failed to load canvas image'));
                image.src = canvas.toDataURL('image/png');
            } catch (error) {
                reject(error);
            }
        });
    }

    showUploadedProductsPreview() {
        this.populateUploadedPreviewGrid();
        
        if (this.bulkSheetContainer) {
            this.bulkSheetContainer.classList.add('hidden-block');
        }
        
        if (this.bulkUploadPreviewContainer) {
            this.bulkUploadPreviewContainer.classList.remove('hidden-block');
        }
        
        this.scrollToTop();
    }
    populateUploadedPreviewGrid() {
        const uploadedGrid = this.querySelector('.uploaded-products-grid');
        if (!uploadedGrid || !this.parsedCSVData.length) {
            return;
        }
        
        uploadedGrid.innerHTML = '';
        
        const productsToShow = this.parsedCSVData.slice(0, 4);
        
        productsToShow.forEach((item, index) => {
            const productPreview = this.createUploadedProductPreview(item, index);
            if (productPreview) {
                uploadedGrid.appendChild(productPreview);
            }
        });
        
        if (this.parsedCSVData.length > 4) {
            const moreProductsElement = document.createElement('div');
            moreProductsElement.className = 'more-products-message';
            moreProductsElement.innerHTML = `
                <div class="more-products-text">
                    + ${this.parsedCSVData.length - 4} more products
                </div>
            `;
            uploadedGrid.appendChild(moreProductsElement);
        }
        
        const quantityPreview = this.querySelector('.file-product--quantity-preview');
        if (quantityPreview) {
            quantityPreview.textContent = this.parsedCSVData.length;
        }
    }
    setupUploadFileButton() {
        const uploadFileBtn = this.querySelector('.upload-file-button, [data-action="upload-file"]');
        if (uploadFileBtn) {
            const newBtn = uploadFileBtn.cloneNode(true);
            uploadFileBtn.parentNode.replaceChild(newBtn, uploadFileBtn);
            
            newBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleBulkUpload();
            });
        }
    }

    createUploadedProductPreview(item, index) {
        if (!this.uploadedProductPreviewTemplate) {
            console.error('Uploaded product preview template not found');
            return null;
        }
        
        const previewElement = this.uploadedProductPreviewTemplate.content.cloneNode(true).querySelector(".uploaded-product-preview");
        this.populateUploadedPreviewTemplate(previewElement, item, index);
        this.renderUploadedProductCanvas(previewElement, item, index);
        
        return previewElement;
    }
    
    populateUploadedPreviewTemplate(element, item, index) {
        const titleElement = element.querySelector('.preview-product-title');
        if (titleElement) {
            titleElement.textContent = `Bottle Number : ${index + 1}`;
        }
        
        const textElement = element.querySelector('.personalized-text-value');
        if (textElement) {
            textElement.textContent = item.Name || 'Not set';
        }
        
        const fontStyleElement = element.querySelector('.font-style-value');
        if (fontStyleElement) {
            fontStyleElement.textContent = item['Font Style'] || 'Default';
        }
        
        const fontPatternElement = element.querySelector('.font-pattern-value');
        if (fontPatternElement) {
            let fontPatternValue = item['Font Pattern'] || 'None';
            if (fontPatternValue.includes('http') || fontPatternValue.includes('www.')) {
                fontPatternValue = this.extractNameFromUrl(fontPatternValue) || 'Font Pattern';
            }
            fontPatternElement.textContent = fontPatternValue;
        }
        
        const iconElement = element.querySelector('.icon-value');
        if (iconElement) {
            let iconValue = item['Icon'] || 'None';
            if (iconValue.includes('http') || iconValue.includes('www.')) {
                iconValue = this.extractNameFromUrl(iconValue) || 'Icon';
            }
            iconElement.textContent = iconValue;
        }
        
        const fontStyleDetail = element.querySelector('.font-style-detail');
        const fontPatternDetail = element.querySelector('.font-pattern-detail');
        const iconDetail = element.querySelector('.icon-detail');
        
        if (fontStyleDetail) {
            fontStyleDetail.style.display = item['Font Style'] ? 'block' : 'none';
        }
        if (fontPatternDetail) {
            fontPatternDetail.style.display = item['Font Pattern'] ? 'block' : 'none';
        }
        if (iconDetail) {
            const iconVal = item['Icon'] ? item['Icon'].trim() : '';
            iconDetail.style.display = (iconVal && iconVal !== 'No icon') ? 'block' : 'none';
        }
    }

    renderUploadedProductCanvas(previewElement, item, index) {
        const canvas = previewElement.querySelector('.uploaded-preview-canvas');
        if (!canvas) {
            return;
        }
        
        const width = 280;
        const height = 200;
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        
        if (this.blankBottleImage) {
            this.renderWithStoredBottleImage(canvas, item, width, height, index);
        } else {
            this.renderSimpleBottlePreview(canvas, item, width, height, index);
        }
    }

    renderWithStoredBottleImage(canvas, item, width, height, index) {
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, width, height);

        if (this.blankBottleImage && this.blankBottleImage.complete) {
            try {
               const bottleHeight = 240;
               const bottleY = -20;
               
               ctx.drawImage(this.blankBottleImage, 0, bottleY, width, bottleHeight);
            } catch (error) {
                console.log('Bottle image draw failed:', error);
            }
        } else {
            ctx.fillRect(0, 0, width, height);
        }

        if (item.Name && item.Name.trim() !== '') {
            
            setTimeout(() => {
                this.drawTextOnBottle(ctx, item.Name, width, height);
            }, 10);
        }

    }
    
    drawTextOnBottle(ctx, text, width, height) {
        
        const textX = width / 2;
        const textY = height / 2;
        
        const textStyle = {
            color: '#ffffff',
            fontSize: '8px',
            fontFamily: 'Arial',
            fontWeight: 'bold'
        };
        
        ctx.font = `${textStyle.fontWeight} ${textStyle.fontSize} ${textStyle.fontFamily}`;
        ctx.fillStyle = textStyle.color;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        
        ctx.fillText(text, textX, textY);
    }
    
    renderSimpleBottlePreview(canvas, item, width, height, index) {
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        
        ctx.clearRect(0, 0, width, height);
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        
        ctx.strokeStyle = '#e5e7eb';
        ctx.lineWidth = 1;
        ctx.strokeRect(0, 0, width, height);
        
        this.drawBottleShape(ctx, width, height);
        
        if (item.Name && item.Name.trim() !== '') {
            this.drawCSVTextOnBottle(ctx, item, width, height);
        }
        
        ctx.fillStyle = '#6b7280';
        ctx.font = '12px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(`Bottle Number ${index + 1}`, width / 2, height - 15);
    }

    drawBottleShape(ctx, width, height) {
        const centerX = width / 2;
        const bottleWidth = width * 0.6;
        const bottleHeight = height * 0.6;
        const bottleTop = (height - bottleHeight) / 2;
        
        ctx.fillStyle = '#f3f4f6';
        ctx.strokeStyle = '#d1d5db';
        ctx.lineWidth = 2;
        
        ctx.beginPath();
        ctx.roundRect(centerX - bottleWidth/2, bottleTop, bottleWidth, bottleHeight, 8);
        ctx.fill();
        ctx.stroke();
        
        const neckWidth = bottleWidth * 0.4;
        const neckHeight = bottleHeight * 0.2;
        ctx.beginPath();
        ctx.roundRect(centerX - neckWidth/2, bottleTop - neckHeight, neckWidth, neckHeight, 4);
        ctx.fill();
        ctx.stroke();
        
        const capWidth = neckWidth * 0.8;
        const capHeight = neckHeight * 0.6;
        ctx.fillStyle = '#9ca3af';
        ctx.beginPath();
        ctx.roundRect(centerX - capWidth/2, bottleTop - neckHeight - capHeight, capWidth, capHeight, 2);
        ctx.fill();
        ctx.stroke();
    }

    drawCSVTextOnBottle(ctx, item, width, height) {
        const text = String(item.Name).trim();
        if (!text) return;
        
        const centerX = width / 2;
        const textY = height / 2;
        
        ctx.font = 'bold 36px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 6;
        ctx.strokeText(text, centerX, textY);
        
        ctx.fillStyle = '#FFFFFF';
        ctx.fillText(text, centerX, textY);
        
    }
    ensureOptionClassesAreApplied(product) {
        if (!product) return;
        
        const customizationData = product.savedCustomizationData || {};
        
        // Remove all existing selected classes first (clean slate)
        this.removeAllOptionSelectedClasses(product, 'font-style');
        this.removeAllOptionSelectedClasses(product, 'font-pattern');
        this.removeAllOptionSelectedClasses(product, 'icon');
        
        // Apply font-style class if selected
        if (customizationData["font-style"] && customizationData["font-style"].trim() !== "") {
            const fontStyleInputs = product.querySelectorAll('input[name="font-style"]');
            let found = false;
            fontStyleInputs.forEach(input => {
                if (input.dataset.optionData === customizationData["font-style"]) {
                    input.checked = true;
                    this.addOptionSelectedClass(product, 'font-style', input);
                    found = true;
                } else {
                    input.checked = false;
                }
            });
            if (!found) {
                console.warn('❌ Font style not found in first product inputs:', customizationData["font-style"]);
                // Select the first font style as fallback
                const firstInput = fontStyleInputs[0];
                if (firstInput) {
                    firstInput.checked = true;
                    this.addOptionSelectedClass(product, 'font-style', firstInput);
                    customizationData["font-style"] = firstInput.dataset.optionData;
                    customizationData["font-style-label"] = firstInput.dataset.optionLabel;                    
                }
            }
        } else {
            // Ensure font-style always has a selection for first product
            this.ensureFontStyleSelection(product);
        }
        
        // Apply font-pattern class if selected
        if (customizationData["font-pattern"] && customizationData["font-pattern"].trim() !== "") {
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            let found = false;
            fontPatternInputs.forEach(input => {
                if (input.dataset.optionData === customizationData["font-pattern"]) {
                    input.checked = true;
                    this.addOptionSelectedClass(product, 'font-pattern', input);
                    found = true;
                } else {
                    input.checked = false;
                }
            });
            if (!found) {
                console.warn('❌ Font pattern not found in first product inputs:', customizationData["font-pattern"]);
            }
        } else {
            // Clear font pattern if no data
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            fontPatternInputs.forEach(input => {
                input.checked = false;
            });
        }
        
        // Apply icon class if selected
        if (customizationData["icon"] && customizationData["icon"].trim() !== "") {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            let found = false;
            iconInputs.forEach(input => {
                if (input.dataset.optionData === customizationData["icon"]) {
                    input.checked = true;
                    this.addOptionSelectedClass(product, 'icon', input);
                    found = true;
                } else {
                    input.checked = false;
                }
            });
            if (!found) {
                console.warn('❌ Icon not found in first product inputs:', customizationData["icon"]);
            }
        } else {
            // Clear icon if no data
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                input.checked = false;
            });
        }
    }
    backToUploadView() {
        if (this.bulkUploadPreviewContainer) {
            this.bulkUploadPreviewContainer.classList.add('hidden-block');
        }
        
        if (this.bulkSheetContainer) {
            this.bulkSheetContainer.classList.remove('hidden-block');
        }
        
        this.scrollToTop();
    }

    setupNextButtonHandler() {
        if (this._nextButtonClickHandler) {
            this.removeEventListener('click', this._nextButtonClickHandler);
        }
        
        this._nextButtonClickHandler = (e) => {
            const nextButton = e.target.closest('.step-next');
            if (nextButton && !this.isProcessingNext && window.innerWidth <= 768) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                this.handleNextButtonClick();
                return false;
            }
        };
        
        this.addEventListener('click', this._nextButtonClickHandler, true);
    }

    setupDesktopNextButtonHandler() {
        if (this._desktopNextButtonClickHandler) {
            this.removeEventListener('click', this._desktopNextButtonClickHandler);
        }
        
        this._desktopNextButtonClickHandler = (e) => {
            const nextButton = e.target.closest('.step-next');
            if (nextButton && !this.isProcessingNext && window.innerWidth > 768) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                this.handleDesktopNextButtonClick();
                return false;
            }
        };
        
        this.addEventListener('click', this._desktopNextButtonClickHandler, true);
    }

    setupMobileTabEvents() {
        if (this._mobileTabClickHandler) {
            this.removeEventListener('click', this._mobileTabClickHandler);
        }
        
        this._mobileTabClickHandler = (e) => {
            const tabButton = e.target.closest('.tab-button');
            if (tabButton && window.innerWidth <= 768) {
                e.preventDefault();
                e.stopPropagation();
                this.handleMobileTabClick(tabButton);
            }
        };
        
        this.addEventListener('click', this._mobileTabClickHandler);
    }

    handleMobileTabClick(tabButton) {
        if (this.isPreviewMode || this.isProcessingNext) return;
        
        const currentProduct = this.products[this.currentProductIndex]?.product;
        if (!currentProduct) return;

        const targetTab = tabButton.dataset.tab;
        
        this.goToStep(currentProduct, targetTab);
    }

    goToStep(product, stepType) {
        if (!product) return;
        
        const steps = product.querySelectorAll('.personalization-step');
        let targetStep = null;
        
        steps.forEach(step => {
            if (step.dataset.step === stepType) {
                targetStep = step;
                step.classList.add('active');
                this.updateCanvasVisibility(product, stepType);
            } else {
                step.classList.remove('active');
            }
        });

        this.updateMobileTabs(product, stepType);
        this.updateNextButtonText(product, stepType);

        if (window.innerWidth <= 768 && targetStep) {
            setTimeout(() => {
                targetStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 50);
        }
    }

    updateCanvasVisibility(product, stepType) {
        if (!product) return;        
        if (product.setCanvasVisibility) {
            product.setCanvasVisibility(stepType);
        } else {
            this.updateCanvasVisibilityDirect(product, stepType);
        }
    }

    updateCanvasVisibilityDirect(product, stepType) {
        if (!product) return;
        
        const canvases = {
            text: product.querySelector('#personalizationCanvas'),
            fontStyle: product.querySelector('#personalizationCanvasFontStyle'),
            fontPattern: product.querySelector('#personalizationCanvasFontPattern'),
            icon: product.querySelector('#personalizationCanvasIcon'),
            main: product.querySelector('#mainPersonalizationCanvas')
        };
        
        Object.values(canvases).forEach(canvas => {
            if (canvas) canvas.style.display = 'none';
        });
        
        let activeCanvas = null;
        switch(stepType) {
            case 'text':
                activeCanvas = canvases.text;
                break;
            case 'font-style':
                activeCanvas = canvases.fontStyle;
                break;
            case 'font-pattern':
                activeCanvas = canvases.fontPattern;
                break;
            case 'icon':
                activeCanvas = canvases.icon;
                break;
        }
        
        if (activeCanvas) {
            activeCanvas.style.display = 'block';
        }
        
        if (window.innerWidth > 768 && canvases.main) {
            canvases.main.style.display = 'block';
        }
    }

    handleNextButtonClick() {
        if (this.isPreviewMode || this.isProcessingNext) return;
        
        this.isProcessingNext = true;
        
        const currentProduct = this.products[this.currentProductIndex]?.product;
        if (!currentProduct) {
            this.isProcessingNext = false;
            return;
        }
        
        const currentStep = currentProduct.querySelector('.personalization-step.active');
        if (!currentStep) {
            this.isProcessingNext = false;
            return;
        }
        
        const currentStepType = currentStep.dataset.step;
        
        this.markProductAsCompleted(this.currentProductIndex);
        
        const isLastStep = this.isLastStep(currentStepType);
        
        if (isLastStep) {
            if (this.currentProductIndex === this.products.length - 1) {
                this.hidePreviewStep(currentProduct);
                setTimeout(() => {
                    this.showPreview();
                    this.isProcessingNext = false;
                }, 50);
            } else {
                this.currentProductIndex++;
                this.hidePreviewStep(currentProduct);
                this.lastActiveProduct.classList.add("stack-down");
                this.lastActiveProduct.classList.remove("inview");
                
                setTimeout(() => {
                    this.switchProduct(this.products[this.currentProductIndex].tab);
                    this.resetToFirstStep(this.products[this.currentProductIndex].product);
                    this.isProcessingNext = false;
                }, 150);
            }
        } else {
            this.goToNextStep(currentProduct, currentStep);
            setTimeout(() => {
                this.isProcessingNext = false;
            }, 100);
        }
        
        this.scrollToTop();
    }

    // Replace the existing attachTabEvents with:
attachTabEvents(tab) {
    // For backward compatibility, call the simple version
    const index = parseInt(tab.querySelector('.tab--label').textContent) - 1;
    this.attachSimpleTabEvents(tab, index);
}

    handleDesktopNextButtonClick() {
        if (this.isPreviewMode || this.isProcessingNext) return;
        
        this.isProcessingNext = true;
        
        const currentProduct = this.products[this.currentProductIndex]?.product;
        if (!currentProduct) {
            this.isProcessingNext = false;
            return;
        }
        
        const currentStep = this.getCurrentlyActiveStep(currentProduct);
        if (!currentStep) {
            this.isProcessingNext = false;
            return;
        }
        
        const currentStepType = currentStep.dataset.step;
        
        this.markProductAsCompleted(this.currentProductIndex);
        
        const isLastStep = this.isLastStep(currentStepType);
        
        if (isLastStep) {
            if (this.currentProductIndex === this.products.length - 1) {
                this.hidePreviewStep(currentProduct);
                setTimeout(() => {
                    this.showPreview();
                    this.isProcessingNext = false;
                }, 50);
            } else {
                this.currentProductIndex++;
                this.hidePreviewStep(currentProduct);
                this.lastActiveProduct.classList.add("stack-down");
                this.lastActiveProduct.classList.remove("inview");
                
                setTimeout(() => {
                    this.switchProduct(this.products[this.currentProductIndex].tab);
                    this.resetToFirstStep(this.products[this.currentProductIndex].product);
                    this.isProcessingNext = false;
                }, 150);
            }
        } else {
            this.goToNextStepDesktop(currentProduct, currentStep);
            setTimeout(() => {
                this.isProcessingNext = false;
            }, 100);
        }
    }

    goToNextStep(product, currentStep) {
        const steps = Array.from(product.querySelectorAll('.personalization-step'));
        const currentIndex = steps.indexOf(currentStep);
        
        
        if (currentIndex < steps.length - 1) {
            const nextStep = steps[currentIndex + 1];
            const nextStepType = nextStep.dataset.step;
            
            
            steps.forEach(step => {
                step.classList.remove('active');
            });
            
            nextStep.classList.add('active');
            this.updateCanvasVisibility(product, nextStepType);
            this.updateMobileTabs(product, nextStepType);
            this.updateNextButtonText(product, nextStepType);
            
            if (window.innerWidth <= 768) {
                setTimeout(() => {
                    nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 150);
            }
        } else {
            console.log('❌ No next step available');
        }
    }
    goToNextStepDesktop(product, currentStep) {
        if (!product || !currentStep) {
            this.isProcessingNext = false;
            return;
        }
        
        const steps = Array.from(product.querySelectorAll('.personalization-step'));
        if (steps.length === 0) {
            this.isProcessingNext = false;
            return;
        }
        
        const currentIndex = steps.indexOf(currentStep);
        
        
        if (currentIndex < steps.length - 1) {
            const nextStep = steps[currentIndex + 1];
            if (!nextStep) {
                this.isProcessingNext = false;
                return;
            }
            
            const nextStepType = nextStep.dataset.step;
            
            
            steps.forEach(step => {
                if (step) {
                    step.classList.remove('active');
                }
            });
            
            nextStep.classList.add('active');
            
            if (nextStepType) {
                this.updateCanvasVisibility(product, nextStepType);
            }
            
            this.updateNextButtonText(product, nextStepType);
            
            const scrollContainer = product.querySelector('.desktop-scroll-container');
            if (scrollContainer) {
                setTimeout(() => {
                    try {
                        nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } catch (error) {
                        console.log('❌ Scroll error:', error);
                    }
                }, 100);
            }
            
            this.isProcessingNext = false;
        } else {
            this.handleLastStepReached();
        }
    }
    handleLastStepReached() {
        
        const currentProduct = this.products[this.currentProductIndex]?.product;
        
        if (this.currentProductIndex === this.products.length - 1) {
            this.hidePreviewStep(currentProduct);
            setTimeout(() => {
                this.showPreview();
                this.isProcessingNext = false;
            }, 50);
        } else {
            this.currentProductIndex++;
            
            if (!this.products[this.currentProductIndex]) {
                this.currentProductIndex = Math.max(0, this.products.length - 1);
                this.isProcessingNext = false;
                return;
            }
            
            this.hidePreviewStep(currentProduct);
            
            if (this.lastActiveProduct) {
                this.lastActiveProduct.classList.add("stack-down");
                this.lastActiveProduct.classList.remove("inview");
            }
            
            setTimeout(() => {
                this.switchProduct(this.products[this.currentProductIndex].tab);
                this.resetToFirstStep(this.products[this.currentProductIndex].product);
                this.isProcessingNext = false;
            }, 150);
        }
    }
    isLastStep(stepType) {
        const currentProduct = this.products[this.currentProductIndex]?.product;
        if (!currentProduct) {
            return false;
        }
        
        const steps = Array.from(currentProduct.querySelectorAll('.personalization-step'))
            .map(step => step.dataset.step)
            .filter(step => step && step !== 'preview');
        
        const currentIndex = steps.indexOf(stepType);
        
        const isLast = currentIndex === steps.length - 1;
        
               
        return isLast;
    }
    setupScrollNavigationForProduct(product) {
        if (!product) return;
        
        const scrollContainer = product.querySelector('.desktop-scroll-container');
        if (!scrollContainer) return;

        if (this._scrollHandler) {
            scrollContainer.removeEventListener('scroll', this._scrollHandler);
        }
        
        this._scrollHandler = () => {
            this.debounce(() => {
                if (window.innerWidth > 768) {
                    this.updateCurrentStepFromScroll();
                }
            }, 150);
        };
        
        scrollContainer.addEventListener('scroll', this._scrollHandler);
    }

    updateCurrentStepFromScroll() {
        if (this.isPreviewMode || this.isProcessingNext || window.innerWidth <= 768) return;
        
        const currentProduct = this.products[this.currentProductIndex]?.product;
        if (!currentProduct) return;

        const steps = currentProduct.querySelectorAll('.personalization-step');
        const scrollContainer = currentProduct.querySelector('.desktop-scroll-container');
        if (!scrollContainer) return;

        let activeStepIndex = 0;
        let maxVisibleArea = 0;

        steps.forEach((step, index) => {
            const stepRect = step.getBoundingClientRect();
            const containerRect = scrollContainer.getBoundingClientRect();
            
            const visibleHeight = Math.min(stepRect.bottom, containerRect.bottom) - Math.max(stepRect.top, containerRect.top);
            const visibleArea = visibleHeight / stepRect.height;

            if (visibleArea > maxVisibleArea && visibleArea > 0.3) {
                maxVisibleArea = visibleArea;
                activeStepIndex = index;
            }
        });

        steps.forEach((step, index) => {
            step.classList.toggle('active', index === activeStepIndex);
        });

        const activeStep = steps[activeStepIndex];
        if (activeStep) {
            this.updateCanvasVisibility(currentProduct, activeStep.dataset.step);
            this.updateNextButtonText(currentProduct, activeStep.dataset.step);
        }
    }

    getCurrentlyActiveStep(product) {
        if (!product) return null;
        
        if (window.innerWidth <= 768) {
            return product.querySelector('.personalization-step.active');
        }
        
        const steps = product.querySelectorAll('.personalization-step');
        const scrollContainer = product.querySelector('.desktop-scroll-container');
        
        if (!scrollContainer) {
            return product.querySelector('.personalization-step.active');
        }

        let activeStep = null;
        let maxVisibleArea = 0;

        steps.forEach((step) => {
            const stepRect = step.getBoundingClientRect();
            const containerRect = scrollContainer.getBoundingClientRect();
            
            const visibleHeight = Math.min(stepRect.bottom, containerRect.bottom) - Math.max(stepRect.top, containerRect.top);
            const visibleArea = visibleHeight / stepRect.height;

            if (visibleArea > maxVisibleArea && visibleArea > 0.3) {
                maxVisibleArea = visibleArea;
                activeStep = step;
            }
        });

        return activeStep || product.querySelector('.personalization-step.active');
    }

    setupProductPreviewButtons() {
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            const previewButtons = product.querySelectorAll('button[data-action="bulk-add-to-cart"]');
            
            previewButtons.forEach(button => {
                button.replaceWith(button.cloneNode(true));
                const newButton = product.querySelector('button[data-action="bulk-add-to-cart"]');
                
                newButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const { icon, "personalized-text": personalizedText } = product.savedCustomizationData || {};
                    const hasCustomization = (icon?.trim() !== "") || (personalizedText?.trim() !== "");
                    
                    if (!hasCustomization) {
                        document.body.querySelector('milton-toast')?.showErrorToast(`Please complete customization for this product before proceeding.`);
                        return;
                    }

                    const currentStep = this.getCurrentlyActiveStep(product);
                    if (currentStep && !this.isLastStep(currentStep.dataset.step)) {
                        document.body.querySelector('milton-toast')?.showErrorToast(`Please complete all steps before proceeding.`);
                        return;
                    }
                    
                    if (this.currentProductIndex === this.products.length - 1) {
                        this.showPreview();
                    } else {
                        this.currentProductIndex++;
                        this.switchProduct(this.products[this.currentProductIndex].tab);
                        this.resetToFirstStep(this.products[this.currentProductIndex].product);
                    }
                });
            });
        });
    }
    /*
    createProductPreview(productObj, index) {
        if (!this.previewTemplate) return document.createElement('div');
        
        const product = productObj.product;
        const customizationData = product.savedCustomizationData || {};
        const productQuantity = this.getProductQuantity(product);
        
        const previewElement = this.previewTemplate.content.cloneNode(true).querySelector(".product-preview");
        
        const previewTitle = previewElement.querySelector(".preview-product-title");
        const editButton = previewElement.querySelector(".edit-single-btn");
        const textValue = previewElement.querySelector(".preview-detail:nth-child(1) .preview-value");
        const fontStyleDetail = previewElement.querySelector(".preview-detail:nth-child(2)");
        const fontStyleValue = fontStyleDetail?.querySelector(".preview-value");
        const fontPatternDetail = previewElement.querySelector(".preview-detail:nth-child(3)");
        const fontPatternValue = fontPatternDetail?.querySelector(".preview-value");
        const iconDetail = previewElement.querySelector(".preview-detail:nth-child(4)");
        const iconValue = iconDetail?.querySelector(".preview-value");
        const quantityDetail = previewElement.querySelector(".preview-detail:nth-child(5)");
        const quantityValue = quantityDetail?.querySelector(".preview-value");
        
        if (previewTitle) {
            previewTitle.textContent = `Bottle Number: ${index + 1}`;
        }
        
        if (editButton) {
            editButton.dataset.index = index;
            editButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const productIndex = parseInt(e.target.dataset.index);
                this.editSingleProduct(productIndex);
            });
        }
        
        if (textValue) {
            textValue.textContent = customizationData['personalized-text'] || 'Not set';
        }
        
        if (fontStyleDetail && fontStyleValue) {
            if (customizationData['font-style-label'] && customizationData['font-style-label'].trim() !== '') {
                fontStyleValue.textContent = customizationData['font-style-label'];
                fontStyleDetail.style.display = 'block';
            } else if (customizationData['font-style'] && customizationData['font-style'].trim() !== '') {                
                fontStyleValue.textContent = this.extractNameFromUrl(customizationData['font-style']) || 'Font Style';
                fontStyleDetail.style.display = 'block';
            } else {
                fontStyleDetail.style.display = 'none';
            }
        }
        
        if (fontPatternDetail && fontPatternValue) {
            if (customizationData['font-pattern-label'] && customizationData['font-pattern-label'].trim() !== '') {
                fontPatternValue.textContent = customizationData['font-pattern-label'];
                fontPatternDetail.style.display = 'block';
            } else if (customizationData['font-pattern'] && customizationData['font-pattern'].trim() !== '') {
                fontPatternValue.textContent = this.extractNameFromUrl(customizationData['font-pattern']) || 'Font Pattern';
                fontPatternDetail.style.display = 'block';
            } else {
                fontPatternDetail.style.display = 'none';
            }
        }
        if (iconDetail && iconValue) {
            if (customizationData['icon'] && customizationData['icon'].trim() !== '' && customizationData['icon-label'] && customizationData['icon-label'].trim() !== '' && customizationData['icon-label'] !== 'No icon') {
                iconValue.textContent = customizationData['icon-label'];
                iconDetail.style.display = 'block';
            } else if (customizationData['icon'] && customizationData['icon'].trim() !== '') {
                iconValue.textContent = this.extractNameFromUrl(customizationData['icon']) || 'Custom Icon';
                iconDetail.style.display = 'block';
            } else {
                iconDetail.style.display = 'none';
            }
        }
        if (quantityDetail && quantityValue) {
            quantityValue.textContent = `${productQuantity} item${productQuantity > 1 ? 's' : ''}`;
            quantityDetail.style.display = 'block';
        }
        
        const canvas = previewElement.querySelector('.preview-canvas');
        this.renderActualCanvas(canvas, product);
        
        return previewElement;
    }
    */
    createProductPreview(productObj, index) {
        if (!this.previewTemplate) return document.createElement('div');
        
        const product = productObj.product;
        const customizationData = product.savedCustomizationData || {};
        const productQuantity = this.getProductQuantity(product);
        
        const previewElement = this.previewTemplate.content.cloneNode(true).querySelector(".product-preview");
        
        // Get all elements by their classes/positions
        const previewTitle = previewElement.querySelector(".preview-product-title");
        const editButton = previewElement.querySelector(".edit-single-btn");
        
        // Get all preview detail elements
        const allDetails = previewElement.querySelectorAll('.preview-detail');
        
        // Map details by their content or position (assuming consistent order)
        // Order: Text, Orientation, Font Style, Style Pattern, Icon
        const textDetail = allDetails[0];
        const textOrientationDetail = allDetails[1];
        const fontStyleDetail = allDetails[2];
        const fontPatternDetail = allDetails[3];
        const iconDetail = allDetails[4];
        
        const textValue = textDetail?.querySelector(".preview-value");
        const textOrientationValue = textOrientationDetail?.querySelector(".preview-value");
        const fontStyleValue = fontStyleDetail?.querySelector(".preview-value");
        const fontPatternValue = fontPatternDetail?.querySelector(".preview-value");
        const iconValue = iconDetail?.querySelector(".preview-value");
        
        // Quantity detail might be separate or not exist
        const quantityDetail = previewElement.querySelector('.quantity-detail') || allDetails[5];
        const quantityValue = quantityDetail?.querySelector(".preview-value");
        
        if (previewTitle) {
            previewTitle.textContent = `Bottle Number: ${index + 1}`;
        }
        
        if (editButton) {
            editButton.dataset.index = index;
            editButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const productIndex = parseInt(e.target.dataset.index);
                this.editSingleProduct(productIndex);
            });
        }
        
        // Set text value
        if (textValue) {
            textValue.textContent = customizationData['personalized-text'] || 'Not set';
        }
        
        // Set text orientation
        if (textOrientationDetail && textOrientationValue) {
            const orientation = customizationData['text-orientation'] || 'horizontal';
            textOrientationValue.textContent = orientation === 'vertical' ? 'Vertical' : 'Horizontal';
            textOrientationDetail.style.display = 'block';
        }
        
        // Set font style
        if (fontStyleDetail && fontStyleValue) {
            if (customizationData['font-style-label'] && customizationData['font-style-label'].trim() !== '') {
                fontStyleValue.textContent = customizationData['font-style-label'];
                fontStyleDetail.style.display = 'block';
            } else if (customizationData['font-style'] && customizationData['font-style'].trim() !== '') {                
                fontStyleValue.textContent = this.extractNameFromUrl(customizationData['font-style']) || 'Font Style';
                fontStyleDetail.style.display = 'block';
            } else {
                fontStyleDetail.style.display = 'none';
            }
        }
        
        // Set font pattern
        if (fontPatternDetail && fontPatternValue) {
            if (customizationData['font-pattern-label'] && customizationData['font-pattern-label'].trim() !== '') {
                fontPatternValue.textContent = customizationData['font-pattern-label'];
                fontPatternDetail.style.display = 'block';
            } else if (customizationData['font-pattern'] && customizationData['font-pattern'].trim() !== '') {
                fontPatternValue.textContent = this.extractNameFromUrl(customizationData['font-pattern']) || 'Font Pattern';
                fontPatternDetail.style.display = 'block';
            } else {
                fontPatternDetail.style.display = 'none';
            }
        }
        
        // Set icon
        if (iconDetail && iconValue) {
            if (customizationData['icon'] && customizationData['icon'].trim() !== '' && customizationData['icon-label'] && customizationData['icon-label'].trim() !== '' && customizationData['icon-label'] !== 'No icon') {
                iconValue.textContent = customizationData['icon-label'];
                iconDetail.style.display = 'block';
            } else if (customizationData['icon'] && customizationData['icon'].trim() !== '') {
                iconValue.textContent = this.extractNameFromUrl(customizationData['icon']) || 'Custom Icon';
                iconDetail.style.display = 'block';
            } else {
                iconDetail.style.display = 'none';
            }
        }
        
        // Set quantity
        if (quantityDetail && quantityValue) {
            quantityValue.textContent = `${productQuantity} item${productQuantity > 1 ? 's' : ''}`;
            quantityDetail.style.display = 'flex';
        }
        
        const canvas = previewElement.querySelector('.preview-canvas');
        this.renderActualCanvas(canvas, product);
        
        return previewElement;
    }
    extractNameFromUrl(url) {
        if (!url) return '';
        
        try {
            // Remove query parameters
            const cleanUrl = url.split('?')[0];
            
            // Get filename without extension
            const filename = cleanUrl.split('/').pop();
            const nameWithoutExt = filename.split('.')[0];
            
            // Clean up the name
            let name = nameWithoutExt
                .replace(/[_-]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            
            // Capitalize first letter of each word
            name = name.replace(/\b\w/g, l => l.toUpperCase());
            
            // Special case handling for common patterns
            if (name.toLowerCase().includes('icon')) {
                name = name.replace(/icon/gi, '');
            }
            
            return name.trim() || 'Custom Icon';
        } catch (error) {
            console.error('Error extracting name from URL:', error, url);
            return 'Custom Icon';
        }
    }
    initializeDropdownWithPlaceholder() {
        const dropdownButtons = this.querySelectorAll('.select-dropdown__button .selected-product--quantity');
        dropdownButtons.forEach(button => {
            // Always show "Select Quantity" as placeholder text
            button.textContent = 'Select Quantity';
            button.dataset.placeholder = 'Select Quantity';
        });
        
        // Set the dropdown list to show 1 as selected visually
        const dropdownItems = this.querySelectorAll('.select-dropdown__list-item');
        dropdownItems.forEach(item => {
            if (item.dataset.value === '1') {
                item.classList.add('selected');
            } else {
                item.classList.remove('selected');
            }
        });
    }
    ensureAllCanvasesExist(product) {
        if (!product) return;
        
        const requiredCanvases = [
            'mainPersonalizationCanvas',
            'personalizationCanvas', 
            'personalizationCanvasFontStyle',
            'personalizationCanvasFontPattern',
            'personalizationCanvasIcon',
            'personalizationCanvasPreview'
        ];
        
        requiredCanvases.forEach(canvasId => {
            let canvas = product.querySelector(`#${canvasId}`);
            if (!canvas) {
                canvas = document.createElement('canvas');
                canvas.id = canvasId;
                canvas.width = 3000;
                canvas.height = 3000;
                canvas.style.display = 'none';
                
                // Add to the appropriate container
                const container = product.querySelector('.canvas-container') || 
                                product.querySelector('.customization-steps-container') ||
                                product;
                container.appendChild(canvas);
            }
        });
    }
    populatePreviewGrid() {
        if (!this.previewProductsGrid) return;
        
        this.previewProductsGrid.innerHTML = '';
        
        this.products.forEach((productObj, index) => {
            const productPreview = this.createProductPreview(productObj, index);
            if (productPreview) {
                this.previewProductsGrid.appendChild(productPreview);
            }
        });
    }

    renderActualCanvas(canvas, product) {
        if (!canvas || !product) return;
        
        const productCanvas = product.querySelector('#mainPersonalizationCanvas') || 
                             product.querySelector('#personalizationCanvas') ||
                             product.querySelector('#personalizationCanvasFontStyle') ||
                             product.querySelector('#personalizationCanvasFontPattern') ||
                             product.querySelector('#personalizationCanvasIcon');
        
        if (productCanvas) {
            setTimeout(() => {
                const ctx = canvas.getContext('2d');
                canvas.width = productCanvas.width;
                canvas.height = productCanvas.height;
                ctx.drawImage(productCanvas, 0, 0);
            }, 100);
        } else {
            this.renderFallbackCanvas(canvas, product.savedCustomizationData || {});
        }
    }

    renderFallbackCanvas(canvas, customizationData) {
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        ctx.fillStyle = '#f8f9fa';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        ctx.strokeStyle = '#dee2e6';
        ctx.strokeRect(0, 0, canvas.width, canvas.height);
        
        if (customizationData['personalized-text']) {
            ctx.fillStyle = '#495057';
            ctx.font = 'bold 16px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(customizationData['personalized-text'], canvas.width / 2, canvas.height / 2);
        } else {
            ctx.fillStyle = '#6c757d';
            ctx.font = '12px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText('Customization preview', canvas.width / 2, canvas.height / 2);
        }
    }

    showPreview() {
        this.isPreviewMode = true;
        
        this.products.forEach(productObj => {
            const product = productObj.product;
            product.classList.remove("inview");
            product.classList.add("hidden-block");
        });
        
        if (this.bulkProductsWrapper) {
            this.bulkProductsWrapper.classList.add('hidden-block');
        }
        if (this.bulkPreviewContainer) {
            this.bulkPreviewContainer.classList.remove('hidden-block');
        }
        
        this.populatePreviewGrid();
        
        if (this.addAllToCartBtn) {
            this.addAllToCartBtn.removeAttribute("disabled");
        }
        
        this.scrollToTop();
    }

    hidePreviewStep(product) {
        if (!product) return;
        const previewStep = product.querySelector('.preview-step-container');
        if (previewStep) {
            previewStep.classList.add('hidden-block');
        }
        
        const previewSteps = product.querySelectorAll('[data-step="preview"]');
        previewSteps.forEach(step => {
            step.classList.add('hidden-block');
        });
    }

    scrollToTop() {
        const customizerWrapper = this.querySelector('.bulk-customizer__wrapper');
        if (customizerWrapper) {
            customizerWrapper.scrollTo({ top: 0, behavior: 'smooth' });
        }
        
        if (window.innerWidth <= 768) {
            const modalContent = this.closest('.modal-content');
            if (modalContent) {
                modalContent.scrollTo({ top: 0, behavior: 'smooth' });
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    updateNextButtonText(product, stepType) {
        const nextButton = product.querySelector('.step-next');
        if (!nextButton) return;
        
        if (this.isLastStep(stepType)) {
            if (this.currentProductIndex === this.products.length - 1) {
                nextButton.textContent = 'Next';
            } else {
                nextButton.textContent = 'Next Product';
            }
        } else {
            nextButton.textContent = 'Next';
        }
    }

    resetToFirstStep(product) {
        if (!product) return;
        
        const steps = product.querySelectorAll('.personalization-step');
        steps.forEach(step => {
            step.classList.remove('active');
            if (step.dataset.step === 'preview') {
                step.classList.add('hidden-block');
            } else {
                step.classList.remove('hidden-block');
            }
        });
        
        if (steps[0]) {
            steps[0].classList.add('active');
            steps[0].classList.remove('hidden-block');
        }
        
        this.updateMobileTabs(product, 'text');
        this.updateCanvasVisibility(product, 'text');
        
        const nextButton = product.querySelector('.step-next');
        if (nextButton) {
            nextButton.textContent = 'Next';
            nextButton.disabled = true;
        }
        
        const previewContainer = product.querySelector('.preview-step-container');
        if (previewContainer) {
            previewContainer.classList.add('hidden-block');
        }
        
        const staticImageContainer = product.querySelector('.static-image-container');
        const customizationStepsContainer = product.querySelector('.customization-steps-container');
        
        if (staticImageContainer) {
            staticImageContainer.classList.remove('hidden-block');
        }
        if (customizationStepsContainer) {
            customizationStepsContainer.classList.remove('hidden-block');
        }
        
        const textInput = product.querySelector('#personalizedText');
        if (textInput) {
            setTimeout(() => {
                textInput.focus();
            }, 100);
        }
    }

    updateMobileTabs(product, activeStep) {
        if (!product) return;
        
        const tabButtons = product.querySelectorAll('.tab-button');
        tabButtons.forEach(button => {
            button.classList.remove('active');
            if (button.dataset.tab === activeStep) {
                button.classList.add('active');
            }
        });
    }

    editSingleProduct(productIndex) {
        this.exitPreviewMode();
        this.currentProductIndex = productIndex;
        this.switchProduct(this.products[productIndex].tab);
        this.scrollToTop();
    }

    exitPreviewMode() {
        this.isPreviewMode = false;
        
        if (this.bulkPreviewContainer) {
            this.bulkPreviewContainer.classList.add('hidden-block');
        }
        if (this.bulkProductsWrapper) {
            this.bulkProductsWrapper.classList.remove('hidden-block');
        }
        
        this.showProductSelectionUI();
        
        this.scrollToTop();
    }

    resetToFirstStepWithoutClearingData(product) {
        if (!product) return;
        
        const steps = product.querySelectorAll('.personalization-step');
        steps.forEach(step => {
            step.classList.remove('active');
            if (step.dataset.step === 'preview') {
                step.classList.add('hidden-block');
            } else {
                step.classList.remove('hidden-block');
            }
        });
        
        if (steps[0]) {
            steps[0].classList.add('active');
            steps[0].classList.remove('hidden-block');
        }
        
        this.updateMobileTabs(product, 'text');
        this.updateCanvasVisibility(product, 'text');
        
        const nextButton = product.querySelector('.step-next');
        if (nextButton) {
            const hasCustomization = this.hasCustomizationData(product);
            nextButton.disabled = !hasCustomization;
            nextButton.textContent = 'Next';
        }
        
        const previewContainer = product.querySelector('.preview-step-container');
        if (previewContainer) {
            previewContainer.classList.add('hidden-block');
        }
        
        const staticImageContainer = product.querySelector('.static-image-container');
        const customizationStepsContainer = product.querySelector('.customization-steps-container');
        
        if (staticImageContainer) {
            staticImageContainer.classList.remove('hidden-block');
        }
        if (customizationStepsContainer) {
            customizationStepsContainer.classList.remove('hidden-block');
        }
        
        const textInput = product.querySelector('#personalizedText');
        if (textInput && product.savedCustomizationData && product.savedCustomizationData['personalized-text']) {
            textInput.value = product.savedCustomizationData['personalized-text'];
        }
    }
    
    hasCustomizationData(product) {
        if (!product || !product.savedCustomizationData) return false;
        
        const { icon, "personalized-text": personalizedText } = product.savedCustomizationData;
        return (icon?.trim() !== "") || (personalizedText?.trim() !== "");
    }

    handleCSVDownloadBtnEvent() {
        this.CSVDownloadBtn?.addEventListener("click", (e) => {
            e.preventDefault();
            if (this.CSVDownloadBtn.parentElement) {
                this.CSVDownloadBtn.parentElement.click();
            }
            this.CSVDownloadBtn.style.setProperty("--download-button--width", `${this.CSVDownloadBtn.getBoundingClientRect().width}px`);
            const previousLabel = this.CSVDownloadBtnLabel.textContent;
            this.CSVDownloadBtnLabel.innerHTML = "Done";
            this.CSVDownloadBtn.classList.add("active");

            setTimeout(() => {
                this.CSVDownloadBtn.style.setProperty("--download-button--width", `fit-content`);
                this.CSVDownloadBtnLabel.innerHTML = "Download Again";
                this.CSVDownloadBtn.style.setProperty("--download-button--width", `${this.CSVDownloadBtn.getBoundingClientRect().width}px`);
                this.CSVDownloadBtn.classList.remove("active");
                if (previousLabel !== "Download Again") {
                    this.setCompleteStep(1);
                    this.setActiveStep(2);
                }
            }, 2000);
        });
    }

    updateBulkPersonalization() {
        this.updateATCButton(this.bulkFileATCButton, this.bulkFileATCButtonLabel);
        this.availableVariantQuantity == 0 ? this.disableFileInput() : this.enableFileInput();
        
        if (this.personalizationModal) {
            const outerButton = this.personalizationModal.querySelector('.products-personalization-button');
            if (outerButton) {
                const btnText = outerButton.querySelector('.btn__text');
                const icon = outerButton.querySelector('.personalization-icon');
                
                if (!outerButton.dataset.originalText && btnText) {
                    outerButton.dataset.originalText = btnText.textContent.trim();
                }
                
                if (this.availableVariantQuantity < 1) {
                    if (btnText) btnText.textContent = "Sold out";
                    if (icon) icon.style.display = "none";
                    outerButton.classList.add('bs-cursor-not-allowed');
                    outerButton.disabled = true;
                    outerButton.setAttribute('disabled', 'disabled');
                    outerButton.style.opacity = '0.5';
                    outerButton.style.cursor = 'not-allowed';
                    outerButton.style.pointerEvents = 'none';
                } else {
                    if (btnText) btnText.textContent = outerButton.dataset.originalText;
                    if (icon) icon.style.display = "";
                    outerButton.classList.remove('bs-cursor-not-allowed');
                    outerButton.disabled = false;
                    outerButton.removeAttribute('disabled');
                    outerButton.style.opacity = '';
                    outerButton.style.cursor = '';
                    outerButton.style.pointerEvents = '';
                }
            }
        }
        
        // Update all product ATC buttons
        this.products.forEach(prdMap => {
            const productATCBtn = prdMap.product.querySelector("button[data-action=bulk-add-to-cart]")
            
            // FIXED: Match single personalization styling
            if (productATCBtn) {
                // Store original text if not already stored
                if (!productATCBtn.dataset.originalText) {
                    productATCBtn.dataset.originalText = productATCBtn.textContent;
                }
                
                if (this.availableVariantQuantity < 1) {
                    productATCBtn.textContent = "Out of stock";
                    productATCBtn.classList.add('bs-cursor-not-allowed');
                    productATCBtn.disabled = true;
                    productATCBtn.setAttribute('disabled', 'disabled');
                    productATCBtn.style.opacity = '0.5';
                    productATCBtn.style.cursor = 'not-allowed';
                    productATCBtn.style.pointerEvents = 'none';
                } else {
                    productATCBtn.textContent = productATCBtn.dataset.originalText || this.bulkATCLabel;
                    productATCBtn.classList.remove('bs-cursor-not-allowed');
                    
                    // Button will be disabled/enabled by validateAllCustomizers based on customization
                    productATCBtn.disabled = false;
                    productATCBtn.removeAttribute('disabled');
                    productATCBtn.style.opacity = '';
                    productATCBtn.style.cursor = '';
                    productATCBtn.style.pointerEvents = '';
                }
            }
        });
        
        this.updateQuantityDropdownItems();
        if (this.availableProductElement) {
            this.availableProductElement.textContent = ` Available product quantity: ${this.availableVariantQuantity}`;
        }
        
        // Re-validate all customizers to update button states
        this.validateAllCustomizers();
    }

    updateQuantityDropdownItems() {
        const qty = this.availableVariantQuantity;
        const dropdownItems = this.querySelectorAll(".select-dropdown__list-item");
        dropdownItems.forEach(item => {
            let val = parseInt(item.dataset.value);
            item.style.display = (qty <= 1 && val === 1) || (qty > 1 && qty <= 9 && val <= qty) || qty > 9 ? "block" : "block";
        });
    }

    setupBulkActionWrapperEvent(wrapper) {
        wrapper.addEventListener("pointerdown", (event) => {
            const bulkATCButton = wrapper.querySelector("button[data-action=bulk-add-to-cart]");
            if (bulkATCButton && bulkATCButton.textContent != "Out of stock" && event.target === bulkATCButton && bulkATCButton.disabled) {
                if (this.emptyTabs === undefined || this.emptyTabs === 0) {
                    const allTabs = this.querySelectorAll("button.products-switcher--tab");
                    allTabs.forEach(tab => {
                        if (tab !== this.lastActiveTab) tab.querySelector(".empty-svg__wrapper").classList.add("active");
                    })
                } else {
                    this.emptyTabs.forEach(tab => {
                        if (tab !== this.lastActiveTab) tab.querySelector(".empty-svg__wrapper").classList.add("active");
                    })
                }
                if (this.availableVariantQuantity > 0) {
                    document.body.querySelector('milton-toast')?.showErrorToast(`Some product customizers are empty. Click their respective tabs to customize!`);
                } else {
                    document.body.querySelector('milton-toast')?.showErrorToast(`This product is out of stock. Check back soon or explore similar items!`);
                }
            }
        });
    }

    setupBulkCustomizerValidation() {
        this.products.forEach(productObj => {
            const product = productObj.product;
            this.setupSingleBulkCustomizerValidation(product);
        });
    }

    setupSingleBulkCustomizerValidation(product) {
        if (!product) return;
        
        const textInput = product.querySelector('#personalizedText');
        if (textInput) {
            const newTextInput = textInput.cloneNode(true);
            textInput.parentNode.replaceChild(newTextInput, textInput);
            
            newTextInput.addEventListener('input', this.debounce((e) => {
                this.handleBulkTextInput(e, product);
            }, 200));
        }
        
        const optionInputs = product.querySelectorAll('input[name="font-style"], input[name="font-pattern"], input[name="icon"]');
        optionInputs.forEach(input => {
            const newInput = input.cloneNode(true);
            input.parentNode.replaceChild(newInput, input);
            
            newInput.addEventListener('change', (e) => {
                this.handleBulkOptionChange(e, product);
            });
        });
    }

    handleBulkTextInput(e, product) {
        const textInput = e.target;
        const rawValue = textInput.value;
        
        textInput.classList.remove("red-outline");
    
        let text = rawValue;
        
        if (text.length > 0) {
            text = text.replace(/[^a-zA-Z ]/g, "");
            text = text.replace(/^\s+/, "");
            text = text.slice(0, 11);
            
            if (text !== rawValue) {
                textInput.value = text;
            }
        }
    
        const trimmedText = text.trim();
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        product.savedCustomizationData["personalized-text"] = trimmedText;
                
        // Get all customization data for proper rendering
        const fontPattern = product.savedCustomizationData?.["font-pattern"] || "";
        const orientation = product.savedCustomizationData?.["text-orientation"] || "horizontal";
        const fontStyle = product.savedCustomizationData?.["font-style"] || "";
        const iconUrl = product.savedCustomizationData?.["icon"] || "";
        
        // Update immediately with both bottle image and text
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: { text: trimmedText }
        }));
    }
    createEmergencyBottleImage() {        
        const canvas = document.createElement('canvas');
        canvas.width = 3000;
        canvas.height = 3000;
        
        const ctx = canvas.getContext('2d');
        
        // Create a gradient background
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#e0e0e0');
        gradient.addColorStop(1, '#c0c0c0');
        
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Draw a simple bottle outline
        ctx.strokeStyle = '#999999';
        ctx.lineWidth = 20;
        ctx.strokeRect(canvas.width * 0.2, canvas.height * 0.1, canvas.width * 0.6, canvas.height * 0.8);
        
        // Add some text indicating it's a product
        ctx.fillStyle = '#666666';
        ctx.font = 'bold 200px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('PRODUCT', canvas.width / 2, canvas.height / 2);
        
        this.blankBottleImage = new Image();
        this.blankBottleImage.src = canvas.toDataURL('image/png');
        this.blankBottleImage.onload = () => {
            this.updateAllCanvasesWithStoredImage();
        };
    }

    forceCanvasUpdate(product, text) {
        if (!product) return;
            
        const currentStep = this.getCurrentlyActiveStep(product);
        const stepType = currentStep ? currentStep.dataset.step : 'text';
        const canvasesToUpdate = [];
        
        const currentCanvas = this.getCurrentStepCanvas(product, stepType);
        if (currentCanvas) canvasesToUpdate.push(currentCanvas);
        
        const mainCanvas = product.querySelector('#mainPersonalizationCanvas');
        if (mainCanvas) canvasesToUpdate.push(mainCanvas);
        
        canvasesToUpdate.forEach(canvas => {
            this.renderSingleCanvas(product, canvas, text);
        });
    }

    renderSingleCanvas(product, canvas, text) {
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        if (this.blankBottleImage && this.blankBottleImage.complete) {
            ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
        } else {
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        
        if (text && text.trim() !== '') {
            this.drawTextOnCanvas(ctx, text, canvas.width, canvas.height);
        }
        
    }

    updateCanvasWithText(product, text) {
        if (!product) return;
        
        let canvas = null;
        const currentStep = this.getCurrentlyActiveStep(product);
        
        if (currentStep) {
            const stepType = currentStep.dataset.step;
            switch(stepType) {
                case 'text':
                    canvas = product.querySelector('#personalizationCanvas');
                    break;
                case 'font-style':
                    canvas = product.querySelector('#personalizationCanvasFontStyle');
                    break;
                case 'font-pattern':
                    canvas = product.querySelector('#personalizationCanvasFontPattern');
                    break;
                case 'icon':
                    canvas = product.querySelector('#personalizationCanvasIcon');
                    break;
                default:
                    canvas = product.querySelector('#mainPersonalizationCanvas');
            }
        }
        if (!canvas) {
            canvas = product.querySelector('#mainPersonalizationCanvas');
        }
        
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        if (this.blankBottleImage && this.blankBottleImage.complete) {
            ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
        } else {
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        
        if (text && text.trim() !== '') {
            this.drawTextOnCanvas(ctx, text, canvas.width, canvas.height);
        }
    }

    drawTextOnCanvas(ctx, text, width, height, orientation = "horizontal") {
        if (!text || text.trim() === '') {
            return;
        }
        
        // Use the safe method to get customization region
        const customizationRegion = this.getCustomizationRegionData();
        
        let centerX, centerY;
        
        if (customizationRegion) {
            centerX = customizationRegion.x + (customizationRegion.width / 2);
            centerY = customizationRegion.y + (customizationRegion.height / 2);
        } else {
            centerX = width / 2;
            centerY = height / 2;
        }
        
        // Use same large font size
        const textStyle = {
            color: '#ffffff',
            fontSize: '120px',
            fontFamily: 'Arial, sans-serif',
            fontWeight: 'bold'
        };
        
        ctx.font = `${textStyle.fontWeight} ${textStyle.fontSize} ${textStyle.fontFamily}`;
        ctx.fillStyle = textStyle.color;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
        ctx.shadowBlur = 6;
        ctx.shadowOffsetX = 3;
        ctx.shadowOffsetY = 3;
        
        // Save the current canvas state
        ctx.save();
        
        if (orientation === "vertical") {
            // Rotate the canvas 90 degrees for vertical text
            ctx.translate(centerX, centerY);
            ctx.rotate(-Math.PI / 2); // -90 degrees
            ctx.translate(-centerX, -centerY);
        }
        
        ctx.fillText(text, centerX, centerY);
        
        // Restore the canvas state
        ctx.restore();
        
        // Reset shadow
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
    }
    clearCanvasForStep(product, stepType) {
        if (!product) return;
        
        const canvas = this.getCurrentStepCanvas(product, stepType);
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        if (this.blankBottleImage && this.blankBottleImage.complete) {
            ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
        } else {
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        
    }
    // Update the existing handleBulkOptionChange for non-font-style options
    handleBulkOptionChange(e, product) {
        const input = e.target;
        const optionName = input.name;
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        // Skip font-style as it has its own handler
        if (optionName === 'font-style') {
            return;
        }
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
                
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        if (input.checked) {
            // Option is being deselected
            if (optionName === 'icon') {
                // Allow icon deselection
                input.checked = false;
                
                // Clear the data
                product.savedCustomizationData[optionName] = "";
                product.savedCustomizationData[`${optionName}-label`] = "";
                
                // Remove selected class from label
                this.removeOptionSelectedClass(product, optionName, input);            
            }
            // For font-pattern, do nothing when already selected (prevent deselection)
        } else {
            // Option is being selected - uncheck others for this option group
            allInputs.forEach(option => {
                if (option !== input) {
                    option.checked = false;
                    // Remove selected class from other labels
                    const otherLabel = option.closest('label') || product.querySelector(`label[for="${option.id}"]`);
                    if (otherLabel) {
                        otherLabel.classList.remove(`${optionName}-option-selected`);
                    }
                }
            });
            
            // Select current option
            input.checked = true;
            
            // Update customization data
            product.savedCustomizationData[optionName] = optionData;
            product.savedCustomizationData[`${optionName}-label`] = optionLabel;
            
            // Add selected class to the label
            const label = input.closest('label') || product.querySelector(`label[for="${input.id}"]`);
            if (label) {
                label.classList.add(`${optionName}-option-selected`);
            }
        }
        
        // Force immediate canvas update with ALL current data
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    updateProductImageForVariant(variantId) {
        if (!variantId) return;
        
        // Get the image URL for this variant
        const variantsImgScript = document.body.querySelector("#variantPersonalizationImage");
        if (!variantsImgScript) {
            console.error('❌ Variant image script not found');
            return;
        }
        
        const variantsPersonalizationImages = JSON.parse(variantsImgScript.textContent || '{}');
        const imageUrl = variantsPersonalizationImages[variantId];
        
        if (!imageUrl) {
            console.error(`❌ No image found for variant ${variantId}`);
            return;
        }
        
        // Create a new image for the variant
        const variantImg = new Image();
        variantImg.crossOrigin = "anonymous";
        variantImg.src = imageUrl;
        
        variantImg.onload = () => {            
            // Store this as the current bottle image
            this.blankBottleImage = variantImg;
            
            // Update all product customizers with the new variant ID
            this.products.forEach(productObj => {
                const product = productObj.product;
                if (product) {
                    // Update the variant ID in the product customizer
                    product.variantId = variantId;
                    
                    // Update the product image in the customizer
                    if (product.productImg) {
                        product.productImg.src = imageUrl;
                    }
                }
            });
            
            // Force redraw all canvases
            this.updateAllCanvasesWithNewImage(variantImg);
        };
        
        variantImg.onerror = () => {
            console.error(`❌ Failed to load image for variant ${variantId}`);
        };
    }
    updateAllCanvasesWithNewImage(newImage) {
        if (!newImage || !newImage.complete) return;
        
        // Update all product canvases
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            if (product) {
                // Get all canvases for this product
                const canvases = [
                    product.querySelector('#mainPersonalizationCanvas'),
                    product.querySelector('#personalizationCanvas'),
                    product.querySelector('#personalizationCanvasFontStyle'),
                    product.querySelector('#personalizationCanvasFontPattern'),
                    product.querySelector('#personalizationCanvasIcon'),
                    product.querySelector('#personalizationCanvasPreview')
                ];
                
                // Update each canvas
                canvases.forEach(canvas => {
                    if (canvas) {
                        const ctx = canvas.getContext('2d');
                        if (!ctx) return;
                        
                        // Clear and redraw with new image
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        this.processCanvasImage(canvas, ctx, newImage);
                        
                        // Also redraw any existing text/icon
                        const customizationData = product.savedCustomizationData || {};
                        const text = customizationData["personalized-text"] || "";
                        const fontPattern = customizationData["font-pattern"] || "";
                        const orientation = customizationData["text-orientation"] || "horizontal";
                        const fontStyle = customizationData["font-style"] || "";
                        const iconUrl = customizationData["icon"] || "";
                        
                        if (text || iconUrl) {
                            this.drawTextAndIconOnCanvas(ctx, canvas, text, fontPattern, orientation, fontStyle, iconUrl);
                        }
                    }
                });
            }
        });
    }
    // Update the applyInitialOptionClasses method
    applyInitialOptionClasses(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const customizationData = product.savedCustomizationData;
        
        // Apply font-style selected class
        if (customizationData["font-style"]) {
            const fontStyleInputs = product.querySelectorAll('input[name="font-style"]');
            fontStyleInputs.forEach(input => {
                if (input.dataset.optionData === customizationData["font-style"]) {
                    input.checked = true;
                    this.addOptionSelectedClass(product, 'font-style', input);
                } else {
                    input.checked = false;
                    this.removeOptionSelectedClass(product, 'font-style', input);
                }
            });
        }
        
        // Apply font-pattern selected class
        if (customizationData["font-pattern"]) {
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            fontPatternInputs.forEach(input => {
                if (input.dataset.optionData === customizationData["font-pattern"]) {
                    input.checked = true;
                    this.addOptionSelectedClass(product, 'font-pattern', input);
                } else {
                    input.checked = false;
                    this.removeOptionSelectedClass(product, 'font-pattern', input);
                }
            });
        } else {
            // If no font pattern is selected, ensure all are unchecked
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            fontPatternInputs.forEach(input => {
                input.checked = false;
                this.removeOptionSelectedClass(product, 'font-pattern', input);
            });
        }
        
        // Apply icon selected class
        if (customizationData["icon"]) {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                if (input.dataset.optionData === customizationData["icon"]) {
                    input.checked = true;
                    this.addOptionSelectedClass(product, 'icon', input);
                } else {
                    input.checked = false;
                    this.removeOptionSelectedClass(product, 'icon', input);
                }
            });
        } else {
            // If no icon is selected, ensure all are unchecked
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                input.checked = false;
                this.removeOptionSelectedClass(product, 'icon', input);
            });
        }
    }
        // NEW METHOD: Handle option deselection
    handleBulkOptionDeselection(product, optionName) {
        if (!product) return;
        
        const allInputs = product.querySelectorAll(`input[name="${optionName}"]`);
        
        // Uncheck all inputs for this option
        allInputs.forEach(input => {
            input.checked = false;
            this.updateOptionLabelClass(product, optionName, input);
        });
        
        // Clear the data
        if (product.savedCustomizationData) {
            product.savedCustomizationData[optionName] = "";
            product.savedCustomizationData[`${optionName}-label`] = "";
        }
                
        // Force canvas update
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    handleBulkFontStyleChange(e, product) {
        const input = e.target;
        const optionData = input.dataset.optionData;
        const optionLabel = input.dataset.optionLabel;
        
        if (!product.savedCustomizationData) {
            product.savedCustomizationData = {};
        }
        
        const allInputs = product.querySelectorAll('input[name="font-style"]');
        
        // Uncheck all other font style options and remove their classes
        allInputs.forEach(option => {
            if (option !== input) {
                option.checked = false;
                this.removeOptionSelectedClass(product, 'font-style', option);
            }
        });
        
        // Set the current input as checked
        input.checked = true;
        
        // Update customization data
        product.savedCustomizationData["font-style"] = optionData;
        product.savedCustomizationData["font-style-label"] = optionLabel;
        
        // CRITICAL: Add the selected class
        this.addOptionSelectedClass(product, 'font-style', input);        
        
        // Force canvas update
        this.forceBulkCanvasUpdateWithText(product);
        
        this.updateBulkNextButtonState(product);
        this.validateAllCustomizers();
        
        product.dispatchEvent(new CustomEvent('BulkCustomizerChange', {
            detail: {...product.savedCustomizationData}
        }));
    }
    // NEW METHOD: Apply pending visual classes only
    applyPendingVisualClasses(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const data = product.savedCustomizationData;
        
        // Apply font pattern visual class if pattern is selected
        if (data["font-pattern"] && data["font-pattern"].trim() !== "") {
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            fontPatternInputs.forEach(input => {
                if (input.dataset.optionData === data["font-pattern"]) {
                    input.checked = true;
                    this.updateOptionLabelClass(product, 'font-pattern', input);
                }
            });
        }
        
        // Apply icon visual class if icon is selected
        if (data["icon"] && data["icon"].trim() !== "") {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                if (input.dataset.optionData === data["icon"]) {
                    input.checked = true;
                    this.updateOptionLabelClass(product, 'icon', input);                    
                }
            });
        } else if (data["icon-label"] === "No icon") {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                const isNoIconInput = (input.value === "No icon" || input.dataset.optionLabel === "No icon");
                const label = input.closest('label');
                if (isNoIconInput) {
                    input.checked = true;
                    if (label) label.classList.add('icon-option-selected');
                } else {
                    input.checked = false;
                    if (label) label.classList.remove('icon-option-selected');
                }
            });
        }
    }
    applyPendingOptionClasses(product) {
        if (!product || !product.savedCustomizationData) return;
        
        const data = product.savedCustomizationData;
        
        // Apply font pattern class if pattern is selected
        if (data["font-pattern"] && data["font-pattern"].trim() !== "") {
            const fontPatternInputs = product.querySelectorAll('input[name="font-pattern"]');
            fontPatternInputs.forEach(input => {
                if (input.dataset.optionData === data["font-pattern"]) {
                    input.checked = true;
                    this.updateOptionLabelClass(product, 'font-pattern', input);
                }
            });
        }
        
        // Apply icon class if icon is selected
        if (data["icon"] && data["icon"].trim() !== "") {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                if (input.dataset.optionData === data["icon"]) {
                    input.checked = true;
                    this.updateOptionLabelClass(product, 'icon', input);
                }
            });
        } else if (data["icon-label"] === "No icon") {
            const iconInputs = product.querySelectorAll('input[name="icon"]');
            iconInputs.forEach(input => {
                const isNoIconInput = (input.value === "No icon" || input.dataset.optionLabel === "No icon");
                const label = input.closest('label');
                if (isNoIconInput) {
                    input.checked = true;
                    if (label) label.classList.add('icon-option-selected');
                } else {
                    input.checked = false;
                    if (label) label.classList.remove('icon-option-selected');
                }
            });
        }
    }
    // EMERGENCY: Ensure canvas always shows something
    emergencyCanvasRender(canvas, text = '') {
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Always draw a background
        ctx.fillStyle = '#f8f9fa';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Draw bottle outline
        ctx.strokeStyle = '#dee2e6';
        ctx.lineWidth = 8;
        ctx.strokeRect(canvas.width * 0.2, canvas.height * 0.1, canvas.width * 0.6, canvas.height * 0.8);
        
        // Draw text if provided
        if (text && text.trim() !== '') {
            ctx.fillStyle = '#495057';
            ctx.font = 'bold 100px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(text, canvas.width / 2, canvas.height / 2);
        }
        
    }
    updateCanvasWithIcon(product, iconUrl) {
        if (!product || !iconUrl) return;
        
        let canvas = product.querySelector('#personalizationCanvasIcon');
        if (!canvas) {
            canvas = product.querySelector('#mainPersonalizationCanvas');
        }
        if (!canvas) return;
        
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        if (this.blankBottleImage && this.blankBottleImage.complete) {
            ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
        } else {
            ctx.fillStyle = '#f8f9fa';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        
        const img = new Image();
        img.onload = () => {
            const maxBox = Math.min(canvas.width, canvas.height) * 0.85;
            let drawW = maxBox;
            let drawH = maxBox;
            if (img.naturalWidth && img.naturalHeight) {
                const aspectRatio = img.naturalHeight / img.naturalWidth;
                if (aspectRatio > 1) {
                    drawH = maxBox;
                    drawW = maxBox / aspectRatio;
                } else {
                    drawW = maxBox;
                    drawH = maxBox * aspectRatio;
                }
            }
            const x = (canvas.width - drawW) / 2;
            const y = (canvas.height - drawH) / 2;
            
            ctx.drawImage(img, x, y, drawW, drawH);
        };
        img.onerror = () => {
            console.error('Failed to load icon:', iconUrl);
            this.drawIconPlaceholder(ctx, canvas.width, canvas.height);
        };
        img.src = iconUrl;
    }

    drawIconPlaceholder(ctx, width, height) {
        const centerX = width / 2;
        const centerY = height / 2;
        const size = Math.min(width, height) * 0.3;
        
        ctx.fillStyle = '#666666';
        ctx.beginPath();
        ctx.rect(centerX - size/2, centerY - size/2, size, size);
        ctx.fill();
        
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 16px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('Icon', centerX, centerY);
    }

    updateBulkNextButtonState(product) {
        if (!product) return;
        
        const customizationData = product.savedCustomizationData || {};
        const hasText = customizationData["personalized-text"] && customizationData["personalized-text"].trim() !== "";
        
        const desktopNextButton = product.querySelector('.desktop-step-navigation .step-next') || 
                                product.querySelector('.sticky-contents .step-next') ||
                                product.querySelector('.step-next');
        
        const mobileNextButtons = product.querySelectorAll('.mobile-step-navigation .step-next, .mobile-sticky-btns .step-next');
        
        if (desktopNextButton) {
            this.updateSingleButtonState(desktopNextButton, hasText, 'desktop');
        } else {
            console.warn('❌ Desktop next button not found in product');
            const fallbackButton = this.querySelector('.desktop-step-navigation .step-next');
            if (fallbackButton) {
                this.updateSingleButtonState(fallbackButton, hasText, 'desktop-fallback');
            }
        }
        mobileNextButtons.forEach((button, index) => {
            this.updateSingleButtonState(button, hasText, `mobile-${index}`);
        });
        if (!desktopNextButton && mobileNextButtons.length === 0) {
            console.warn('❌ No next buttons found in product. Available buttons:', {
                desktop: product.querySelectorAll('.step-next'),
                sticky: product.querySelectorAll('.sticky-contents .step-next'),
                mobile: product.querySelectorAll('.mobile-step-navigation .step-next')
            });
        }
    }

    updateSingleButtonState(button, enabled, type) {
        if (!button) return;
        
        if (enabled) {
            button.disabled = false;
            button.removeAttribute('disabled');
            button.classList.remove('disabled');
            button.style.opacity = '1';
            button.style.cursor = 'pointer';
            button.style.pointerEvents = 'auto';
        } else {
            button.disabled = true;
            button.setAttribute('disabled', 'disabled');
            button.classList.add('disabled');
            button.style.opacity = '0.5';
            button.style.cursor = 'not-allowed';
            button.style.pointerEvents = 'none';
        }
    }

    // Update the validateAllCustomizers method in BulkPersonalization class
    validateAllCustomizers() {        
        this.emptyTabs = this.products
            .filter(prd => {
                const product = prd.product;
                const customizationData = product.savedCustomizationData || {};
                const { icon, "icon-label": iconLabel, "personalized-text": personalizedText } = customizationData;
                const hasCustomization = (icon?.trim() !== "") || (iconLabel === "No icon") || (personalizedText?.trim() !== "");              
            
                return !hasCustomization;
            })
            .map(prd => prd.tab);
        
        const hasEmptyProducts = this.emptyTabs.length > 0;
        
        // CHECK FOR OUT OF STOCK
        const isOutOfStock = this.availableVariantQuantity < 1;
    
        this.products.forEach(productObj => {
            this.updateBulkNextButtonState(productObj.product);
        });
        
        // FIXED: Check both conditions - empty products OR out of stock
        if (this.allBulkATCBtns) {
            this.allBulkATCBtns.forEach(Btn => {
                // Disable if there are empty products OR product is out of stock
                const shouldDisable = hasEmptyProducts || isOutOfStock;
                
                // Match single personalization styling
                if (isOutOfStock) {
                    Btn.textContent = "Out of stock";
                    Btn.classList.add('bs-cursor-not-allowed');
                    Btn.disabled = true;
                    Btn.setAttribute('disabled', 'disabled');
                    Btn.style.opacity = '0.5';
                    Btn.style.cursor = 'not-allowed';
                    Btn.style.pointerEvents = 'none';
                } else {
                    Btn.textContent = this.bulkATCLabel;
                    Btn.classList.remove('bs-cursor-not-allowed');
                    Btn.disabled = shouldDisable;
                    
                    if (shouldDisable) {
                        Btn.setAttribute('disabled', 'disabled');
                        Btn.style.opacity = '0.5';
                        Btn.style.cursor = 'not-allowed';
                        Btn.style.pointerEvents = 'none';
                    } else {
                        Btn.removeAttribute('disabled');
                        Btn.style.opacity = '';
                        Btn.style.cursor = '';
                        Btn.style.pointerEvents = '';
                    }
                }
            });
        }
        
        if (this.addAllToCartBtn) {
            const allProductsHaveCustomization = this.products.every(productObj => {
                const customizationData = productObj.product?.savedCustomizationData || {};
                const { icon, "personalized-text": personalizedText } = customizationData;
                return (icon?.trim() !== "") || (personalizedText?.trim() !== "");
            });
            
            // FIXED: Check both conditions
            const shouldDisableAll = !allProductsHaveCustomization || this.availableVariantQuantity < 1;
            
            // Match single personalization styling
            if (this.availableVariantQuantity < 1) {
                this.addAllToCartBtn.textContent = "Out of stock";
                this.addAllToCartBtn.classList.add('bs-cursor-not-allowed');
                this.addAllToCartBtn.disabled = true;
                this.addAllToCartBtn.setAttribute('disabled', 'disabled');
                this.addAllToCartBtn.style.opacity = '0.5';
                this.addAllToCartBtn.style.cursor = 'not-allowed';
                this.addAllToCartBtn.style.pointerEvents = 'none';
            } else {
                this.addAllToCartBtn.textContent = this.addAllToCartBtn.dataset.originalText || "Add All to Cart";
                this.addAllToCartBtn.classList.remove('bs-cursor-not-allowed');
                this.addAllToCartBtn.disabled = shouldDisableAll;
                
                if (shouldDisableAll) {
                    this.addAllToCartBtn.setAttribute('disabled', 'disabled');
                    this.addAllToCartBtn.style.opacity = '0.5';
                    this.addAllToCartBtn.style.cursor = 'not-allowed';
                    this.addAllToCartBtn.style.pointerEvents = 'none';
                } else {
                    this.addAllToCartBtn.removeAttribute('disabled');
                    this.addAllToCartBtn.style.opacity = '';
                    this.addAllToCartBtn.style.cursor = '';
                    this.addAllToCartBtn.style.pointerEvents = '';
                }
            }
        }
        
        this.updateAllProductsCompletionStatus();
    }

    handleBulkFileATC(e) {
        e.preventDefault();
        
        if (!this.parsedCSVData || this.parsedCSVData.length === 0) {
            document.body.querySelector('milton-toast')?.showErrorToast(`No uploaded products found. Please upload a CSV file first.`);
            return;
        }
        
        // Check if out of stock
        if (this.availableVariantQuantity < 1) {
            document.body.querySelector('milton-toast')?.showErrorToast(`This product is out of stock.`);
            return;
        }
        
        this.initialATCLabel = this.bulkFileATCButtonLabel;        
        
        const cartItems = this.parsedCSVData.map((item, index) => {
            const properties = {
                "personalization type": "bulk file personalization"
            };
            
            const nameText = String(item.Name).trim();
            if (nameText && nameText.length > 0 && nameText.length <= 11) {
                properties[`product${index + 1} personalized text`] = nameText;
                
                if (item['Font Style'] && item['Font Style'].trim() !== '') {
                    properties[`product${index + 1} font style`] = item['Font Style'];
                }
                if (item['Font Pattern'] && item['Font Pattern'].trim() !== '') {
                    properties[`product${index + 1} font pattern`] = item['Font Pattern'];
                }
                if (item['Icon'] && item['Icon'].trim() !== '' && item['Icon'].trim() !== 'No icon') {
                    // For CSV uploads, extract name from URL if needed
                    let iconValue = item['Icon'];
                    if (iconValue.includes('http') || iconValue.includes('www.')) {
                        iconValue = this.extractNameFromUrl(iconValue) || 'Custom Icon';
                    }
                    properties[`product${index + 1} icon`] = iconValue;
                }
            }
            
            return {
                id: this.variantID,
                quantity: 1,
                properties: properties
            };
        });
        
        this.sendMultipleItemsToCart(cartItems, this.bulkFileATCButton);
    }

    resetBulkPersonalization() {        
        this.showManualBulkUI();
        
        this.parsedCSVData = [];
        this.bulkFileQuantity = 0;        
        this._handleRemoveFilesButtonClick();
        this.setCompleteStep(0);
        this.setActiveStep(1);        
        this.handleProductQuantityChange(1, false);
        
        this.products.forEach(productObj => {
            if (productObj.product && productObj.product.resetAllSelections) {
                productObj.product.resetAllSelections();
            }
        });
        // ADD THIS LINE - Hide the bulk preview container when resetting
        if (this.bulkPreviewContainer) {
            this.bulkPreviewContainer.classList.add('hidden-block');
        }
    }

    setupBackToManualButton() {
        const backToManualBtn = this.querySelector('.back-to-manual-group-personalize-btn');
        if (backToManualBtn) {
            backToManualBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.showManualBulkUI();
            });
        }
    }
    
    removeProduct(productsToRemove, removeInSequence = false) {
        if (removeInSequence) {
            for (let i = 0; i < productsToRemove; i++) {
                setTimeout(() => {
                    if (this.products.length > 0) {
                        this.deleteProduct(this.products[this.products.length - 1].tab, true);
                    }
                }, i * 50);
            }
        } else {
            const productsToDelete = [];
            for (let i = 0; i < productsToRemove; i++) {
                if (this.products.length > 0) {
                    productsToDelete.push(this.products[this.products.length - 1]);
                    this.products.pop(); 
                }
            }
            
            productsToDelete.forEach(productObj => {
                this.deleteProductImmediately(productObj.tab, productObj.product);
            });
            
            this.updateTabLabels();
            this.updateAllDropdownButtons();
            this.validateAllCustomizers();
        }
    }

    deleteProductImmediately(tabElement, productElement) {
        const tabLabel = tabElement.querySelector('.tab--label').textContent;
        
        if (productElement && productElement.parentNode) {
            productElement.remove();
        }
        this.removeTabByLabelImmediately(tabLabel);
    }

    removeTabByLabelImmediately(tabLabel) {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        allTabs.forEach(tab => {
            if (tab.querySelector('.tab--label').textContent === tabLabel) {
                tab.remove();
            }
        });
    }

    setupBulkCloseEvent(Btn) {
        Btn.addEventListener("click", () => {
            if (this.personalizationModal?.querySelector("modal-viewer")?.classList.contains("active")) {
                this.personalizationModal.toggleModal();
            }
        });
    }

    setCompleteStep(stepNumber) {
        this.steps.forEach((step, index) => {
            step.classList.remove("progress__item--active", "progress__item--loading", "progress__item--error");
            if (index < stepNumber) {
                step.classList.add("progress__item--completed");
            }
        });
    }

    setActiveStep(stepNumber) {
        this.steps.forEach((step, index) => {
            if (index == stepNumber - 1) {
                step.classList.remove("progress__item--completed", "progress__item--loading", "progress__item--error")
                step.classList.add("progress__item--active");
            } else if (index > stepNumber - 1) {
                step.classList.remove("progress__item--completed", "progress__item--acitve", "progress__item--error");
            }
        });
    }

    setLoadingStep(stepNumber) {
        this.steps.forEach((step, index) => {
            step.classList.remove("progress__item--loading", "progress__item--active", "progress__item--error");
        });

        this.steps[stepNumber - 1].classList.add("progress__item--loading");
    }

    setErrorgStep(stepNumber) {
        this.steps[stepNumber - 1].classList.add("progress__item--error");
    }

    addBulkToggleEvent(bulkBtn) {
        bulkBtn.addEventListener("click", () => this.toggleBulkUpload());
    }

    addFileEvents() {
        this._fakeInput?.addEventListener('click', this._handleFakeInputClick, false);
        this._realInput?.addEventListener('change', this._handleRealInputChange, false);
        this._realInput?.addEventListener("cancel", () => {
            this.setActiveStep(3);
        });
        this._removeFilesButton?.addEventListener('click', this._handleRemoveFilesButtonClick, false);
    }

    _handleFakeInputClick = () => {
        if (this._chipContainer.querySelectorAll('.chip').length > 0) {
            this._removeChips();
        }
        this.setCompleteStep(2);
        this.setLoadingStep(3);
        if (this.fileProductQuantity) {
            this.fileProductQuantity.classList.remove("quantity-available", "quantity-not-available");
        }
        this._realInput.click();
    }

    _handleRealInputChange = (e) => {
        this.disableFileInput();
        if (this._realInput.files.length > 0) {
            this._toggleNoFile();
            [...this._realInput.files].forEach(file => {
                const name = file.name;
                const randomId = (Math.random() * 0xFFFFFF << 0).toString(16);
                const id = `chip-${randomId}`;
                const chipTemplate = `<span id="${id}" class="chip">
                                        <span class="chip__text">${name}</span>
                                    </span>`;
                this._chipContainer.insertAdjacentHTML('afterbegin', chipTemplate);
                const chip = this._chipContainer.querySelector(`#${id}`);
                const filesObj = { name, id, chip };
                this._files.push(filesObj);
            })
            
            this.handleFile(e);
        }
    
        this.setCompleteStep(3);
        this.setLoadingStep(4);
    }

    disableFileInput() {
        this._fakeInput?.setAttribute("disabled", true);
        this._realInput?.setAttribute("disabled", true);
    }

    enableFileInput() {
        this._fakeInput?.removeAttribute("disabled");
        this._realInput?.removeAttribute("disabled");
    }

    _handleRemoveFilesButtonClick = (e) => {
        if (this.availableVariantQuantity > 0) this.enableFileInput();
        if (this._realInput?.files.length) {
            this._removeChips();
        }
        this.updateVerificationButton('default');
    }

    _removeChips = () => {
        this.setCompleteStep(2)
        this.setActiveStep(3);
        this.bulkFileATCButton?.setAttribute("disabled", true);
        const chips = this._chipContainer?.querySelectorAll('.chip') || [];
        this._toggleNoFile();
        chips.forEach(chip => chip.remove());
        this._files = [];
        if (this._realInput) {
            this._realInput.value = '';
        }
    };

    _toggleNoFile = () => {
        if (this._noFile) {
            this._noFile.hidden = !this._noFile.hidden;
        }
        if (this._removeFilesButton) {
            this._removeFilesButton.hidden = !this._removeFilesButton.hidden;
        }
    }
    setupVerificationButton() {
        this.verifyNowBtn = this.querySelector('.verify-now-btn');
        if (this.verifyNowBtn) {
            this.verifyNowBtnLabel = this.verifyNowBtn.textContent;
        }
    }

    handleFile(event) {
        const file = event.target.files[0];
        if (!file) return;

        const allowedTypes = [
            "text/csv",
        ];

        if (!allowedTypes.includes(file.type)) {
            this.setCompleteStep(2);
            this.setErrorgStep(3);
            document.body.querySelector('milton-toast')?.showErrorToast("Invalid file type. Please upload a CSV file.");
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const csvData = e.target.result;

            Papa.parse(csvData, {
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
                complete: (results) => {
                    let validRows = [];
                    let isValidColumn = false;
                    
                    results.data.forEach((item, index) => {
                        isValidColumn = item.hasOwnProperty("Name") && item.Name !== null && item.Name !== undefined;
                        if (!isValidColumn) return;
                        
                        const nameText = String(item.Name).trim();
                        const cleanedText = nameText.replace(/[^a-zA-Z ]/g, "");
                        
                        if (item.Name && nameText === cleanedText && nameText.length >= 1 && nameText.length <= 11) {
                            const cleanItem = {
                                Name: item.Name,
                                'Font Style': (item['Font Style'] || item['FontStyle'] || '').trim(),
                                'Font Pattern': (item['Font Pattern'] || item['FontPattern'] || '').trim(),
                                'Icon': (item['Icon'] || '').trim()
                            };
                            
                            validRows.push(cleanItem);
                        }
                    });

                    const validRowCount = validRows.length;
                    if (this.fileProductQuantity) {
                        this.fileProductQuantity.textContent = validRowCount;
                    }

                    if (validRowCount < 1) {
                        const errorMessage = isValidColumn ? `No valid personalization data found in the CSV file or file is empty` : "Found incorrect column header, re-upload file with 'Name' column header";
                        document.body.querySelector('milton-toast')?.showErrorToast(errorMessage);
                        this._handleRemoveFilesButtonClick();
                        this.setCompleteStep(2);
                        this.setActiveStep(3);
                        this.setErrorgStep(4);
                        return;
                    }

                    if (validRowCount > this.availableVariantQuantity || validRowCount > 500) {
                        document.body.querySelector('milton-toast')?.showErrorToast(`You can add up to ${this.availableVariantQuantity} of this product to your cart.`);
                        this._handleRemoveFilesButtonClick();
                        this.setCompleteStep(2);
                        this.setActiveStep(3);
                        this.setErrorgStep(4);
                        if (this.fileProductQuantity) {
                            this.fileProductQuantity.classList.remove("quantity-available");
                            this.fileProductQuantity.classList.add("quantity-not-available");
                        }
                        return;
                    }
                    
                    this.bulkFileQuantity = validRowCount;
                    this.parsedCSVData = validRows;
                    
                    if (this.fileProductQuantity) {
                        this.fileProductQuantity.classList.remove("quantity-not-available");
                        this.fileProductQuantity.classList.add("quantity-available");
                    }

                    setTimeout(() => {
                        this.setCompleteStep(4);
                        this.setActiveStep(5);
                        
                        if (this.previewUploadedBtn) {
                            this.previewUploadedBtn.style.display = 'block';
                        }
                        
                        this.bulkFileATCButton?.removeAttribute("disabled");
                    }, 400);
                },
                error: (error) => {
                    this.setActiveStep(3);
                    this.setErrorgStep(4);
                    document.body.querySelector('milton-toast')?.showErrorToast("Error parsing CSV file. Please check the file format.");
                }
            });
        };

        reader.readAsText(file);
    }
    
    handleFile(event) {
        const file = event.target.files[0];
        if (!file) return;
    
        const allowedTypes = [
            "text/csv",
        ];
    
        if (!allowedTypes.includes(file.type)) {
            this.setCompleteStep(2);
            this.setErrorgStep(3);
            this.updateVerificationButton('error', "Invalid file type");
            document.body.querySelector('milton-toast')?.showErrorToast("Invalid file type. Please upload a CSV file.");
            return;
        }
    
        this.updateVerificationButton('verifying', "Verifying...");
    
        const reader = new FileReader();
        reader.onload = (e) => {
            const csvData = e.target.result;
    
            Papa.parse(csvData, {
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
                complete: (results) => {
                    let validRows = [];
                    let isValidColumn = false;
                    
                    results.data.forEach((item, index) => {
                        isValidColumn = item.hasOwnProperty("Name") && item.Name !== null && item.Name !== undefined;
                        if (!isValidColumn) return;
                        
                        const nameText = String(item.Name).trim();
                        const cleanedText = nameText.replace(/[^a-zA-Z ]/g, "");
                        
                        if (item.Name && nameText === cleanedText && nameText.length >= 1 && nameText.length <= 11) {
                            const cleanItem = {
                                Name: item.Name,
                                'Font Style': (item['Font Style'] || item['FontStyle'] || '').trim(),
                                'Font Pattern': (item['Font Pattern'] || item['FontPattern'] || '').trim(),
                                'Icon': (item['Icon'] || '').trim()
                            };
                            
                            validRows.push(cleanItem);
                        }
                    });
    
                    const validRowCount = validRows.length;
                    if (this.fileProductQuantity) {
                        this.fileProductQuantity.textContent = validRowCount;
                    }
    
                    if (validRowCount < 1) {
                        const errorMessage = isValidColumn ? `No valid personalization data found in the CSV file or file is empty` : "Found incorrect column header, re-upload file with 'Name' column header";
                        
                        this.updateVerificationButton('error', "Verification Failed");
                        document.body.querySelector('milton-toast')?.showErrorToast(errorMessage);
                        this._handleRemoveFilesButtonClick();
                        this.setCompleteStep(2);
                        this.setActiveStep(3);
                        this.setErrorgStep(4);
                        return;
                    }
    
                    if (validRowCount > this.availableVariantQuantity || validRowCount > 500) {
                        this.updateVerificationButton('error', "Quantity Exceeded");
                        document.body.querySelector('milton-toast')?.showErrorToast(`You can add up to ${this.availableVariantQuantity} of this product to your cart.`);
                        this._handleRemoveFilesButtonClick();
                        this.setCompleteStep(2);
                        this.setActiveStep(3);
                        this.setErrorgStep(4);
                        if (this.fileProductQuantity) {
                            this.fileProductQuantity.classList.remove("quantity-available");
                            this.fileProductQuantity.classList.add("quantity-not-available");
                        }
                        return;
                    }
                    
                    this.bulkFileQuantity = validRowCount;
                    this.parsedCSVData = validRows;
                    
                    if (this.fileProductQuantity) {
                        this.fileProductQuantity.classList.remove("quantity-not-available");
                        this.fileProductQuantity.classList.add("quantity-available");
                    }
    
                    this.updateVerificationButton('verified', "Verified");
    
                    setTimeout(() => {
                        this.setCompleteStep(4);
                        this.setActiveStep(5);
                        
                        if (this.previewUploadedBtn) {
                            this.previewUploadedBtn.style.display = 'block';
                        }
                        
                        this.bulkFileATCButton?.removeAttribute("disabled");
                    }, 400);
                },
                error: (error) => {
                    this.updateVerificationButton('error', "Verification Failed");
                    this.setActiveStep(3);
                    this.setErrorgStep(4);
                    document.body.querySelector('milton-toast')?.showErrorToast("Error parsing CSV file. Please check the file format.");
                }
            });
        };
    
        reader.readAsText(file);
    }

    updateVerificationButton(state, text = null) {
        if (!this.verifyNowBtn) return;
        
        this.verifyNowBtn.classList.remove('verifying', 'verified', 'error');
        
        switch(state) {
            case 'verifying':
                this.verifyNowBtn.classList.add('verifying');
                this.verifyNowBtn.textContent = text || "Verifying...";
                this.verifyNowBtn.disabled = true;
                break;
            case 'verified':
                this.verifyNowBtn.classList.add('verified');
                this.verifyNowBtn.textContent = text || "Verified";
                this.verifyNowBtn.disabled = false;
                break;
            case 'error':
                this.verifyNowBtn.classList.add('error');
                this.verifyNowBtn.textContent = text || "Verification Failed";
                this.verifyNowBtn.disabled = false;
                break;
            default:
                // Reset to default state
                this.verifyNowBtn.textContent = this.verifyNowBtnLabel || "Verify Now";
                this.verifyNowBtn.disabled = false;
        }
    }

    deleteProductByLabel(tabLabel) {        
        // Find the exact product to delete
        const productIndexToDelete = parseInt(tabLabel) - 1;
        
        // Validate the index
        if (productIndexToDelete < 0 || productIndexToDelete >= this.products.length) {
            return;
        }
        
        // If we're trying to delete the only product, just reset it instead
        if (this.products.length === 1) {
            this.resetProduct(this.products[0].product);
            return;
        }
        
        // Get the product to delete
        const productToDelete = this.products[productIndexToDelete];
        
        // 1. Remove the product DOM element
        if (productToDelete.product && productToDelete.product.parentNode) {
            productToDelete.product.remove();
        }
        
        // 2. Remove all tab instances with this label
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        allTabs.forEach(tab => {
            const labelElement = tab.querySelector('.tab--label');
            if (labelElement && labelElement.textContent === tabLabel) {
                tab.remove();
            }
        });
        
        // 3. Remove from products array
        this.products.splice(productIndexToDelete, 1);
        
        
        // 4. RE-NUMBER ALL REMAINING PRODUCTS
        this.renumberAllProductsAndTabs();
        
        // 5. Determine which product to show next
        const nextIndex = Math.min(productIndexToDelete, this.products.length - 1);
        
        // 6. Show the next product
        this.showProductByIndex(nextIndex);
        
        // 7. Update UI
        this.updateAllDropdownButtons();
        this.validateAllCustomizers();
        this.bulkProductQuantity = this.products.length;
        
        this.scrollToTop();
    }
    // NEW METHOD: Reset a product (instead of deleting when it's the only one)
    resetProduct(product) {
        if (!product) return;
        
        
        // Reset customization data
        if (product.savedCustomizationData) {
            product.savedCustomizationData = {
                "personalized-text": "",
                "text-orientation": "horizontal",
                "font-style": "",
                "font-style-label": "",
                "font-pattern": "",
                "font-pattern-label": "",
                "icon": "",
                "icon-label": "",
            };
        }
        
        // Reset form inputs
        const textInput = product.querySelector('#personalizedText');
        if (textInput) textInput.value = "";
        
        const optionInputs = product.querySelectorAll('input[name="font-style"], input[name="font-pattern"], input[name="icon"]');
        optionInputs.forEach(input => {
            input.checked = false;
            // Remove selected classes
            const label = input.closest('label');
            if (label) {
                label.classList.remove('font-style-option-selected', 'font-pattern-option-selected', 'icon-option-selected');
            }
        });
        
        // Reset to first step
        this.resetToFirstStep(product);
        
        // Clear canvases but keep them visible
        this.clearProductCanvases(product);
        
        // Update button state
        this.updateBulkNextButtonState(product);
        
    }

// NEW METHOD: Clear product canvases but keep them visible
    clearProductCanvases(product) {
        if (!product) return;
        
        const canvases = product.querySelectorAll('canvas');
        canvases.forEach(canvas => {
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                
                // Draw blank background but KEEP canvas visible
                if (this.blankBottleImage && this.blankBottleImage.complete) {
                    ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
                } else {
                    ctx.fillStyle = '#f8f9fa';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            
            // Ensure canvas is visible
            canvas.style.display = 'block';
            canvas.style.visibility = 'visible';
            canvas.style.opacity = '1';
        });
    }

// NEW METHOD: Simple renumbering of all products and tabs
    renumberAllProductsAndTabs() {
        
        // Update products array with new sequential numbering
        this.products.forEach((productObj, index) => {
            const newLabel = `${index + 1}`;
            
            // Update the product object
            productObj.index = index;
            
            // Create a new tab with the correct label
            const newTab = this.createProductTab(index + 1);
            productObj.tab = newTab;
            
        });
        
        // Now rebuild ALL tab containers
        this.simpleRebuildTabContainers();
    }

// NEW METHOD: Simple tab container rebuilding
    simpleRebuildTabContainers() {
        // Find ALL tab containers
        const allTabContainers = this.querySelectorAll('.product-tabs__container');
        
        // Clear and rebuild each container
        allTabContainers.forEach(container => {
            // Clear container
            container.innerHTML = '';
            
            // Add tabs for all products in correct order
            this.products.forEach((productObj, index) => {
                const tab = productObj.tab.cloneNode(true);
                
                // Make sure label is correct
                const labelElement = tab.querySelector('.tab--label');
                labelElement.textContent = `${index + 1}`;
                
                // Re-attach events
                this.attachSimpleTabEvents(tab, index);
                
                // Add to container
                container.appendChild(tab);
                
                // Update the reference in products array
                productObj.tab = tab;
            });
        });
    }

// NEW METHOD: Simple tab event attachment
    attachSimpleTabEvents(tab, productIndex) {
        // Handle tab click (switching products)
        tab.addEventListener('click', (e) => {
            if (e.target.closest('.delete-svg__wrapper')) {
                return; // Let delete handler handle this
            }
            
            e.preventDefault();
            e.stopPropagation();
            
            this.showProductByIndex(productIndex);
        });
        
        // Handle delete button click
        const deleteBtn = tab.querySelector('.delete-svg__wrapper');
        if (deleteBtn) {
            deleteBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const label = tab.querySelector('.tab--label').textContent;
                this.deleteProductByLabel(label);
            });
        }
    }

    // NEW METHOD: Show product by index
    showProductByIndex(index) {
        if (index < 0 || index >= this.products.length) {
            index = 0; // Default to first product
        }
        
        const productToShow = this.products[index];
        const labelToShow = `${index + 1}`;
        
        // Hide all products
        this.products.forEach((productObj, i) => {
            const product = productObj.product;
            if (i === index) {
                product.classList.remove('hidden-block', 'slide-right', 'stack-down');
                product.classList.add('inview');
                
                // Ensure canvases are visible
                this.ensureCanvasesVisible(product);
            } else {
                product.classList.remove('inview');
                product.classList.add('hidden-block');
            }
        });
        
        // Activate the correct tab
        this.simpleActivateTab(labelToShow);
        
        // Update current index
        this.currentProductIndex = index;
        this.lastActiveTab = productToShow.tab;
        this.lastActiveProduct = productToShow.product;
        
        // Setup scroll for this product
        this.setupScrollNavigationForProduct(productToShow.product);
    }

    // NEW METHOD: Simple tab activation
    simpleActivateTab(label) {
        const allTabs = this.querySelectorAll('.products-switcher--tab');
        
        allTabs.forEach(tab => {
            const tabLabel = tab.querySelector('.tab--label').textContent;
            if (tabLabel === label) {
                tab.classList.add('active');
                if (this.products.length >= 2) {
                    tab.querySelector('.delete-svg__wrapper')?.classList.add('active');
                }
            } else {
                tab.classList.remove('active');
                tab.querySelector('.delete-svg__wrapper')?.classList.remove('active');
            }
        });
    }

    // NEW METHOD: Ensure canvases are visible
    ensureCanvasesVisible(product) {
        if (!product) return;
        
        const canvases = product.querySelectorAll('canvas');
        canvases.forEach(canvas => {
            // Remove any display: none
            canvas.style.display = 'block';
            canvas.style.visibility = 'visible';
            canvas.style.opacity = '1';
        });
    }
    updateClasses(goingToIndex) {
        this.products.forEach((item, index) => {
            const product = item.product;
            if (index !== goingToIndex) {
                product.style.visibility = "hidden";
                if (index < goingToIndex) {
                    product.classList.remove("inview", "slide-right");
                    product.classList.add("stack-down", "hidden-block");
                } else if (index > goingToIndex) {
                    product.classList.remove("inview", "stack-down");
                    product.classList.add("slide-right", "hidden-block");
                }
                setTimeout(() => {
                    product.removeAttribute("style");
                }, 800);
            } else {
                product.classList.remove("stack-down", "slide-right", "hidden-block");
                product.classList.add("inview");
            }
        });
    }
    
    initializeTabsForAllStepsInAllProducts() {
        
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            
            const steps = product.querySelectorAll('.personalization-step');
            
            steps.forEach(step => {
                const stepType = step.dataset.step;
                
                const desktopTabsContainer = step.querySelector('.desktop-product-tabs-container .product-tabs__container');
                const mobileTabsContainer = step.querySelector('.mobile-product-tabs-container .product-tabs__container');
                
                if (desktopTabsContainer) {
                    desktopTabsContainer.innerHTML = '';
                    this.products.forEach((prodObj, prodIndex) => {
                        const desktopTab = this.createProductTab(prodIndex + 1);
                        desktopTabsContainer.appendChild(desktopTab);
                        this.attachTabEvents(desktopTab);
                        
                        if (prodIndex === index) {
                            prodObj.tab = desktopTab;
                        }
                    });
                }
                
                if (mobileTabsContainer) {
                    mobileTabsContainer.innerHTML = '';
                    this.products.forEach((prodObj, prodIndex) => {
                        const mobileTab = this.createProductTab(prodIndex + 1);
                        mobileTabsContainer.appendChild(mobileTab);
                        this.attachTabEvents(mobileTab);
                    });
                }
            });
        });
        
        if (this.products.length > 0) {
            const currentTabLabel = this.products[this.currentProductIndex]?.tab.querySelector('.tab--label').textContent;
            if (currentTabLabel) {
                this.activateTabInAllStepsOfAllProducts(currentTabLabel);
            }
        }
        
    }
    
    initializeMainDesktopTabs() {        
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            
            const mainDesktopTabsContainer = product.querySelector('.desktop-layout-container .desktop-product-tabs-container .product-tabs__container');
            
            if (mainDesktopTabsContainer) {
                mainDesktopTabsContainer.innerHTML = '';
                this.products.forEach((prodObj, prodIndex) => {
                    const desktopTab = this.createProductTab(prodIndex + 1);
                    mainDesktopTabsContainer.appendChild(desktopTab);
                    this.attachTabEvents(desktopTab);
                });
            } else {
                console.log(`❌ No main desktop tabs container found for product ${index + 1}`);
            }
        });
        
        if (this.products.length > 0) {
            const currentTabLabel = this.products[this.currentProductIndex]?.tab.querySelector('.tab--label').textContent;
            if (currentTabLabel) {
                this.activateTabInMainDesktopLayout(currentTabLabel);
            }
        }
    }

    activateTabInMainDesktopLayout(tabLabel) {        
        this.products.forEach(productObj => {
            const product = productObj.product;
            const mainDesktopTabsContainer = product.querySelector('.desktop-layout-container .desktop-product-tabs-container .product-tabs__container');
            
            if (mainDesktopTabsContainer) {
                const allTabs = mainDesktopTabsContainer.querySelectorAll('.products-switcher--tab');
                
                allTabs.forEach(tab => {
                    const labelElement = tab.querySelector('.tab--label');
                    if (labelElement) {
                        if (labelElement.textContent === tabLabel) {
                            tab.classList.add("active");
                            if (this.products.length >= 2) {
                                tab.querySelector(".delete-svg__wrapper")?.classList.add("active");
                            }
                        } else {
                            tab.classList.remove("active");
                            tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
                        }
                    }
                });
            }
        });
    }

    activateTabInAllStepsOfAllProducts(tabLabel) {        
        this.products.forEach(productObj => {
            const product = productObj.product;
            
            const mainDesktopTabsContainer = product.querySelector('.desktop-layout-container .desktop-product-tabs-container .product-tabs__container');
            if (mainDesktopTabsContainer) {
                const allTabs = mainDesktopTabsContainer.querySelectorAll('.products-switcher--tab');
                allTabs.forEach(tab => {
                    const labelElement = tab.querySelector('.tab--label');
                    if (labelElement) {
                        if (labelElement.textContent === tabLabel) {
                            tab.classList.add("active");
                            if (this.products.length >= 2) {
                                tab.querySelector(".delete-svg__wrapper")?.classList.add("active");
                            }
                        } else {
                            tab.classList.remove("active");
                            tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
                        }
                    }
                });
            }
            
            const steps = product.querySelectorAll('.personalization-step');
            steps.forEach(step => {
                const allTabs = step.querySelectorAll('.products-switcher--tab');
                allTabs.forEach(tab => {
                    const labelElement = tab.querySelector('.tab--label');
                    if (labelElement) {
                        if (labelElement.textContent === tabLabel) {
                            tab.classList.add("active");
                            if (this.products.length >= 2) {
                                tab.querySelector(".delete-svg__wrapper")?.classList.add("active");
                            }
                        } else {
                            tab.classList.remove("active");
                            tab.querySelector(".delete-svg__wrapper")?.classList.remove("active");
                        }
                    }
                });
            });
            this.updateAllProductsCompletionStatus();
        });
    }

    toggleBulkUpload() {
        if (!this.bulkSheetContainer.classList.contains('hidden-block')) {
            this.showManualBulkUI();
        } else {
            this.resetUploadFileUI();
            this.showUploadFileUI();
        }
    }
    
    showManualBulkUI() {
        if (this.bulkSheetContainer) {
            this.bulkSheetContainer.classList.add('hidden-block');
        }
        if (this.bulkUploadPreviewContainer) {
            this.bulkUploadPreviewContainer.classList.add('hidden-block');
        }
        if (this.bulkPreviewContainer) {
            this.bulkPreviewContainer.classList.add('hidden-block');
        }
        
        if (this.bulkProductsWrapper) {
            this.bulkProductsWrapper.classList.remove('hidden-block');
            this.bulkProductsWrapper.classList.remove('stack-down');
            this.bulkProductsWrapper.classList.add('inview');
        }
        
        // Reset all products to their initial state
        this.products.forEach(productObj => {
            const product = productObj.product;
            
            // Reset customization data
            if (product.savedCustomizationData) {
                product.savedCustomizationData = {
                    "personalized-text": "",
                    "text-orientation": "horizontal", 
                    "font-style": "",
                    "font-style-label": "",
                    "font-pattern": "",
                    "font-pattern-label": "",
                    "icon": "",
                    "icon-label": "",
                };
            }
            
            // Reset text input
            const textInput = product.querySelector('#personalizedText');
            if (textInput) {
                textInput.value = "";
            }
            
            // Reset option inputs
            const optionInputs = product.querySelectorAll('input[name="font-style"], input[name="font-pattern"], input[name="icon"]');
            optionInputs.forEach(input => {
                input.checked = false;
            });
            
            // Reset to first step
            this.resetToFirstStep(product);
            this.resetManualBulkUI();
            
            // Reset product quantity to 1
            this.setProductQuantity(product, 1);
            
            // Clear canvases
            const canvases = product.querySelectorAll('canvas');
            canvases.forEach(canvas => {
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    const bottleImage = this.getBottleImageForProduct(product);
                    
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    if (bottleImage && bottleImage.complete) {
                        this.processCanvasImage(canvas, ctx, bottleImage);
                    } else {
                        ctx.fillStyle = '#f8f9fa';
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                }
            });
            
            // Update button state
            this.updateBulkNextButtonState(product);
        });
        
        // Reset the product quantity dropdown to show 1 product
        this.handleProductQuantityChange(1, false);
        
        this.updateAllProductsCompletionStatus();
        this.validateAllCustomizers();
        
        // Reset to first product
        this.currentProductIndex = 0;
        this.isPreviewMode = false;
        
        if (this.products.length > 0) {
            this.switchProduct(this.products[0].tab);
        }
        
        this.scrollToTop();
    }
    ensureInitialCanvasRender() {        
        // Ensure we have region data
        this.initializeCustomizationRegionData();
        
        this.products.forEach((productObj, index) => {
            const product = productObj.product;
            
            // Get current text from input or saved data
            const textInput = product.querySelector('#personalizedText');
            const currentText = textInput?.value?.trim() || product.savedCustomizationData?.["personalized-text"] || "";
            const fontPattern = product.savedCustomizationData?.["font-pattern"] || "";           
            
            // Force initial canvas setup with BOTH image AND text
            const canvases = [
                product.querySelector('#mainPersonalizationCanvas'),
                product.querySelector('#personalizationCanvas'),
                product.querySelector('#personalizationCanvasFontStyle'), 
                product.querySelector('#personalizationCanvasFontPattern'),
                product.querySelector('#personalizationCanvasIcon'),
                product.querySelector('#personalizationCanvasPreview')
            ];
            
            canvases.forEach(canvas => {
                if (canvas) {
                    // Ensure canvas has proper dimensions
                    if (canvas.width === 0 || canvas.height === 0) {
                        canvas.width = 3000;
                        canvas.height = 3000;
                    }
                    
                    // Use the main rendering method that draws BOTH image and text
                    this.renderBulkCanvasWithTextAndPattern(product, canvas, currentText, fontPattern);
                }
            });
            
            // Ensure text is saved in customization data
            if (currentText && (!product.savedCustomizationData || product.savedCustomizationData["personalized-text"] !== currentText)) {
                if (!product.savedCustomizationData) {
                    product.savedCustomizationData = {};
                }
                product.savedCustomizationData["personalized-text"] = currentText;
            }
        });
    }
    // Add this method to BulkPersonalization to properly handle variant changes
    updateVariantForBulk(variantId) {
        if (!variantId || variantId === this.variantID) return;
        
        this.variantID = variantId;
        
        // Get the image URL for this variant
        const variantsImgScript = document.body.querySelector("#variantPersonalizationImage");
        if (!variantsImgScript) {
            console.error('❌ Variant image script not found');
            return;
        }
        
        const variantsPersonalizationImages = JSON.parse(variantsImgScript.textContent || '{}');
        const imageUrl = variantsPersonalizationImages[variantId];
        
        if (!imageUrl) {
            console.error(`❌ No image found for variant ${variantId}`);
            return;
        }
        
        // Create a new image
        const newProductImg = new Image();
        newProductImg.crossOrigin = "anonymous";
        newProductImg.src = imageUrl;
        
        newProductImg.onload = () => {
            
            // Update the blank bottle image
            this.blankBottleImage = newProductImg;
            
            // Update each product's canvases
            this.products.forEach((productObj, index) => {
                const product = productObj.product;
                if (product) {
                    // Update the variant ID in the product customizer
                    product.variantId = variantId;
                    
                    // Update the product image reference
                    if (product.productImg) {
                        product.productImg.src = imageUrl;
                    }
                    
                    // Clear and redraw all canvases
                    this.redrawAllCanvasesForProduct(product, newProductImg);
                }
            });
        };
        
        newProductImg.onerror = () => {
            console.error(`❌ Bulk: Failed to load image for variant ${variantId}`);
        };
    }

// Add this method to redraw all canvases for a product
redrawAllCanvasesForProduct(product, productImg) {
    if (!product || !productImg) return;
    
    const canvases = [
        product.querySelector('#mainPersonalizationCanvas'),
        product.querySelector('#personalizationCanvas'),
        product.querySelector('#personalizationCanvasFontStyle'),
        product.querySelector('#personalizationCanvasFontPattern'),
        product.querySelector('#personalizationCanvasIcon'),
        product.querySelector('#personalizationCanvasPreview')
    ];
    
    const customizationData = product.savedCustomizationData || {};
    const text = customizationData["personalized-text"] || "";
    const fontPattern = customizationData["font-pattern"] || "";
    const orientation = customizationData["text-orientation"] || "horizontal";
    const fontStyle = customizationData["font-style"] || "";
    const iconUrl = customizationData["icon"] || "";
    
    canvases.forEach(canvas => {
        if (canvas) {
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            
            // Clear canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            
            // Draw the new product image
            this.processCanvasImage(canvas, ctx, productImg);
            
            // Draw text/icon if exists
            if (text || iconUrl) {
                this.drawTextAndIconOnCanvas(ctx, canvas, text, fontPattern, orientation, fontStyle, iconUrl);
            }
        }
    });
}
resetManualBulkUI() {
    // Remove all products except the first one
    while (this.products.length > 1) {
        this.deleteProductByLabel(this.products[this.products.length - 1].tab.querySelector('.tab--label').textContent);
    }
    
    // Reset the first product
    if (this.products.length > 0) {
        const firstProduct = this.products[0].product;
        
        // Reset customization data
        if (firstProduct.savedCustomizationData) {
            firstProduct.savedCustomizationData = {
                "personalized-text": "",
                "text-orientation": "horizontal", 
                "font-style": "",
                "font-style-label": "",
                "font-pattern": "",
                "font-pattern-label": "",
                "icon": "",
                "icon-label": "",
            };
        }
        
        // Reset UI elements
        const textInput = firstProduct.querySelector('#personalizedText');
        if (textInput) textInput.value = "";
        
        const optionInputs = firstProduct.querySelectorAll('input[name="font-style"], input[name="font-pattern"], input[name="icon"]');
        optionInputs.forEach(input => input.checked = false);
        
        this.setProductQuantity(firstProduct, 1);
        this.resetToFirstStep(firstProduct);
        
        // Clear canvases
        const canvases = firstProduct.querySelectorAll('canvas');
        canvases.forEach(canvas => {
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (this.blankBottleImage && this.blankBottleImage.complete) {
                    ctx.drawImage(this.blankBottleImage, 0, 0, canvas.width, canvas.height);
                }
            }
        });
        
        // Update button state
        this.updateBulkNextButtonState(firstProduct);
    }
    
    // Update dropdown to show "Select Quantity" for 1 product
    const dropdownButtons = this.querySelectorAll('.select-dropdown__button .selected-product--quantity');
    dropdownButtons.forEach(button => {
        button.textContent = 'Select Quantity';
    });

    if (this.bulkPreviewContainer) {
        this.bulkPreviewContainer.classList.add('hidden-block');
    }
    
    this.updateAllProductsCompletionStatus();
    this.validateAllCustomizers();
}
    resetUploadFileUI() {
        this.parsedCSVData = [];
        this.bulkFileQuantity = 0;
        
        if (this._realInput?.files.length) {
            this._removeChips();
        }
        this.updateVerificationButton('default');
        this.setCompleteStep(0);
        this.setActiveStep(1);
        
        if (this.bulkUploadPreviewContainer) {
            this.bulkUploadPreviewContainer.classList.add('hidden-block');
        }
        
        if (this.previewUploadedBtn) {
            this.previewUploadedBtn.style.display = 'none';
        }
        
        if (this.fileProductQuantity) {
            this.fileProductQuantity.textContent = '0';
            this.fileProductQuantity.classList.remove("quantity-available", "quantity-not-available");
        }
        if (this.bulkFileATCButton) {
            this.bulkFileATCButton.setAttribute("disabled", true);
        }
        
        if (this.availableVariantQuantity > 0) {
            this.enableFileInput();
        }
    }
        
    showUploadFileUI() {
        this.resetUploadFileUI();
        
        if (this.bulkProductsWrapper) {
            this.bulkProductsWrapper.classList.remove('inview');
            this.bulkProductsWrapper.classList.add('hidden-block');
        }
        if (this.bulkPreviewContainer) {
            this.bulkPreviewContainer.classList.add('hidden-block');
        }
        if (this.bulkSheetContainer) {
            this.bulkSheetContainer.classList.remove('hidden-block');
            this.bulkSheetContainer.classList.remove('slide-left');
            this.bulkSheetContainer.classList.add('inview');
        }
        
        this.scrollToTop();
    }
}

customElements.define("bulk-personalization", BulkPersonalization);
window.cartDataJSON = null;
let isFetchingCartData = false;
let cartDataPromise = null;
const fetchCartJSON = async () => {
    if (isFetchingCartData) return cartDataPromise;
    isFetchingCartData = true; 
    cartDataPromise = (async () => {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) throw new Error('Failed to fetch cart data');
            const data = await response.json();
            window.cartDataJSON = data;
            document.dispatchEvent(new CustomEvent('cart:JSONReady'));
        } catch (error) {
            console.error('Error fetching cart data:', error);
            window.cartDataJSON = {};
        } finally {
            isFetchingCartData = false;
        }
    })();
    return cartDataPromise;
};
const ensureCartData = async () => {
    return window.cartDataJSON || await fetchCartJSON();
};
fetchCartJSON();
document.addEventListener('cart:updated', fetchCartJSON); 

/* ===== Icon Group Filter Tabs ===== */
(function () {
  /**
   * Filter icon options within the nearest .customizer-options__container
   * when a .icon-group-tab button is clicked.
   */
  function applyIconGroupFilter(tabButton) {
    const selectedGroup = tabButton.dataset.group;

    // Find the container that holds both the tabs bar and the icon grid
    const tabsBar = tabButton.closest('.icon-group-tabs');
    if (!tabsBar) return;

    // Mark the clicked tab as active
    tabsBar.querySelectorAll('.icon-group-tab').forEach(function (btn) {
      btn.classList.toggle('active', btn === tabButton);
    });

    // Walk up to the customizer-options__container then find all icon options
    const optionsContainer = tabsBar.closest('.customizer-options__container');
    if (!optionsContainer) return;

    const iconOptions = optionsContainer.querySelectorAll('.customizer-icon__option[data-icon-group]');
    iconOptions.forEach(function (label) {
      if (selectedGroup === 'all') {
        label.classList.remove('hidden-icon');
      } else {
        const matches = label.dataset.iconGroup === selectedGroup;
        label.classList.toggle('hidden-icon', !matches);
      }
    });
  }

  // Event delegation – works for dynamically loaded modals
  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.icon-group-tab');
    if (tab) {
      e.preventDefault();
      applyIconGroupFilter(tab);
    }
  });
})();
